import { isObservableMap, isObservableSet, isObservableArray, createAtom, runInAction, action, observable, computed, untracked, when, isAction, isObservableObject, remove, reaction, set, intercept, observe, isObservable, toJS, values, get, has, keys, entries } from 'mobx';
import uuidv4 from 'uuid/v4';
import { __decorate } from 'tslib';
import fastDeepEqual from 'fast-deep-equal/es6';

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/**
 * A mobx-keystone error.
 */

var MobxKeystoneError =
/*#__PURE__*/
function (_Error) {
  _inheritsLoose(MobxKeystoneError, _Error);

  function MobxKeystoneError(msg) {
    var _this;

    _this = _Error.call(this, msg) || this; // Set the prototype explicitly.

    Object.setPrototypeOf(_assertThisInitialized(_this), MobxKeystoneError.prototype);
    return _this;
  }

  return MobxKeystoneError;
}(
/*#__PURE__*/
_wrapNativeSuper(Error));
/**
 * @ignore
 * @internal
 */

function failure(msg) {
  return new MobxKeystoneError(msg);
}
var writableHiddenPropDescriptor = {
  enumerable: false,
  writable: true,
  configurable: false,
  value: undefined
};
/**
 * @ignore
 * @internal
 */

function addHiddenProp(object, propName, value, writable) {
  if (writable === void 0) {
    writable = true;
  }

  if (writable) {
    Object.defineProperty(object, propName, writableHiddenPropDescriptor);
    object[propName] = value;
  } else {
    Object.defineProperty(object, propName, {
      enumerable: false,
      writable: writable,
      configurable: true,
      value: value
    });
  }
}
/**
 * @ignore
 * @internal
 */

function makePropReadonly(object, propName, enumerable) {
  var propDesc = Object.getOwnPropertyDescriptor(object, propName);

  if (propDesc) {
    propDesc.enumerable = enumerable;

    if (propDesc.get) {
      delete propDesc.set;
    } else {
      propDesc.writable = false;
    }

    Object.defineProperty(object, propName, propDesc);
  }
}
/**
 * @ignore
 * @internal
 */

function isPlainObject(value) {
  if (!isObject(value)) return false;
  var proto = Object.getPrototypeOf(value);
  return proto === Object.prototype || proto === null;
}
/**
 * @ignore
 * @internal
 */

function isObject(value) {
  return value !== null && typeof value === "object";
}
/**
 * @ignore
 * @internal
 */

function isPrimitive(value) {
  switch (typeof value) {
    case "number":
    case "string":
    case "boolean":
    case "undefined":
    case "bigint":
      return true;
  }

  return value === null;
}
/**
 * @ignore
 * @internal
 */

function debugFreeze(value) {
  if (inDevMode()) {
    Object.freeze(value);
  }
}
/**
 * @ignore
 * @internal
 */

function deleteFromArray(array, value) {
  var index = array.indexOf(value);

  if (index >= 0) {
    array.splice(index, 1);
    return true;
  }

  return false;
}
/**
 * @ignore
 * @internal
 */

function isMap(val) {
  return val instanceof Map || isObservableMap(val);
}
/**
 * @ignore
 * @internal
 */

function isSet(val) {
  return val instanceof Set || isObservableSet(val);
}
/**
 * @ignore
 * @internal
 */

function isArray(val) {
  return Array.isArray(val) || isObservableArray(val);
}
/**
 * @ignore
 * @internal
 */

function inDevMode() {
  return process.env.NODE_ENV !== "production";
}
/**
 * @ignore
 * @internal
 */

function assertIsObject(value, argName) {
  if (!isObject(value)) {
    throw failure(argName + " must be an object");
  }
}
/**
 * @ignore
 * @internal
 */

function assertIsFunction(value, argName) {
  if (typeof value !== "function") {
    throw failure(argName + " must be a function");
  }
}
/**
 * @ignore
 * @internal
 */

function assertIsPrimitive(value, argName) {
  if (!isPrimitive(value)) {
    throw failure(argName + " must be a primitive");
  }
}
/**
 * @ignore
 * @internal
 */

function decorateWrapMethodOrField(decoratorName, data, wrap) {
  var target = data.target,
      propertyKey = data.propertyKey,
      baseDescriptor = data.baseDescriptor;

  if (baseDescriptor) {
    // method decorator
    if (baseDescriptor.get !== undefined) {
      throw failure("@" + decoratorName + " cannot be used with getters");
    } // babel / typescript
    // @action method() { }


    if (baseDescriptor.value) {
      // typescript
      return {
        enumerable: false,
        writable: true,
        configurable: true,
        value: wrap(data, baseDescriptor.value)
      };
    } // babel only: @action method = () => {}


    var _initializer = baseDescriptor.initializer;
    return {
      enumerable: false,
      configurable: true,
      writable: true,
      initializer: function initializer() {
        // N.B: we can't immediately invoke initializer; this would be wrong
        return wrap(data, _initializer.call(this));
      }
    };
  } else {
    // field decorator
    Object.defineProperty(target, propertyKey, {
      configurable: true,
      enumerable: false,
      get: function get() {
        return undefined;
      },
      set: function set(fn) {
        addHiddenProp(this, propertyKey, wrap(_extends({}, data, {
          target: this
        }), fn));
      }
    });
  }
}
var warningsAlreadyDisplayed =
/*#__PURE__*/
new Set();
/**
 * @ignore
 * @internal
 */

function logWarning(type, msg, uniqueKey) {
  if (uniqueKey) {
    if (warningsAlreadyDisplayed.has(uniqueKey)) {
      return;
    }

    warningsAlreadyDisplayed.add(uniqueKey);
  }

  msg = "[mobx-keystone] " + msg;

  switch (type) {
    case "warn":
      console.warn(msg);
      break;

    case "error":
      console.error(msg);
      break;

    default:
      throw failure("unknown log type - " + type);
  }
}
var notMemoized =
/*#__PURE__*/
Symbol("notMemoized");
/**
 * @ignore
 * @internal
 */

function lateVal(getter) {
  var memoized = notMemoized;

  var fn = function fn() {
    if (memoized === notMemoized) {
      memoized = getter.apply(void 0, arguments);
    }

    return memoized;
  };

  return fn;
}

var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
function toBase64(input) {
  if (typeof global === "object" && typeof global.Buffer === "function") {
    // node
    return Buffer.from(input).toString("base64");
  }

  if (typeof btoa === "function") {
    // browser
    return btoa(input);
  }

  var str = String(input);
  var output = "";

  for ( // initialize result and counter
  var block = 0, charCode, idx = 0, map = chars; // if the next str index does not exist:
  //   change the mapping table to "="
  //   check if d has no fractional digits
  str.charAt(idx | 0) || (map = "=", idx % 1); // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
  output += map.charAt(63 & block >> 8 - idx % 1 * 8)) {
    charCode = str.charCodeAt(idx += 3 / 4);

    if (charCode > 0xff) {
      throw new Error("the string to be encoded contains characters outside of the Latin1 range.");
    }

    block = block << 8 | charCode;
  }

  return output;
}

/**
 * Model auto type-checking mode.
 */

var ModelAutoTypeCheckingMode;

(function (ModelAutoTypeCheckingMode) {
  /**
   * Auto type check models only in dev mode
   */
  ModelAutoTypeCheckingMode["DevModeOnly"] = "devModeOnly";
  /**
   * Auto type check models no matter the current environment
   */

  ModelAutoTypeCheckingMode["AlwaysOn"] = "alwaysOn";
  /**
   * Do not auto type check models no matter the current environment
   */

  ModelAutoTypeCheckingMode["AlwaysOff"] = "alwaysOff";
})(ModelAutoTypeCheckingMode || (ModelAutoTypeCheckingMode = {}));

var localId = 0;
var localBaseId =
/*#__PURE__*/
shortenUuid(
/*#__PURE__*/
uuidv4());

function defaultModelIdGenerator() {
  // we use base 36 for local id since it is short and fast
  var id = localId.toString(36) + "-" + localBaseId;
  localId++;
  return id;
} // defaults


var globalConfig = {
  modelAutoTypeChecking: ModelAutoTypeCheckingMode.DevModeOnly,
  modelIdGenerator: defaultModelIdGenerator
};
/**
 * Partially sets the current global config.
 *
 * @param config Partial object with the new configurations. Options not included in the object won't be changed.
 */

function setGlobalConfig(config) {
  globalConfig = Object.freeze(_extends({}, globalConfig, {}, config));
}
/**
 * Returns the current global config object.
 *
 * @returns
 */

function getGlobalConfig() {
  return globalConfig;
}
/**
 * @ignore
 * @internal
 *
 * Returns if the auto type checking for models is enabled.
 *
 * @returns
 */

function isModelAutoTypeCheckingEnabled() {
  switch (getGlobalConfig().modelAutoTypeChecking) {
    case ModelAutoTypeCheckingMode.DevModeOnly:
      return inDevMode();

    case ModelAutoTypeCheckingMode.AlwaysOff:
      return false;

    case ModelAutoTypeCheckingMode.AlwaysOn:
      return true;

    default:
      throw failure("invalid 'modelAutoTypeChecking' config value - " + globalConfig.modelAutoTypeChecking);
  }
}

function shortenUuid(uuid) {
  // remove non-hex chars
  var hex = uuid.split("-").join(""); // convert to base64

  var hexMatch = hex.match(/\w{2}/g);
  var str = String.fromCharCode.apply(null, hexMatch.map(function (a) {
    return parseInt(a, 16);
  }));
  return toBase64(str);
}

/**
 * @ignore
 */
var noDefaultValue =
/*#__PURE__*/
Symbol("noDefaultValue");
function prop(def) {
  var hasDefaultValue = arguments.length > 0;
  var isDefFn = typeof def === "function";
  return {
    $propValueType: null,
    $propCreationValueType: null,
    $isOptional: null,
    $instanceValueType: null,
    $instanceCreationValueType: null,
    defaultFn: hasDefaultValue && isDefFn ? def : noDefaultValue,
    defaultValue: hasDefaultValue && !isDefFn ? def : noDefaultValue,
    typeChecker: undefined,
    transform: undefined
  };
}

/**
 * Creates a prop transform, useful to transform property data into another kind of data.
 *
 * For example, to transform from a number timestamp into a date:
 * ```ts
 * const asDate = propTransformDecorator({
 *   propToData(prop: number) {
 *     return new Date(prop)
 *   },
 *   dataToProp(data: Date) {
 *     return +data
 *   }
 * })
 *
 * @model("myApp/MyModel")
 * class MyModel extends Model({
 *   timestamp: prop<number>()
 * }) {
 *   @asDate("timestamp")
 *   date!: Date
 * }
 *
 * const date: Date = myModel.date
 * // inside some model action
 * myModel.date = new Date()
 * ```
 *
 * @typename TProp Property value type.
 * @typename TData Data value type.
 * @param transform Transform to apply.
 * @returns A decorator that can be used to decorate model class fields.
 */

function propTransform(transform) {
  var parametrizedDecorator = function parametrizedDecorator(boundPropName) {
    var decorator = function decorator(target, propertyKey) {
      // make the field a getter setter
      Object.defineProperty(target, propertyKey, {
        get: function get() {
          var memoTransform = memoTransformCache.getOrCreateMemoTransform(this, propertyKey, transform);
          return memoTransform.propToData(this.$[boundPropName]);
        },
        set: function set(value) {
          var memoTransform = memoTransformCache.getOrCreateMemoTransform(this, propertyKey, transform);
          this.$[boundPropName] = memoTransform.dataToProp(value);
          return true;
        }
      });
    };

    return decorator;
  };

  parametrizedDecorator.propToData = transform.propToData.bind(transform);
  parametrizedDecorator.dataToProp = transform.dataToProp.bind(transform);
  return parametrizedDecorator;
}

var MemoTransformCache =
/*#__PURE__*/
function () {
  function MemoTransformCache() {
    this.cache = new WeakMap();
  }

  var _proto = MemoTransformCache.prototype;

  _proto.getOrCreateMemoTransform = function getOrCreateMemoTransform(target, propName, baseTransform) {
    var transformsPerProperty = this.cache.get(target);

    if (!transformsPerProperty) {
      transformsPerProperty = new Map();
      this.cache.set(target, transformsPerProperty);
    }

    var memoTransform = transformsPerProperty.get(propName);

    if (!memoTransform) {
      memoTransform = toMemoPropTransform(baseTransform, function (newPropValue) {
        target.$[propName] = newPropValue;
      });
      transformsPerProperty.set(propName, memoTransform);
    }

    return memoTransform;
  };

  return MemoTransformCache;
}();
/**
 * @ignore
 * @internal
 */


var memoTransformCache =
/*#__PURE__*/
new MemoTransformCache();
var valueNotMemoized =
/*#__PURE__*/
Symbol("valueNotMemoized");

function toMemoPropTransform(transform, propSetter) {
  var lastPropValue = valueNotMemoized;
  var lastDataValue = valueNotMemoized;
  return {
    isMemoPropTransform: true,
    propToData: function propToData(propValue) {
      if (lastPropValue !== propValue) {
        lastDataValue = transform.propToData(propValue, propSetter);
        lastPropValue = propValue;
      }

      return lastDataValue;
    },
    dataToProp: function dataToProp(newDataValue) {
      // clear caches in this case
      lastPropValue = valueNotMemoized;
      lastDataValue = valueNotMemoized;
      return transform.dataToProp(newDataValue);
    }
  };
}
/**
 * @ignore
 * @internal
 */


function transformedProp(prop, transform, transformDefault) {
  if (prop.transform) {
    throw failure("a property cannot have more than one transform");
  }

  var p = _extends({}, prop, {
    transform: transform
  }); // transform defaults if needed


  if (transformDefault) {
    if (p.defaultValue !== noDefaultValue) {
      var originalDefaultValue = p.defaultValue;
      p.defaultValue = transform.dataToProp(originalDefaultValue);
    }

    if (p.defaultFn !== noDefaultValue) {
      var originalDefaultFn = p.defaultFn;

      p.defaultFn = function () {
        return transform.dataToProp(originalDefaultFn());
      };
    }
  }

  return p;
}

/**
 * @ignore
 */

var objectParents =
/*#__PURE__*/
new WeakMap();
/**
 * @ignore
 */

var objectParentsAtoms =
/*#__PURE__*/
new WeakMap();
/**
 * @ignore
 */

function parentPathEquals(parentPath1, parentPath2, comparePath) {
  if (comparePath === void 0) {
    comparePath = true;
  }

  if (!parentPath1 && !parentPath2) return true;
  if (!parentPath1 || !parentPath2) return false;
  var parentEquals = parentPath1.parent === parentPath2.parent;
  if (!parentEquals) return false;
  return comparePath ? parentPath1.path === parentPath2.path : true;
}

function createParentPathAtom(obj) {
  var atom = objectParentsAtoms.get(obj);

  if (!atom) {
    atom = createAtom("parentAtom");
    objectParentsAtoms.set(obj, atom);
  }

  return atom;
}
/**
 * @ignore
 */


function reportParentPathObserved(node) {
  createParentPathAtom(node).reportObserved();
}
/**
 * @ignore
 */

function reportParentPathChanged(node) {
  createParentPathAtom(node).reportChanged();
}
/**
 * @ignore
 */

var dataObjectParent =
/*#__PURE__*/
new WeakMap();
/**
 * @ignore
 */

function dataToModelNode(node) {
  var modelNode = dataObjectParent.get(node);
  return modelNode || node;
}
/**
 * @ignore
 */

function modelToDataNode(node) {
  return isModel(node) ? node.$ : node;
}

/**
 * @ignore
 * @internal
 */

var tweakedObjects =
/*#__PURE__*/
new WeakMap();
/**
 * @ignore
 * @internal
 */

function isTweakedObject(value, canBeDataObject) {
  if (!canBeDataObject && dataObjectParent.has(value)) {
    return false;
  }

  return tweakedObjects.has(value);
}
/**
 * Checks if a given object is now a tree node.
 *
 * @param value Value to check.
 * @returns true if it is a tree node, false otherwise.
 */

function isTreeNode(value) {
  return !isPrimitive(value) && isTweakedObject(value, false);
}
/**
 * @ignore
 * @internal
 */

function assertTweakedObject(treeNode, argName, canBeDataObject) {
  if (canBeDataObject === void 0) {
    canBeDataObject = false;
  }

  if (!canBeDataObject && dataObjectParent.has(treeNode)) {
    throw failure(argName + " must be the model object instance instead of the '$' sub-object");
  }

  if (!isTreeNode(treeNode)) {
    throw failure(argName + " must be a tree node (usually a model or a shallow / deep child part of a model 'data' object)");
  }
}
/**
 * @ignore
 * @internal
 */

var runningWithoutSnapshotOrPatches = false;
/**
 * @ignore
 * @internal
 */

function runWithoutSnapshotOrPatches(fn) {
  var old = runningWithoutSnapshotOrPatches;
  runningWithoutSnapshotOrPatches = true;

  try {
    runInAction(function () {
      fn();
    });
  } finally {
    runningWithoutSnapshotOrPatches = old;
  }
}

var defaultObservableSetOptions = {
  deep: false
};
var objectChildren =
/*#__PURE__*/
new WeakMap();
/**
 * @ignore
 */

function initializeObjectChildren(node) {
  if (objectChildren.has(node)) {
    return;
  }

  objectChildren.set(node, {
    shallow: observable.set(undefined, defaultObservableSetOptions),
    deep: new Set(),
    deepByModelTypeAndId: new Map(),
    deepDirty: true,
    deepAtom: createAtom("deepChildrenAtom")
  });
}
/**
 * @ignore
 */

function getObjectChildren(node) {
  return objectChildren.get(node).shallow;
}
/**
 * @ignore
 */

function getDeepObjectChildren(node) {
  var obj = objectChildren.get(node);

  if (obj.deepDirty) {
    updateDeepObjectChildren(node);
  }

  obj.deepAtom.reportObserved();
  return {
    deep: obj.deep,
    deepByModelTypeAndId: obj.deepByModelTypeAndId
  };
}

function addNodeToDeepLists(node, deep, deepByModelTypeAndId) {
  deep.add(node);

  if (isModel(node)) {
    deepByModelTypeAndId.set(byModelTypeAndIdKey(node.$modelType, node.$modelId), node);
  }
}

var updateDeepObjectChildren =
/*#__PURE__*/
action(function (node) {
  var obj = objectChildren.get(node);

  if (!obj.deepDirty) {
    return {
      deep: obj.deep,
      deepByModelTypeAndId: obj.deepByModelTypeAndId
    };
  }

  var deep = new Set();
  var deepByModelTypeAndId = new Map();
  var childrenIter = getObjectChildren(node).values();
  var ch = childrenIter.next();

  while (!ch.done) {
    addNodeToDeepLists(ch.value, deep, deepByModelTypeAndId);
    var ret = updateDeepObjectChildren(ch.value).deep;
    var retIter = ret.values();
    var retCur = retIter.next();

    while (!retCur.done) {
      addNodeToDeepLists(retCur.value, deep, deepByModelTypeAndId);
      retCur = retIter.next();
    }

    ch = childrenIter.next();
  }

  obj.deep = deep;
  obj.deepByModelTypeAndId = deepByModelTypeAndId;
  obj.deepDirty = false;
  obj.deepAtom.reportChanged();
  return {
    deep: deep,
    deepByModelTypeAndId: deepByModelTypeAndId
  };
});
/**
 * @ignore
 */

var addObjectChild =
/*#__PURE__*/
action(function (node, child) {
  var obj = objectChildren.get(node);
  obj.shallow.add(child);
  invalidateDeepChildren(node);
});
/**
 * @ignore
 */

var removeObjectChild =
/*#__PURE__*/
action(function (node, child) {
  var obj = objectChildren.get(node);
  obj.shallow["delete"](child);
  invalidateDeepChildren(node);
});

function invalidateDeepChildren(node) {
  var obj = objectChildren.get(node);

  if (!obj.deepDirty) {
    obj.deepDirty = true;
    obj.deepAtom.reportChanged();
  }

  var parent = fastGetParent(node);

  if (parent) {
    invalidateDeepChildren(parent);
  }
}
/**
 * @ignore
 */


function byModelTypeAndIdKey(modelType, modelId) {
  return modelType + " " + modelId;
}

/**
 * Returns the parent of the target plus the path from the parent to the target, or undefined if it has no parent.
 *
 * @typeparam T Parent object type.
 * @param value Target object.
 * @returns
 */

function getParentPath(value) {
  assertTweakedObject(value, "value");
  return fastGetParentPath(value);
}
/**
 * @ignore
 * @internal
 */

function fastGetParentPath(value) {
  reportParentPathObserved(value);
  return objectParents.get(value);
}
/**
 * @ignore
 * @internal
 */

function fastGetParentPathIncludingDataObjects(value) {
  var parentModel = dataObjectParent.get(value);

  if (parentModel) {
    return {
      parent: parentModel,
      path: "$"
    };
  }

  var parentPath = fastGetParentPath(value);

  if (parentPath && isModel(parentPath.parent)) {
    return {
      parent: parentPath.parent.$,
      path: parentPath.path
    };
  }

  return parentPath;
}
/**
 * Returns the parent object of the target object, or undefined if there's no parent.
 *
 * @typeparam T Parent object type.
 * @param value Target object.
 * @returns
 */

function getParent(value) {
  assertTweakedObject(value, "value");
  return fastGetParent(value);
}
/**
 * @ignore
 * @internal
 */

function fastGetParent(value) {
  var parentPath = fastGetParentPath(value);
  return parentPath ? parentPath.parent : undefined;
}
/**
 * @ignore
 * @internal
 */

function fastGetParentIncludingDataObjects(value) {
  var parentPath = fastGetParentPathIncludingDataObjects(value);
  return parentPath ? parentPath.parent : undefined;
}
/**
 * Returns if a given object is a model interim data object (`$`).
 *
 * @param value Object to check.
 * @returns true if it is, false otherwise.
 */

function isModelDataObject(value) {
  assertTweakedObject(value, "value", true);
  return fastIsModelDataObject(value);
}
/**
 * @ignore
 * @internal
 */

function fastIsModelDataObject(value) {
  return dataObjectParent.has(value);
}
/**
 * Returns the root of the target plus the path from the root to get to the target.
 *
 * @typeparam T Root object type.
 * @param value Target object.
 * @returns
 */

function getRootPath(value) {
  assertTweakedObject(value, "value");
  return fastGetRootPath(value);
} // we use computeds so they are cached whenever possible

var computedsGetRootPath =
/*#__PURE__*/
new WeakMap();

function internalGetRootPath(value) {
  var rootPath = {
    root: value,
    path: [],
    pathObjects: [value]
  };
  var parentPath;

  while (parentPath = fastGetParentPath(rootPath.root)) {
    rootPath.root = parentPath.parent;
    rootPath.path.unshift(parentPath.path);
    rootPath.pathObjects.unshift(parentPath.parent);
  }

  return rootPath;
}
/**
 * @ignore
 * @internal
 */


function fastGetRootPath(value) {
  var computedGetRootPathForNode = computedsGetRootPath.get(value);

  if (!computedGetRootPathForNode) {
    computedGetRootPathForNode = computed(function () {
      return internalGetRootPath(value);
    });
    computedsGetRootPath.set(value, computedGetRootPathForNode);
  }

  return computedGetRootPathForNode.get();
}
/**
 * Returns the root of the target object, or itself if the target is a root.
 *
 * @typeparam T Root object type.
 * @param value Target object.
 * @returns
 */

function getRoot(value) {
  assertTweakedObject(value, "value");
  return fastGetRoot(value);
}
/**
 * @ignore
 * @internal
 */

function fastGetRoot(value) {
  return fastGetRootPath(value).root;
}
/**
 * Returns if a given object is a root object.
 *
 * @param value Target object.
 * @returns
 */

function isRoot(value) {
  assertTweakedObject(value, "value");
  return !fastGetParent(value);
}
/**
 * Returns if the target is a "child" of the tree of the given "parent" object.
 *
 * @param child Target object.
 * @param parent Parent object.
 * @returns
 */

function isChildOfParent(child, parent) {
  assertTweakedObject(child, "child");
  assertTweakedObject(parent, "parent");
  return getDeepObjectChildren(parent).deep.has(child);
}
/**
 * Returns if the target is a "parent" that has in its tree the given "child" object.
 *
 * @param parent Target object.
 * @param child Child object.
 * @returns
 */

function isParentOfChild(parent, child) {
  return isChildOfParent(child, parent);
}
var unresolved = {
  resolved: false
};
/**
 * Tries to resolve a path from an object.
 *
 * @typeparam T Returned value type.
 * @param pathRootObject Object that serves as path root.
 * @param path Path as an string or number array.
 * @returns An object with `{ resolved: true, value: T }` or `{ resolved: false }`.
 */

function resolvePath(pathRootObject, path) {
  // unit tests rely on this to work with any object
  // assertTweakedObject(pathRootObject, "pathRootObject")
  var current = modelToDataNode(pathRootObject);
  var len = path.length;

  for (var i = 0; i < len; i++) {
    if (!isObject(current)) {
      return unresolved;
    }

    var p = path[i]; // check just to avoid mobx warnings about trying to access out of bounds index

    if (isArray(current) && +p >= current.length) {
      return unresolved;
    }

    current = modelToDataNode(current[p]);
  }

  return {
    resolved: true,
    value: dataToModelNode(current)
  };
}
/**
 * @ignore
 */

var skipIdChecking =
/*#__PURE__*/
Symbol("skipIdChecking");
/**
 * @ignore
 *
 * Tries to resolve a path from an object while checking ids.
 *
 * @typeparam T Returned value type.
 * @param pathRootObject Object that serves as path root.
 * @param path Path as an string or number array.
 * @param pathIds An array of ids of the models that must be checked, null if not a model or `skipIdChecking` to skip it.
 * @returns An object with `{ resolved: true, value: T }` or `{ resolved: false }`.
 */

function resolvePathCheckingIds(pathRootObject, path, pathIds) {
  // unit tests rely on this to work with any object
  // assertTweakedObject(pathRootObject, "pathRootObject")
  var current = modelToDataNode(pathRootObject); // root id is never checked

  var len = path.length;

  for (var i = 0; i < len; i++) {
    if (!isObject(current)) {
      return {
        resolved: false
      };
    }

    var p = path[i]; // check just to avoid mobx warnings about trying to access out of bounds index

    if (isArray(current) && +p >= current.length) {
      return {
        resolved: false
      };
    }

    var currentMaybeModel = current[p];
    current = modelToDataNode(currentMaybeModel);
    var expectedId = pathIds[i];

    if (expectedId !== skipIdChecking) {
      var currentId = isModel(currentMaybeModel) ? currentMaybeModel.$modelId : null;

      if (expectedId !== currentId) {
        return {
          resolved: false
        };
      }
    }
  }

  return {
    resolved: true,
    value: dataToModelNode(current)
  };
}
/**
 * Gets the path to get from a parent to a given child.
 * Returns an empty array if the child is actually the given parent or undefined if the child is not a child of the parent.
 *
 * @param fromParent
 * @param toChild
 * @returns
 */

function getParentToChildPath(fromParent, toChild) {
  assertTweakedObject(fromParent, "fromParent");
  assertTweakedObject(toChild, "toChild");

  if (fromParent === toChild) {
    return [];
  }

  var path = [];
  var current = toChild;
  var parentPath;

  while (parentPath = fastGetParentPath(current)) {
    path.unshift(parentPath.path);
    current = parentPath.parent;

    if (current === fromParent) {
      return path;
    }
  }

  return undefined;
}

var snapshots =
/*#__PURE__*/
new WeakMap();
/**
 * @ignore
 */

function getInternalSnapshot(value) {
  return snapshots.get(value);
}

function getInternalSnapshotParent(sn, parentPath) {
  return untracked(function () {
    if (!parentPath) {
      return undefined;
    }

    var parentSn = getInternalSnapshot(parentPath.parent);

    if (!parentSn) {
      return undefined;
    }

    return sn ? {
      parentSnapshot: parentSn,
      parentPath: parentPath
    } : undefined;
  });
}
/**
 * @ignore
 */


var unsetInternalSnapshot =
/*#__PURE__*/
action("unsetInternalSnapshot", function (value) {
  var oldSn = getInternalSnapshot(value);

  if (oldSn) {
    snapshots["delete"](value);
    oldSn.atom.reportChanged();
  }
});
/**
 * @ignore
 */

var setInternalSnapshot =
/*#__PURE__*/
action("setInternalSnapshot", function (value, standard) {
  var oldSn = getInternalSnapshot(value); // do not actually update if not needed

  if (oldSn && oldSn.standard === standard) {
    return;
  }

  debugFreeze(standard);
  var sn;

  if (oldSn) {
    sn = oldSn;
    sn.standard = standard;
  } else {
    sn = {
      standard: standard,
      atom: createAtom("snapshot")
    };
    snapshots.set(value, sn);
  }

  sn.atom.reportChanged(); // also update parent(s) snapshot(s) if needed

  var parent = getInternalSnapshotParent(oldSn, fastGetParentPath(value));

  if (parent) {
    var parentSnapshot = parent.parentSnapshot,
        parentPath = parent.parentPath; // might be false in the cases where the parent has not yet been created

    if (parentSnapshot) {
      var path = parentPath.path; // patches for parent changes should not be emitted

      var parentStandardSn = parentSnapshot.standard;

      if (parentStandardSn[path] !== sn.standard) {
        if (Array.isArray(parentStandardSn)) {
          parentStandardSn = parentStandardSn.slice();
        } else {
          parentStandardSn = Object.assign({}, parentStandardSn);
        }

        parentStandardSn[path] = sn.standard;
        setInternalSnapshot(parentPath.parent, parentStandardSn);
      }
    }
  }
});
/**
 * @ignore
 */

function reportInternalSnapshotObserved(sn) {
  sn.atom.reportObserved();
}

/**
 * Retrieves an immutable snapshot for a data structure.
 * Since returned snapshots are immutable they will respect shallow equality, this is,
 * if no changes are made then the snapshot will be kept the same.
 *
 * @typeparam T Object type.
 * @param nodeOrPrimitive Data structure, including primtives.
 * @returns The snapshot.
 */

function getSnapshot(nodeOrPrimitive) {
  if (isPrimitive(nodeOrPrimitive)) {
    return nodeOrPrimitive;
  }

  assertTweakedObject(nodeOrPrimitive, "nodeOrPrimitive");
  var snapshot = getInternalSnapshot(nodeOrPrimitive);

  if (!snapshot) {
    throw failure("getSnapshot is not supported for this kind of object");
  }

  reportInternalSnapshotObserved(snapshot);
  return snapshot.standard;
}

var modelPropertiesSymbol =
/*#__PURE__*/
Symbol("modelProperties");
var modelDataTypeCheckerSymbol =
/*#__PURE__*/
Symbol("modelDataTypeChecker");
var modelInitializersSymbol =
/*#__PURE__*/
Symbol("modelInitializers");
var modelUnwrappedClassSymbol =
/*#__PURE__*/
Symbol("modelUnwrappedClass");

/**
 * Returns the associated data type for run-time checking (if any) to a model instance or class.
 *
 * @param modelClassOrInstance Model class or instance.
 * @returns The associated data type, or undefined if none.
 */

function getModelDataType(modelClassOrInstance) {
  if (isModel(modelClassOrInstance)) {
    return modelClassOrInstance.constructor[modelDataTypeCheckerSymbol];
  } else if (isModelClass(modelClassOrInstance)) {
    return modelClassOrInstance[modelDataTypeCheckerSymbol];
  } else {
    throw failure("modelClassOrInstance must be a model class or instance");
  }
}

/**
 * Key where model snapshots will store model type metadata.
 */
var modelTypeKey = "$modelType";
/**
 * Key where model snapshots will store model internal IDs metadata.
 */

var modelIdKey = "$modelId";
/**
 * @internal
 * Returns if a given key is a reserved key in model snapshots.
 *
 * @param key
 * @returns
 */

function isReservedModelKey(key) {
  return key === modelTypeKey || key === modelIdKey;
}

/**
 * @ignore
 */

var modelInfoByName = {};
/**
 * @ignore
 */

var modelInfoByClass =
/*#__PURE__*/
new Map();
/**
 * @ignore
 */

function getModelInfoForName(name) {
  return modelInfoByName[name];
}

/**
 * A type checking error.
 */

var TypeCheckError =
/*#__PURE__*/
function () {
  /**
   * Creates an instance of TypeError.
   * @param path Sub-path where the error occured.
   * @param expectedTypeName Name of the expected type.
   * @param actualValue Actual value.
   */
  function TypeCheckError(path, expectedTypeName, actualValue) {
    this.path = path;
    this.expectedTypeName = expectedTypeName;
    this.actualValue = actualValue;
  }
  /**
   * Throws the type check error as an actual error.
   *
   * @param typeCheckedValue Usually the value where the type check was invoked.
   */


  var _proto = TypeCheckError.prototype;

  _proto["throw"] = function _throw(typeCheckedValue) {
    var msg = "TypeCheckError: ";
    var rootPath = [];

    if (isTweakedObject(typeCheckedValue, true)) {
      rootPath = getRootPath(typeCheckedValue).path;
    }

    msg += "[/" + [].concat(rootPath, this.path).join("/") + "] ";
    msg += "Expected: " + this.expectedTypeName;
    throw failure(msg);
  };

  return TypeCheckError;
}();

var emptyPath = [];
var typeCheckersWithCachedResultsOfObject =
/*#__PURE__*/
new WeakMap();
/**
 * @ignore
 */

function invalidateCachedTypeCheckerResult(obj) {
  // we need to invalidate it for the object and all its parents
  var current = obj;

  while (current) {
    var set = typeCheckersWithCachedResultsOfObject.get(current);

    if (set) {
      for (var _iterator = set, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var typeChecker = _ref;
        typeChecker.invalidateCachedResult(current);
      }

      typeCheckersWithCachedResultsOfObject["delete"](current);
    }

    current = fastGetParentIncludingDataObjects(current);
  }
}
/**
 * @ignore
 */

var TypeChecker =
/*#__PURE__*/
function () {
  function TypeChecker(_check, getTypeName, typeInfoGen) {
    this._check = _check;
    this.getTypeName = getTypeName;
    this.unchecked = !_check;
    this._cachedTypeInfoGen = lateVal(typeInfoGen);
  }

  var _proto = TypeChecker.prototype;

  _proto.createCacheIfNeeded = function createCacheIfNeeded() {
    if (!this.checkResultCache) {
      this.checkResultCache = new WeakMap();
    }

    return this.checkResultCache;
  };

  _proto.setCachedResult = function setCachedResult(obj, newCacheValue) {
    this.createCacheIfNeeded().set(obj, newCacheValue); // register this type checker as listener of that object changes

    var typeCheckerSet = typeCheckersWithCachedResultsOfObject.get(obj);

    if (!typeCheckerSet) {
      typeCheckerSet = new Set();
      typeCheckersWithCachedResultsOfObject.set(obj, typeCheckerSet);
    }

    typeCheckerSet.add(this);
  };

  _proto.invalidateCachedResult = function invalidateCachedResult(obj) {
    if (this.checkResultCache) {
      this.checkResultCache["delete"](obj);
    }
  };

  _proto.getCachedResult = function getCachedResult(obj) {
    return this.checkResultCache ? this.checkResultCache.get(obj) : undefined;
  };

  _proto.check = function check(value, path) {
    if (this.unchecked) {
      return null;
    }

    if (!isTweakedObject(value, true)) {
      return this._check(value, path);
    } // optimized checking with cached values


    var cachedResult = this.getCachedResult(value);

    if (cachedResult === undefined) {
      // we set the path empty since the resoult could be used for another paths other than this base
      cachedResult = this._check(value, emptyPath);
      this.setCachedResult(value, cachedResult);
    }

    if (cachedResult) {
      return new TypeCheckError([].concat(path, cachedResult.path), cachedResult.expectedTypeName, cachedResult.actualValue);
    } else {
      return null;
    }
  };

  _createClass(TypeChecker, [{
    key: "typeInfo",
    get: function get() {
      return this._cachedTypeInfoGen(this);
    }
  }]);

  return TypeChecker;
}();
var lateTypeCheckerSymbol =
/*#__PURE__*/
Symbol("lateTypeCheker");
/**
 * @ignore
 */

function lateTypeChecker(fn, typeInfoGen) {
  var cached;

  var ltc = function ltc() {
    if (cached) {
      return cached;
    }

    cached = fn();
    return cached;
  };

  ltc[lateTypeCheckerSymbol] = true;
  var cachedTypeInfoGen = lateVal(typeInfoGen);
  Object.defineProperty(ltc, "typeInfo", {
    enumerable: true,
    configurable: true,
    get: function get() {
      return cachedTypeInfoGen(ltc);
    }
  });
  return ltc;
}
/**
 * @ignore
 */

function isLateTypeChecker(ltc) {
  return typeof ltc === "function" && ltc[lateTypeCheckerSymbol];
}
/**
 * Type info base class.
 */

var TypeInfo = function TypeInfo(thisType) {
  this.thisType = thisType;
};
/**
 * Gets the type info of a given type.
 *
 * @param type Type to get the info from.
 * @returns The type info.
 */

function getTypeInfo(type) {
  var stdType = resolveStandardType(type);
  var typeInfo = stdType.typeInfo;

  if (!typeInfo) {
    throw failure("type info not found for " + type);
  }

  return typeInfo;
}

/**
 * A refinement over a given type. This allows you to do extra checks
 * over models, ensure numbers are integers, etc.
 *
 * Example:
 * ```ts
 * const integerType = types.refinement(types.number, (n) => {
 *   return Number.isInteger(n)
 * }, "integer")
 *
 * const sumModelType = types.refinement(types.model<Sum>(Sum), (sum) => {
 *   // imagine that for some reason sum includes a number 'a', a number 'b'
 *   // and the result
 *
 *   const rightResult = sum.a + sum.b === sum.result
 *
 *   // simple mode that will just return that the whole model is incorrect
 *   return rightResult
 *
 *   // this will return that the result field is wrong
 *   return rightResult ? null : new TypeCheckError(["result"], "a+b", sum.result)
 * })
 * ```
 *
 * @template T Base type.
 * @param baseType Base type.
 * @param checkFn Function that will receive the data (if it passes the base type
 * check) and return null or false if there were no errors or either a TypeCheckError instance or
 * true if there were.
 * @returns
 */

function typesRefinement(baseType, checkFn, typeName) {
  var typeInfoGen = function typeInfoGen(t) {
    return new RefinementTypeInfo(t, resolveStandardType(baseType), checkFn, typeName);
  };

  return lateTypeChecker(function () {
    var baseChecker = resolveTypeChecker(baseType);

    var getTypeName = function getTypeName() {
      for (var _len = arguments.length, recursiveTypeCheckers = new Array(_len), _key = 0; _key < _len; _key++) {
        recursiveTypeCheckers[_key] = arguments[_key];
      }

      var baseTypeName = baseChecker.getTypeName.apply(baseChecker, recursiveTypeCheckers.concat([baseChecker]));
      var refinementName = typeName || "refinementOf";
      return refinementName + "<" + baseTypeName + ">";
    };

    var thisTc = new TypeChecker(function (data, path) {
      var baseErr = baseChecker.check(data, path);

      if (baseErr) {
        return baseErr;
      }

      var refinementErr = checkFn(data);

      if (refinementErr === true) {
        return null;
      } else if (refinementErr === false) {
        return new TypeCheckError([], getTypeName(thisTc), data);
      } else {
        return refinementErr || null;
      }
    }, getTypeName, typeInfoGen);
    return thisTc;
  }, typeInfoGen);
}
/**
 * `types.refinement` type info.
 */

var RefinementTypeInfo =
/*#__PURE__*/
function (_TypeInfo) {
  _inheritsLoose(RefinementTypeInfo, _TypeInfo);

  function RefinementTypeInfo(thisType, baseType, checkFunction, typeName) {
    var _this;

    _this = _TypeInfo.call(this, thisType) || this;
    _this.baseType = baseType;
    _this.checkFunction = checkFunction;
    _this.typeName = typeName;
    return _this;
  }

  _createClass(RefinementTypeInfo, [{
    key: "baseTypeInfo",
    get: function get() {
      return getTypeInfo(this.baseType);
    }
  }]);

  return RefinementTypeInfo;
}(TypeInfo);

/**
 * A type that represents a certain value of a primitive (for example an *exact* number or string).
 *
 * Example
 * ```ts
 * const hiType = types.literal("hi") // the string with value "hi"
 * const number5Type = types.literal(5) // the number with value 5
 * ```
 *
 * @typeparam T Literal value type.
 * @param literal Literal value.
 * @returns
 */

function typesLiteral(literal) {
  assertIsPrimitive(literal, "literal");
  var typeName;

  switch (literal) {
    case undefined:
      typeName = "undefined";
      break;

    case null:
      typeName = "null";
      break;

    default:
      typeName = JSON.stringify(literal);
      break;
  }

  var typeInfoGen = function typeInfoGen(t) {
    return new LiteralTypeInfo(t, literal);
  };

  return new TypeChecker(function (value, path) {
    return value === literal ? null : new TypeCheckError(path, typeName, value);
  }, function () {
    return typeName;
  }, typeInfoGen);
}
/**
 * `types.literal` type info.
 */

var LiteralTypeInfo =
/*#__PURE__*/
function (_TypeInfo) {
  _inheritsLoose(LiteralTypeInfo, _TypeInfo);

  function LiteralTypeInfo(thisType, literal) {
    var _this;

    _this = _TypeInfo.call(this, thisType) || this;
    _this.literal = literal;
    return _this;
  }

  return LiteralTypeInfo;
}(TypeInfo);
/**
 * A type that represents the value undefined.
 * Syntactic sugar for `types.literal(undefined)`.
 *
 * ```ts
 * types.undefined
 * ```
 */

var typesUndefined =
/*#__PURE__*/
typesLiteral(undefined);
/**
 * A type that represents the value null.
 * Syntactic sugar for `types.literal(null)`.
 *
 * ```ts
 * types.null
 * ```
 */

var typesNull =
/*#__PURE__*/
typesLiteral(null);
/**
 * A type that represents any boolean value.
 *
 * ```ts
 * types.boolean
 * ```
 */

var typesBoolean =
/*#__PURE__*/
new TypeChecker(function (value, path) {
  return typeof value === "boolean" ? null : new TypeCheckError(path, "boolean", value);
}, function () {
  return "boolean";
}, function (t) {
  return new BooleanTypeInfo(t);
});
/**
 * `types.boolean` type info.
 */

var BooleanTypeInfo =
/*#__PURE__*/
function (_TypeInfo2) {
  _inheritsLoose(BooleanTypeInfo, _TypeInfo2);

  function BooleanTypeInfo() {
    return _TypeInfo2.apply(this, arguments) || this;
  }

  return BooleanTypeInfo;
}(TypeInfo);
/**
 * A type that represents any number value.
 *
 * ```ts
 * types.number
 * ```
 */

var typesNumber =
/*#__PURE__*/
new TypeChecker(function (value, path) {
  return typeof value === "number" ? null : new TypeCheckError(path, "number", value);
}, function () {
  return "number";
}, function (t) {
  return new NumberTypeInfo(t);
});
/**
 * `types.number` type info.
 */

var NumberTypeInfo =
/*#__PURE__*/
function (_TypeInfo3) {
  _inheritsLoose(NumberTypeInfo, _TypeInfo3);

  function NumberTypeInfo() {
    return _TypeInfo3.apply(this, arguments) || this;
  }

  return NumberTypeInfo;
}(TypeInfo);
/**
 * A type that represents any string value.
 *
 * ```ts
 * types.string
 * ```
 */

var typesString =
/*#__PURE__*/
new TypeChecker(function (value, path) {
  return typeof value === "string" ? null : new TypeCheckError(path, "string", value);
}, function () {
  return "string";
}, function (t) {
  return new StringTypeInfo(t);
});
/**
 * `types.string` type info.
 */

var StringTypeInfo =
/*#__PURE__*/
function (_TypeInfo4) {
  _inheritsLoose(StringTypeInfo, _TypeInfo4);

  function StringTypeInfo() {
    return _TypeInfo4.apply(this, arguments) || this;
  }

  return StringTypeInfo;
}(TypeInfo);
/**
 * A type that represents any integer number value.
 * Syntactic sugar for `types.refinement(types.number, n => Number.isInteger(n), "integer")`
 *
 * ```ts
 * types.integer
 * ```
 */

var typesInteger =
/*#__PURE__*/
typesRefinement(typesNumber, function (n) {
  return Number.isInteger(n);
}, "integer");
/**
 * A type that represents any string value other than "".
 * Syntactic sugar for `types.refinement(types.string, s => s !== "", "nonEmpty")`
 *
 * ```ts
 * types.nonEmptyString
 * ```
 */

var typesNonEmptyString =
/*#__PURE__*/
typesRefinement(typesString, function (s) {
  return s !== "";
}, "nonEmpty");

/**
 * @ignore
 */

function resolveTypeChecker(v) {
  var next = v;

  while (true) {
    if (next instanceof TypeChecker) {
      return next;
    } else if (v === String) {
      return typesString;
    } else if (v === Number) {
      return typesNumber;
    } else if (v === Boolean) {
      return typesBoolean;
    } else if (v === null) {
      return typesNull;
    } else if (v === undefined) {
      return typesUndefined;
    } else if (isLateTypeChecker(next)) {
      next = next();
    } else {
      throw failure("type checker could not be resolved");
    }
  }
}
/**
 * @ignore
 */

function resolveStandardType(v) {
  if (v instanceof TypeChecker || isLateTypeChecker(v)) {
    return v;
  } else if (v === String) {
    return typesString;
  } else if (v === Number) {
    return typesNumber;
  } else if (v === Boolean) {
    return typesBoolean;
  } else if (v === null) {
    return typesNull;
  } else if (v === undefined) {
    return typesUndefined;
  } else {
    throw failure("standard type could not be resolved");
  }
}

var cachedModelTypeChecker =
/*#__PURE__*/
new WeakMap();
/**
 * A type that represents a model. The type referenced in the model decorator will be used for type checking.
 *
 * Example:
 * ```ts
 * const someModelType = types.model<SomeModel>(SomeModel)
 * // or for recursive models
 * const someModelType = types.model<SomeModel>(() => SomeModel)
 * ```
 *
 * @typeparam M Model type.
 * @param modelClass Model class.
 * @returns
 */

function typesModel(modelClass) {
  // if we type it any stronger then recursive defs and so on stop working
  if (!isModelClass(modelClass) && typeof modelClass === "function") {
    // resolve later
    var typeInfoGen = function typeInfoGen(t) {
      return new ModelTypeInfo(t, modelClass());
    };

    return lateTypeChecker(function () {
      return typesModel(modelClass());
    }, typeInfoGen);
  } else {
    var modelClazz = modelClass;
    assertIsModelClass(modelClazz, "modelClass");
    var cachedTypeChecker = cachedModelTypeChecker.get(modelClazz);

    if (cachedTypeChecker) {
      return cachedTypeChecker;
    }

    var _typeInfoGen = function _typeInfoGen(t) {
      return new ModelTypeInfo(t, modelClazz);
    };

    var tc = lateTypeChecker(function () {
      var modelInfo = modelInfoByClass.get(modelClazz);
      var typeName = "Model(" + modelInfo.name + ")";
      return new TypeChecker(function (value, path) {
        if (!(value instanceof modelClazz)) {
          return new TypeCheckError(path, typeName, value);
        }

        var dataTypeChecker = getModelDataType(value);

        if (!dataTypeChecker) {
          throw failure("type checking cannot be performed over model of type '" + modelInfo.name + "' at path " + path.join("/") + " since that model type has no data type declared, consider adding a data type or using types.unchecked() instead");
        }

        var resolvedTc = resolveTypeChecker(dataTypeChecker);

        if (!resolvedTc.unchecked) {
          return resolvedTc.check(value.$, path);
        }

        return null;
      }, function () {
        return typeName;
      }, _typeInfoGen);
    }, _typeInfoGen);
    cachedModelTypeChecker.set(modelClazz, tc);
    return tc;
  }
}
/**
 * `types.model` type info.
 */

var ModelTypeInfo =
/*#__PURE__*/
function (_TypeInfo) {
  _inheritsLoose(ModelTypeInfo, _TypeInfo);

  function ModelTypeInfo(thisType, modelClass) {
    var _this;

    _this = _TypeInfo.call(this, thisType) || this;
    _this.modelClass = modelClass;
    _this._props = lateVal(function () {
      var objSchema = _this.modelClass[modelPropertiesSymbol];
      var propTypes = {};
      Object.keys(objSchema).forEach(function (propName) {
        var propData = objSchema[propName];
        var type = propData.typeChecker;
        var typeInfo;

        if (type) {
          typeInfo = getTypeInfo(type);
        }

        var hasDefault = false;
        var defaultValue;

        if (propData.defaultFn !== noDefaultValue) {
          defaultValue = propData.defaultFn;
          hasDefault = true;
        } else if (propData.defaultValue !== noDefaultValue) {
          defaultValue = propData.defaultValue;
          hasDefault = true;
        }

        propTypes[propName] = {
          type: type,
          typeInfo: typeInfo,
          hasDefault: hasDefault,
          "default": defaultValue
        };
      });
      return propTypes;
    });
    return _this;
  }

  _createClass(ModelTypeInfo, [{
    key: "props",
    get: function get() {
      return this._props();
    }
  }, {
    key: "modelType",
    get: function get() {
      var modelInfo = modelInfoByClass.get(this.modelClass);
      return modelInfo.name;
    }
  }]);

  return ModelTypeInfo;
}(TypeInfo);

/**
 * Checks if a value conforms to a given type.
 *
 * @typename S Type.
 * @param type Type to check for.
 * @param value Value to check.
 * @returns A TypeError if the check fails or null if no error.
 */

function typeCheck(type, value) {
  var typeChecker = resolveTypeChecker(type);

  if (typeChecker.unchecked) {
    return null;
  } else {
    return typeChecker.check(value, []);
  }
}

var alwaysTrue = function alwaysTrue() {
  return true;
};
/**
 * @ignore
 */


function enqueuePendingAction(action) {
  // delay action until all current actions are finished
  when(alwaysTrue, action);
}

/**
 * Action type, sync or async.
 */
var ActionContextActionType;

(function (ActionContextActionType) {
  ActionContextActionType["Sync"] = "sync";
  ActionContextActionType["Async"] = "async";
})(ActionContextActionType || (ActionContextActionType = {}));
/**
 * An async step type.
 */


var ActionContextAsyncStepType;

(function (ActionContextAsyncStepType) {
  /**
   * The flow is about to start.
   */
  ActionContextAsyncStepType["Spawn"] = "spawn";
  /**
   * The flow is about to return (finish).
   */

  ActionContextAsyncStepType["Return"] = "return";
  /**
   * The flow is about to continue.
   */

  ActionContextAsyncStepType["Resume"] = "resume";
  /**
   * The flow yield just threw, which might be recovered (caught) or not.
   */

  ActionContextAsyncStepType["ResumeError"] = "resumeError";
  /**
   * The flow is about to throw an error to the flow caller.
   */

  ActionContextAsyncStepType["Throw"] = "throw";
})(ActionContextAsyncStepType || (ActionContextAsyncStepType = {}));

var currentActionContext;
/**
 * Gets the currently running action context, or undefined if none.
 *
 * @returns
 */

function getCurrentActionContext() {
  return currentActionContext;
}
/**
 * @ignore
 * @internal
 *
 * Sets the current action context.
 *
 * @param ctx Current action context.
 */

function setCurrentActionContext(ctx) {
  currentActionContext = ctx;
}

/**
 * A hook action.
 */
var HookAction;

(function (HookAction) {
  /**
   * onInit hook
   */
  HookAction["OnInit"] = "$$onInit";
  /**
   * onAttachedToRootStore hook
   */

  HookAction["OnAttachedToRootStore"] = "$$onAttachedToRootStore";
  /**
   * disposer for onAttachedToRootStore hook
   */

  HookAction["OnAttachedToRootStoreDisposer"] = "$$onAttachedToRootStoreDisposer";
})(HookAction || (HookAction = {}));

var hookActionValues =
/*#__PURE__*/
new Set(
/*#__PURE__*/
Object.values(HookAction));
/**
 * Returns if a given action name corresponds to a hook, this is, one of:
 * - onInit() hook
 * - onAttachedToRootStore() hook
 * - disposer returned by a onAttachedToRootStore() hook
 *
 * @param actionName Action name to check.
 * @returns true if it is a hook, false otherwise.
 */

function isHookAction(actionName) {
  return hookActionValues.has(actionName);
}

var perObjectActionMiddlewares =
/*#__PURE__*/
new WeakMap();
var perObjectActionMiddlewaresIterator =
/*#__PURE__*/
new WeakMap();
/**
 * @ignore
 * @internal
 *
 * Gets the current action middlewares to be run over a given object as an iterable object.
 *
 * @returns
 */

function getActionMiddlewares(obj) {
  // when we call a middleware we will call the middlewares of that object plus all parent objects
  // the parent object middlewares are run last
  // since an array like [a, b, c] will be called like c(b(a())) this means that we need to put
  // the parent object ones at the end of the array
  var iterable = perObjectActionMiddlewaresIterator.get(obj);

  if (!iterable) {
    var _iterable;

    iterable = (_iterable = {}, _iterable[Symbol.iterator] = function () {
      var current = obj;

      function getCurrentIterator() {
        var objMwares = current ? perObjectActionMiddlewares.get(current) : undefined;

        if (!objMwares || objMwares.length <= 0) {
          return undefined;
        }

        return objMwares[Symbol.iterator]();
      }

      function findNextIterator() {
        var nextIter;

        while (current && !nextIter) {
          current = fastGetParent(current);
          nextIter = getCurrentIterator();
        }

        return nextIter;
      }

      var iter = getCurrentIterator();

      if (!iter) {
        iter = findNextIterator();
      }

      var iterator = {
        next: function next() {
          if (!iter) {
            return {
              value: undefined,
              done: true
            };
          }

          var result = iter.next();

          if (!result.done) {
            return result;
          }

          iter = findNextIterator();
          return this.next();
        }
      };
      return iterator;
    }, _iterable);
    perObjectActionMiddlewaresIterator.set(obj, iterable);
  }

  return iterable;
}
/**
 * Adds a global action middleware to be run when an action is performed.
 * It is usually preferable to use `onActionMiddleware` instead to limit it to a given tree and only to topmost level actions
 * or `actionTrackingMiddleware` for a simplified middleware.
 *
 * @param mware Action middleware to be run.
 * @returns A disposer to cancel the middleware. Note that if you don't plan to do an early disposal of the middleware
 * calling this function becomes optional.
 */

function addActionMiddleware(mware) {
  assertIsObject(mware, "middleware");
  var middleware = mware.middleware,
      filter = mware.filter,
      subtreeRoot = mware.subtreeRoot;
  assertTweakedObject(subtreeRoot, "middleware.subtreeRoot");
  assertIsFunction(middleware, "middleware.middleware");

  if (filter && typeof filter !== "function") {
    throw failure("middleware.filter must be a function or undefined");
  }

  if (!isAction(middleware)) {
    middleware = action(middleware.name || "actionMiddleware", middleware);
  }

  if (subtreeRoot) {
    var targetFilter = function targetFilter(ctx) {
      return ctx.target === subtreeRoot || isChildOfParent(ctx.target, subtreeRoot);
    };

    if (!filter) {
      filter = targetFilter;
    } else {
      var customFilter = filter;

      filter = function filter(ctx) {
        return targetFilter(ctx) && customFilter(ctx);
      };
    }
  }

  var actualMware = {
    middleware: middleware,
    filter: filter
  };
  var objMwares = perObjectActionMiddlewares.get(subtreeRoot);

  if (!objMwares) {
    objMwares = [actualMware];
    perObjectActionMiddlewares.set(subtreeRoot, objMwares);
  } else {
    objMwares.push(actualMware);
  }

  return function () {
    deleteFromArray(objMwares, actualMware);
  };
}

/**
 * Returns if the given function is a model action or not.
 *
 * @param fn Function to check.
 * @returns
 */

function isModelAction(fn) {
  return typeof fn === "function" && !!fn[modelActionSymbol];
}

function checkModelActionArgs(target, propertyKey, value) {
  if (typeof value !== "function") {
    throw failure("modelAction has to be used over functions");
  }

  checkModelDecoratorArgs("modelAction", target, propertyKey);
}
/**
 * Decorator that turns a function into a model action.
 *
 * @param target
 * @param propertyKey
 * @param [baseDescriptor]
 * @returns
 */


function modelAction(target, propertyKey, baseDescriptor) {
  return decorateWrapMethodOrField("modelAction", {
    target: target,
    propertyKey: propertyKey,
    baseDescriptor: baseDescriptor
  }, function (data, fn) {
    if (isModelAction(fn)) {
      return fn;
    } else {
      checkModelActionArgs(data.target, data.propertyKey, fn);
      return wrapInAction(data.propertyKey, fn, ActionContextActionType.Sync);
    }
  });
}

/**
 * @ignore
 */

var modelActionSymbol =
/*#__PURE__*/
Symbol("modelAction");
/**
 * @ignore
 */

function wrapInAction(name, fn, actionType, overrideContext, isFlowFinsher) {
  if (isFlowFinsher === void 0) {
    isFlowFinsher = false;
  }

  var wrappedAction = action(name, function () {
    if (inDevMode()) {
      assertTweakedObject(this, "wrappedAction");
    }

    var parentContext = getCurrentActionContext();
    var context = {
      actionName: name,
      type: actionType,
      target: this,
      args: Array.from(arguments),
      parentContext: parentContext,
      data: {},
      rootContext: undefined
    };

    if (overrideContext) {
      overrideContext(context);
    }

    if (!context.rootContext) {
      if (context.previousAsyncStepContext) {
        context.rootContext = context.previousAsyncStepContext.rootContext;
      } else if (context.parentContext) {
        context.rootContext = context.parentContext.rootContext;
      } else {
        context.rootContext = context;
      }
    }

    setCurrentActionContext(context);
    var mwareFn = fn.bind.apply(fn, [this].concat(Array.prototype.slice.call(arguments)));
    var mwareIter = getActionMiddlewares(this)[Symbol.iterator]();
    var mwareCur = mwareIter.next();

    while (!mwareCur.done) {
      var mware = mwareCur.value;
      var filterPassed = mware.filter ? mware.filter(context) : true;

      if (filterPassed) {
        mwareFn = mware.middleware.bind(undefined, context, mwareFn);
      }

      mwareCur = mwareIter.next();
    }

    try {
      var ret = mwareFn();

      if (isFlowFinsher) {
        var flowFinisher = ret;
        var value = flowFinisher.value;

        if (flowFinisher.resolution === "accept") {
          flowFinisher.accepter(value);
        } else {
          flowFinisher.rejecter(value);
        }

        return value; // not sure if this is even needed
      } else {
        return ret;
      }
    } finally {
      setCurrentActionContext(context.parentContext);
    }
  });
  wrappedAction[modelActionSymbol] = true;
  return wrappedAction;
}
/**
 * @ignore
 */

function wrapModelMethodInActionIfNeeded(model, propertyKey, name) {
  var fn = model[propertyKey];

  if (isModelAction(fn)) {
    return;
  }

  var wrappedFn = wrapInAction(name, fn, ActionContextActionType.Sync);
  var proto = Object.getPrototypeOf(model);
  var protoFn = proto[propertyKey];

  if (protoFn === fn) {
    proto[propertyKey] = wrappedFn;
  } else {
    model[propertyKey] = wrappedFn;
  }
}

/**
 * Mode for the `walkTree` method.
 */

var WalkTreeMode;

(function (WalkTreeMode) {
  /**
   * The walk will be done parent (roots) first, then children.
   */
  WalkTreeMode["ParentFirst"] = "parentFirst";
  /**
   * The walk will be done children (leafs) first, then parents.
   */

  WalkTreeMode["ChildrenFirst"] = "childrenFirst";
})(WalkTreeMode || (WalkTreeMode = {}));
/**
 * Walks a tree, running the predicate function for each node.
 * If the predicate function returns something other than undefined,
 * then the walk will be stopped and the function will return the returned value.
 *
 * @typeparam T Returned object type, defaults to void.
 * @param target Subtree root object.
 * @param predicate Function that will be run for each node of the tree.
 * @param mode Mode to walk the tree, as defined in `WalkTreeMode`.
 * @returns
 */


function walkTree(target, predicate, mode) {
  assertTweakedObject(target, "target");

  if (mode === WalkTreeMode.ParentFirst) {
    var recurse = function recurse(child) {
      return walkTreeParentFirst(child, predicate, recurse);
    };

    return walkTreeParentFirst(target, predicate, recurse);
  } else {
    var _recurse = function _recurse(child) {
      return walkTreeChildrenFirst(child, predicate, _recurse);
    };

    return walkTreeChildrenFirst(target, predicate, _recurse);
  }
}

function walkTreeParentFirst(target, rootPredicate, recurse) {
  var ret = rootPredicate(target);

  if (ret !== undefined) {
    return ret;
  }

  var childrenIter = getObjectChildren(target).values();
  var ch = childrenIter.next();

  while (!ch.done) {
    var _ret = recurse(ch.value);

    if (_ret !== undefined) {
      return _ret;
    }

    ch = childrenIter.next();
  }

  return undefined;
}

function walkTreeChildrenFirst(target, rootPredicate, recurse) {
  var childrenIter = getObjectChildren(target).values();
  var ch = childrenIter.next();

  while (!ch.done) {
    var _ret2 = recurse(ch.value);

    if (_ret2 !== undefined) {
      return _ret2;
    }

    ch = childrenIter.next();
  }

  var ret = rootPredicate(target);

  if (ret !== undefined) {
    return ret;
  }

  return undefined;
}
/**
 * @ignore
 * @internal
 */


function computedWalkTreeAggregate(predicate) {
  var computedFns = new WeakMap();

  var getComputedTreeResult = function getComputedTreeResult(tree) {
    var cmpted = computedFns.get(tree);

    if (!cmpted) {
      cmpted = computed(function () {
        return walkTreeAggregate(tree, predicate, recurse);
      });
      computedFns.set(tree, cmpted);
    }

    return cmpted.get();
  };

  var recurse = function recurse(ch) {
    return getComputedTreeResult(ch);
  };

  return {
    walk: function walk(target) {
      return getComputedTreeResult(target);
    }
  };
}

function walkTreeAggregate(target, rootPredicate, recurse) {
  var map;
  var rootVal = rootPredicate(target);
  var childrenMap = getObjectChildren(target);
  var childrenIter = childrenMap.values();
  var ch = childrenIter.next(); // small optimization, if there is only one child and this
  // object provides no value we can just reuse the child ones

  if (rootVal === undefined && childrenMap.size === 1) {
    return recurse(ch.value);
  }

  while (!ch.done) {
    var childMap = recurse(ch.value);

    if (childMap) {
      if (!map) {
        map = new Map();
      } // add child map keys/values to own map


      var mapIter = childMap.keys();
      var mapCur = mapIter.next();

      while (!mapCur.done) {
        var key = mapCur.value;
        var val = childMap.get(key);
        map.set(key, val);
        mapCur = mapIter.next();
      }
    }

    ch = childrenIter.next();
  } // add it at the end so parent resolutions have higher
  // priority than child ones


  if (rootVal !== undefined) {
    if (!map) {
      map = new Map();
    }

    map.set(rootVal, target);
  }

  return map;
}

var onAttachedDisposers =
/*#__PURE__*/
new WeakMap();
/**
 * @ignore
 */

var attachToRootStore =
/*#__PURE__*/
action("attachToRootStore", function (rootStore, child) {
  // we use an array to ensure they will get called even if the actual hook modifies the tree
  var childrenToCall = [];
  walkTree(child, function (ch) {
    if (ch instanceof BaseModel && ch.onAttachedToRootStore) {
      wrapModelMethodInActionIfNeeded(ch, "onAttachedToRootStore", HookAction.OnAttachedToRootStore);
      childrenToCall.push(ch);
    }
  }, WalkTreeMode.ParentFirst);
  var childrenToCallLen = childrenToCall.length;

  for (var i = 0; i < childrenToCallLen; i++) {
    var ch = childrenToCall[i];
    var disposer = ch.onAttachedToRootStore(rootStore);

    if (disposer) {
      onAttachedDisposers.set(ch, disposer);
    }
  }
});
/**
 * @ignore
 */

var detachFromRootStore =
/*#__PURE__*/
action("detachFromRootStore", function (child) {
  // we use an array to ensure they will get called even if the actual hook modifies the tree
  var disposersToCall = [];
  walkTree(child, function (ch) {
    var disposer = onAttachedDisposers.get(ch);

    if (disposer) {
      // wrap disposer in action
      var disposerAction = wrapInAction(HookAction.OnAttachedToRootStoreDisposer, disposer, ActionContextActionType.Sync).bind(ch);
      onAttachedDisposers["delete"](ch);
      disposersToCall.push(disposerAction);
    }
  }, WalkTreeMode.ChildrenFirst);
  var disposersToCallLen = disposersToCall.length;

  for (var i = 0; i < disposersToCallLen; i++) {
    disposersToCall[i]();
  }
});

var rootStores =
/*#__PURE__*/
new WeakSet();
var rootStoreAtoms =
/*#__PURE__*/
new WeakMap();
/**
 * Registers a model / tree node object as a root store tree.
 * Marking a model object as a root store tree serves several purposes:
 * - It allows the `onAttachedToRootStore` hook (plus disposer) to be invoked on models once they become part of this tree.
 *   These hooks can be used for example to attach effects and serve as some sort of initialization.
 * - It allows auto detachable references to work properly.
 *
 * @typeparam T Object type.
 * @param node Node object to register as root store.
 * @returns The same model object that was passed.
 */

var registerRootStore =
/*#__PURE__*/
action("registerRootStore", function (node) {
  assertTweakedObject(node, "node");

  if (rootStores.has(node)) {
    throw failure("object already registered as root store");
  }

  if (!isRoot(node)) {
    throw failure("a root store must not have a parent");
  }

  rootStores.add(node);
  attachToRootStore(node, node);
  getOrCreateRootStoreAtom(node).reportChanged();
  return node;
});
/**
 * Unregisters an object to mark it as no longer a root store.
 *
 * @param node Node object to unregister as root store.
 */

var unregisterRootStore =
/*#__PURE__*/
action("unregisterRootStore", function (node) {
  if (!isRootStore(node)) {
    throw failure("not a root store");
  }

  rootStores["delete"](node);
  detachFromRootStore(node);
  getOrCreateRootStoreAtom(node).reportChanged();
});
/**
 * Checks if a given object is marked as a root store.
 *
 * @param node Object.
 * @returns
 */

function isRootStore(node) {
  assertTweakedObject(node, "node");
  return fastIsRootStore(node);
}
/**
 * @ignore
 * @internal
 */

function fastIsRootStore(node) {
  getOrCreateRootStoreAtom(node).reportObserved();
  return rootStores.has(node);
}
/**
 * Gets the root store of a given tree child, or undefined if none.
 *
 * @typeparam T Root store type.
 * @param node Target to find the root store for.
 * @returns
 */

function getRootStore(node) {
  assertTweakedObject(node, "node");
  return fastGetRootStore(node);
}
/**
 * @ignore
 * @internal
 */

function fastGetRootStore(node) {
  var root = fastGetRoot(node);
  return fastIsRootStore(root) ? root : undefined;
}

function getOrCreateRootStoreAtom(node) {
  var atom = rootStoreAtoms.get(node);

  if (!atom) {
    atom = createAtom("rootStore");
    rootStoreAtoms.set(node, atom);
  }

  return atom;
}

/**
 * @ignore
 */

var setParent =
/*#__PURE__*/
action("setParent", function (value, parentPath, indexChangeAllowed, isDataObject) {
  if (isPrimitive(value)) {
    return;
  }

  if (inDevMode()) {
    if (typeof value === "function" || typeof value === "symbol") {
      throw failure("assertion failed: value cannot be a function or a symbol");
    }

    if (!isTweakedObject(value, true)) {
      throw failure("assertion failed: value is not ready to take a parent");
    }

    if (parentPath) {
      if (!isTweakedObject(parentPath.parent, true)) {
        throw failure("assertion failed: parent is not ready to take children");
      }
    }
  }

  if (isDataObject) {
    dataObjectParent.set(value, parentPath.parent); // data object will proxy to use the actual parent model for child/parent stuff

    return;
  }

  initializeObjectChildren(value); // make sure the new parent actually points to models when we give model data objs

  if (parentPath) {
    var actualParent = dataToModelNode(parentPath.parent);

    if (parentPath.parent !== actualParent) {
      parentPath = {
        parent: actualParent,
        path: parentPath.path
      };
    }
  }

  var oldParentPath = fastGetParentPath(value);

  if (parentPathEquals(oldParentPath, parentPath)) {
    return;
  }

  if (isRootStore(value)) {
    throw failure("root stores cannot be attached to any parents");
  }

  if (oldParentPath && parentPath) {
    if (oldParentPath.parent === parentPath.parent && indexChangeAllowed) {
      // just changing the index
      objectParents.set(value, parentPath);
      reportParentPathChanged(value);
      return;
    } else {
      throw failure("an object cannot be assigned a new parent when it already has one");
    }
  }

  var removeFromOldParent = function removeFromOldParent() {
    if (oldParentPath && oldParentPath.parent) {
      removeObjectChild(oldParentPath.parent, value);
    }
  };

  var attachToNewParent = function attachToNewParent() {
    objectParents.set(value, parentPath);

    if (parentPath && parentPath.parent) {
      addObjectChild(parentPath.parent, value);
    }

    reportParentPathChanged(value);
  };

  if (value instanceof BaseModel) {
    var oldRoot = fastGetRoot(value);
    var oldRootStore = isRootStore(oldRoot) ? oldRoot : undefined;
    removeFromOldParent();
    attachToNewParent();
    var newRoot = fastGetRoot(value);
    var newRootStore = isRootStore(newRoot) ? newRoot : undefined; // invoke model root store events

    if (oldRootStore !== newRootStore) {
      if (oldRootStore) {
        enqueuePendingAction(function () {
          detachFromRootStore(value);
        });
      }

      if (newRootStore) {
        enqueuePendingAction(function () {
          attachToRootStore(newRootStore, value);
        });
      }
    }
  } else {
    removeFromOldParent();
    attachToNewParent();
  }
});

/**
 * @ignore
 */

function tweakModel(value, parentPath) {
  tweakedObjects.set(value, undefined);
  setParent(value, parentPath, false, false); // nothing to do for models, data is already proxified and its parent is set
  // for snapshots we will use its "$" object snapshot directly

  return value;
}

/**
 * @ignore
 * @internal
 */

function canWrite() {
  return !getActionProtection() || !!getCurrentActionContext();
}
/**
 * @ignore
 * @internal
 */

function assertCanWrite() {
  if (!canWrite()) {
    throw failure("data changes must be performed inside model actions");
  }
}
var actionProtection = true;
/**
 * @ignore
 * @internal
 *
 * Gets if the action protection is currently enabled or not.
 *
 * @returns
 */

function getActionProtection() {
  return actionProtection;
} // base case

function runUnprotected(arg1, arg2) {
  var name = typeof arg1 === "string" ? arg1 : undefined;
  var fn = typeof arg1 === "string" ? arg2 : arg1;

  var innerAction = function innerAction() {
    var oldActionProtection = actionProtection;
    actionProtection = false;

    try {
      return fn();
    } finally {
      actionProtection = oldActionProtection;
    }
  };

  if (name) {
    return runInAction(name, innerAction);
  } else {
    return runInAction(innerAction);
  }
}

/**
 * @ignore
 * @internal
 */

var InternalPatchRecorder =
/*#__PURE__*/
function () {
  function InternalPatchRecorder() {}

  var _proto = InternalPatchRecorder.prototype;

  _proto.record = function record(patches, invPatches) {
    this.patches = patches;
    this.invPatches = invPatches;
  };

  _proto.emit = function emit(obj) {
    emitPatch(obj, this.patches, this.invPatches, true);
  };

  return InternalPatchRecorder;
}();
var patchListeners =
/*#__PURE__*/
new WeakMap();
var globalPatchListeners = [];
/**
 * Adds a listener that will be called every time a patch is generated for the tree of the given target object.
 *
 * @param subtreeRoot Subtree root object of the patch listener.
 * @param listener The listener function that will be called everytime a patch is generated for the object or its children.
 * @returns A disposer to stop listening to patches.
 */

function onPatches(subtreeRoot, listener) {
  assertTweakedObject(subtreeRoot, "subtreeRoot");
  assertIsFunction(listener, "listener");

  if (!isAction(listener)) {
    listener = action(listener.name || "onPatchesListener", listener);
  }

  var listenersForObject = patchListeners.get(subtreeRoot);

  if (!listenersForObject) {
    listenersForObject = [];
    patchListeners.set(subtreeRoot, listenersForObject);
  }

  listenersForObject.push(listener);
  return function () {
    deleteFromArray(listenersForObject, listener);
  };
}
/**
 * Adds a listener that will be called every time a patch is generated anywhere.
 * Usually prefer using `onPatches`.
 *
 * @param listener The listener function that will be called everytime a patch is generated anywhere.
 * @returns A disposer to stop listening to patches.
 */

function onGlobalPatches(listener) {
  assertIsFunction(listener, "listener");

  if (!isAction(listener)) {
    listener = action(listener.name || "onGlobalPatchesListener", listener);
  }

  globalPatchListeners.push(listener);
  return function () {
    deleteFromArray(globalPatchListeners, listener);
  };
}

function emitPatch(obj, patches, inversePatches, emitGlobally) {
  if (patches.length <= 0 && inversePatches.length <= 0) {
    return;
  } // first emit global listeners


  if (emitGlobally) {
    for (var i = 0; i < globalPatchListeners.length; i++) {
      var listener = globalPatchListeners[i];
      listener(obj, patches, inversePatches);
    }
  } // then per subtree listeners


  var listenersForObject = patchListeners.get(obj);

  if (listenersForObject) {
    for (var _i = 0; _i < listenersForObject.length; _i++) {
      var _listener = listenersForObject[_i];

      _listener(patches, inversePatches);
    }
  } // and also emit subtree listeners all the way to the root


  var parentPath = fastGetParentPath(obj);

  if (parentPath) {
    // tweak patches so they include the child path
    var childPath = parentPath.path;
    var newPatches = patches.map(function (p) {
      return addPathToPatch(p, childPath);
    });
    var newInversePatches = inversePatches.map(function (p) {
      return addPathToPatch(p, childPath);
    }); // false to avoid emitting global patches again for the same change

    emitPatch(parentPath.parent, newPatches, newInversePatches, false);
  }
}

function addPathToPatch(patch, path) {
  return _extends({}, patch, {
    path: [path].concat(patch.path)
  });
}

/**
 * Should freeze and plain json checks be done when creating the frozen object?
 */

var FrozenCheckMode;

(function (FrozenCheckMode) {
  /** Only when in dev mode */
  FrozenCheckMode["DevModeOnly"] = "devModeOnly";
  /** Always */

  FrozenCheckMode["On"] = "on";
  /** Never */

  FrozenCheckMode["Off"] = "off";
})(FrozenCheckMode || (FrozenCheckMode = {}));
/**
 * @ignore
 */


var frozenKey = "$frozen";
/**
 * A class that contains frozen data.
 * Use `frozen` to create an instance of this class.
 *
 * @typeparam T Data type.
 */

var Frozen =
/**
 * Creates an instance of Frozen.
 * Do not use directly, use `frozen` instead.
 *
 * @param dataToFreeze
 * @param checkMode
 */
function Frozen(dataToFreeze, checkMode) {
  if (checkMode === void 0) {
    checkMode = FrozenCheckMode.DevModeOnly;
  }

  var check = checkMode === FrozenCheckMode.On || checkMode === FrozenCheckMode.DevModeOnly && inDevMode();

  if (check) {
    checkDataIsSerializableAndFreeze(dataToFreeze);
  }

  this.data = dataToFreeze;

  if (check) {
    Object.freeze(this.data);
  }

  tweak(this, undefined);
};
/**
 * Marks some data as frozen. Frozen data becomes immutable (at least in dev mode), and is not enhanced
 * with capabilities such as getting the parent of the objects (except for the root object), it is not
 * made deeply observable (though the root object is observable by reference), etc.
 * On the other hand, this means it will be much faster to create/access. Use this for big data pieces
 * that are unlikely to change unless all of them change (for example lists of points for a polygon, etc).
 *
 * Note that data passed to frozen must be serializable to JSON, this is:
 * - primitive, plain object, or array
 * - without cycles
 *
 * @param data
 * @param checkMode
 */

function frozen(data, checkMode) {
  if (checkMode === void 0) {
    checkMode = FrozenCheckMode.DevModeOnly;
  }

  return new Frozen(data, checkMode);
}

function checkDataIsSerializableAndFreeze(data) {
  // TODO: detect cycles and throw if present?
  // primitives are ok
  if (isPrimitive(data)) {
    return;
  }

  if (Array.isArray(data)) {
    var arrLen = data.length;

    for (var i = 0; i < arrLen; i++) {
      var v = data[i];

      if (v === undefined) {
        throw failure("undefined is not supported inside arrays since it is not serializable in JSON, consider using null instead");
      }

      checkDataIsSerializableAndFreeze(v);
    }

    Object.freeze(data);
    return;
  }

  if (isPlainObject(data)) {
    var dataKeys = Object.keys(data);
    var dataKeysLen = dataKeys.length;

    for (var _i = 0; _i < dataKeysLen; _i++) {
      var k = dataKeys[_i];
      var _v = data[k];
      checkDataIsSerializableAndFreeze(k);
      checkDataIsSerializableAndFreeze(_v);
    }

    Object.freeze(data);
    return;
  }

  throw failure("frozen data must be plainly serializable to JSON, but " + data + " is not");
}
/**
 * @ignore
 * @internal
 *
 * Checks if an snapshot is an snapshot for a frozen data.
 *
 * @param snapshot
 * @returns
 */


function isFrozenSnapshot(snapshot) {
  return isPlainObject(snapshot) && !!snapshot[frozenKey];
}

/**
 * Iterates through all the parents (from the nearest until the root)
 * until one of them matches the given predicate.
 * If the predicate is matched it will return the found node.
 * If none is found it will return undefined.
 *
 * @typeparam T Parent object type.
 * @param child Target object.
 * @param predicate Function that will be run for every parent of the target object, from immediate parent to the root.
 * @param maxDepth Max depth, or 0 for infinite.
 * @returns
 */

function findParent(child, predicate, maxDepth) {
  if (maxDepth === void 0) {
    maxDepth = 0;
  }

  var foundParentPath = findParentPath(child, predicate, maxDepth);
  return foundParentPath ? foundParentPath.parent : undefined;
}
/**
 * Iterates through all the parents (from the nearest until the root)
 * until one of them matches the given predicate.
 * If the predicate is matched it will return the found node plus the
 * path to get from the parent to the child.
 * If none is found it will return undefined.
 *
 * @typeparam T Parent object type.
 * @param child Target object.
 * @param predicate Function that will be run for every parent of the target object, from immediate parent to the root.
 * @param maxDepth Max depth, or 0 for infinite.
 * @returns
 */

function findParentPath(child, predicate, maxDepth) {
  if (maxDepth === void 0) {
    maxDepth = 0;
  }

  assertTweakedObject(child, "child");
  var path = [];
  var current = child;
  var depth = 0;
  var parentPath;

  while (parentPath = fastGetParentPath(current)) {
    path.unshift(parentPath.path);
    current = parentPath.parent;

    if (predicate(current)) {
      return {
        parent: current,
        path: path
      };
    }

    depth++;

    if (maxDepth > 0 && depth === maxDepth) {
      break;
    }
  }

  return undefined;
}

/**
 * A built-in action.
 */
var BuiltInAction;

(function (BuiltInAction) {
  /**
   * applyPatches
   */
  BuiltInAction["ApplyPatches"] = "$$applyPatches";
  /**
   * applySnapshot
   */

  BuiltInAction["ApplySnapshot"] = "$$applySnapshot";
  /**
   * detach
   */

  BuiltInAction["Detach"] = "$$detach";
})(BuiltInAction || (BuiltInAction = {}));

var builtInActionValues =
/*#__PURE__*/
new Set(
/*#__PURE__*/
Object.values(BuiltInAction));
/**
 * Returns if a given action name is a built-in action, this is, one of:
 * - applyPatches()
 * - applySnapshot()
 * - detach()
 *
 * @param actionName Action name to check.
 * @returns true if it is a built-in action, false otherwise.
 */

function isBuiltInAction(actionName) {
  return builtInActionValues.has(actionName);
}

/**
 * Detaches a given object from a tree.
 * If the parent is an object / model, detaching will delete the property.
 * If the parent is an array detaching will remove the node by splicing it.
 * If there's no parent it will throw.
 *
 * @param node Object to be detached.
 */

function detach(node) {
  assertTweakedObject(node, "node");
  wrappedInternalDetach.call(node);
}
var wrappedInternalDetach =
/*#__PURE__*/
wrapInAction(BuiltInAction.Detach, internalDetach, ActionContextActionType.Sync);

function internalDetach() {
  var node = this;
  var parentPath = fastGetParentPathIncludingDataObjects(node);
  if (!parentPath) return;
  var parent = parentPath.parent,
      path = parentPath.path;

  if (isObservableArray(parent)) {
    parent.splice(+path, 1);
  } else if (isObservableObject(parent)) {
    remove(parent, "" + path);
  } else {
    throw failure("parent must be an observable object or an observable array");
  }
}

/**
 * Returns all the children objects (this is, excluding primitives) of an object.
 *
 * @param node Object to get the list of children from.
 * @param [options] An optional object with the `deep` option (defaults to false) to true to get
 * the children deeply or false to get them shallowly.
 * @returns A readonly observable set with the children.
 */

function getChildrenObjects(node, options) {
  assertTweakedObject(node, "node");

  if (!options || !options.deep) {
    return getObjectChildren(node);
  } else {
    return getDeepObjectChildren(node).deep;
  }
}

/**
 * Runs a callback everytime a new object is attached to a given node.
 * The callback can optionally return a disposer which will be run when the child is detached.
 *
 * The optional options parameter accepts and object with the following options:
 * - `deep: boolean` (default: `false`) - true if the callback should be run for all children deeply
 * or false if it it should only run for shallow children.
 * - `fireForCurrentChildren: boolean` (default: `true`) - true if the callback should be immediately
 * called for currently attached children, false if only for future attachments.
 *
 * Returns a disposer, which has a boolean parameter which should be true if pending detachment
 * callbacks should be run or false otherwise.
 *
 * @param target Function that returns the object whose children should be tracked.
 * @param fn Callback called when a child is attached to the target object.
 * @param [options]
 * @returns
 */

function onChildAttachedTo(target, fn, options) {
  assertIsFunction(target, "target");
  assertIsFunction(fn, "fn");

  var opts = _extends({
    deep: false,
    runForCurrentChildren: true
  }, options);

  var detachDisposers = new WeakMap();

  var runDetachDisposer = function runDetachDisposer(n) {
    var detachDisposer = detachDisposers.get(n);

    if (detachDisposer) {
      detachDisposers["delete"](n);
      detachDisposer();
    }
  };

  var addDetachDisposer = function addDetachDisposer(n, disposer) {
    if (disposer) {
      detachDisposers.set(n, disposer);
    }
  };

  var getChildrenObjectOpts = {
    deep: opts.deep
  };

  var getCurrentChildren = function getCurrentChildren() {
    var t = target();
    assertTweakedObject(t, "target()");
    var children = getChildrenObjects(t, getChildrenObjectOpts);
    var set = new Set();
    var iter = children.values();
    var cur = iter.next();

    while (!cur.done) {
      set.add(cur.value);
      cur = iter.next();
    }

    return set;
  };

  var currentChildren = opts.runForCurrentChildren ? new Set() : getCurrentChildren();
  var disposer = reaction(function () {
    return getCurrentChildren();
  }, function (newChildren) {
    var disposersToRun = []; // find dead

    var currentChildrenIter = currentChildren.values();
    var currentChildrenCur = currentChildrenIter.next();

    while (!currentChildrenCur.done) {
      var n = currentChildrenCur.value;

      if (!newChildren.has(n)) {
        currentChildren["delete"](n); // we should run it in inverse order

        disposersToRun.push(n);
      }

      currentChildrenCur = currentChildrenIter.next();
    }

    if (disposersToRun.length > 0) {
      for (var i = disposersToRun.length - 1; i >= 0; i--) {
        runDetachDisposer(disposersToRun[i]);
      }
    } // find new


    var newChildrenIter = newChildren.values();
    var newChildrenCur = newChildrenIter.next();

    while (!newChildrenCur.done) {
      var _n = newChildrenCur.value;

      if (!currentChildren.has(_n)) {
        currentChildren.add(_n);
        addDetachDisposer(_n, fn(_n));
      }

      newChildrenCur = newChildrenIter.next();
    }
  }, {
    fireImmediately: true
  });
  return function (runDetachDisposers) {
    disposer();

    if (runDetachDisposers) {
      var currentChildrenIter = currentChildren.values();
      var currentChildrenCur = currentChildrenIter.next();

      while (!currentChildrenCur.done) {
        var n = currentChildrenCur.value;
        runDetachDisposer(n);
        currentChildrenCur = currentChildrenIter.next();
      }
    }

    currentChildren.clear();
  };
}

/**
 * Deserializers a data structure from its snapshot form.
 *
 * @typeparam T Object type.
 * @param snapshot Snapshot, even if a primitive.
 * @param [options] Options.
 * @returns The deserialized object.
 */

var fromSnapshot = function fromSnapshot(snapshot, options) {
  var opts = _extends({
    generateNewIds: false,
    overrideRootModelId: undefined
  }, options);

  var ctx = {
    options: opts
  };
  ctx.snapshotToInitialData = snapshotToInitialData.bind(undefined, ctx);
  return internalFromSnapshot(snapshot, ctx);
};
fromSnapshot =
/*#__PURE__*/
action("fromSnapshot", fromSnapshot);

function internalFromSnapshot(sn, ctx) {
  if (isPrimitive(sn)) {
    return sn;
  }

  if (isMap(sn)) {
    throw failure("a snapshot must not contain maps");
  }

  if (isSet(sn)) {
    throw failure("a snapshot must not contain sets");
  }

  if (isArray(sn)) {
    return fromArraySnapshot(sn, ctx);
  }

  if (isFrozenSnapshot(sn)) {
    return frozen(sn.data);
  }

  if (isModelSnapshot(sn)) {
    return fromModelSnapshot(sn, ctx);
  }

  if (isPlainObject(sn)) {
    return fromPlainObjectSnapshot(sn, ctx);
  }

  throw failure("unsupported snapshot - " + sn);
}

function fromArraySnapshot(sn, ctx) {
  var arr = observable.array([], observableOptions);
  var ln = sn.length;

  for (var i = 0; i < ln; i++) {
    arr.push(internalFromSnapshot(sn[i], ctx));
  }

  return tweakArray(arr, undefined, true);
}

function fromModelSnapshot(sn, ctx) {
  var type = sn[modelTypeKey];

  if (!type) {
    throw failure("a model snapshot must contain a type key (" + modelTypeKey + "), but none was found");
  }

  var modelInfo = getModelInfoForName(type);

  if (!modelInfo) {
    throw failure("model with name \"" + type + "\" not found in the registry");
  }

  if (!sn[modelIdKey]) {
    throw failure("a model snapshot must contain an id key (" + modelIdKey + "), but none was found");
  }

  return new modelInfo["class"](undefined, {
    unprocessedSnapshot: sn,
    snapshotToInitialData: ctx.snapshotToInitialData
  }, ctx.options.generateNewIds);
}

function snapshotToInitialData(ctx, processedSn) {
  var initialData = observable.object({}, undefined, observableOptions);
  var processedSnKeys = Object.keys(processedSn);
  var processedSnKeysLen = processedSnKeys.length;

  for (var i = 0; i < processedSnKeysLen; i++) {
    var k = processedSnKeys[i];

    if (!isReservedModelKey(k)) {
      var v = processedSn[k];
      set(initialData, k, internalFromSnapshot(v, ctx));
    }
  }

  return initialData;
}

function fromPlainObjectSnapshot(sn, ctx) {
  var plainObj = observable.object({}, undefined, observableOptions);
  var snKeys = Object.keys(sn);
  var snKeysLen = snKeys.length;

  for (var i = 0; i < snKeysLen; i++) {
    var k = snKeys[i];
    var v = sn[k];
    set(plainObj, k, internalFromSnapshot(v, ctx));
  }

  return tweakPlainObject(plainObj, undefined, undefined, true, false);
}

var observableOptions = {
  deep: false
};

/**
 * @ignore
 */

function reconcileSnapshot(value, sn, modelPool) {
  if (isPrimitive(sn)) {
    return sn;
  }

  if (isArray(sn)) {
    return reconcileArraySnapshot(value, sn, modelPool);
  }

  if (isFrozenSnapshot(sn)) {
    return reconcileFrozenSnapshot(value, sn);
  }

  if (isModelSnapshot(sn)) {
    return reconcileModelSnapshot(value, sn, modelPool);
  }

  if (isPlainObject(sn)) {
    return reconcilePlainObjectSnapshot(value, sn, modelPool);
  }

  if (isMap(sn)) {
    throw failure("a snapshot must not contain maps");
  }

  if (isSet(sn)) {
    throw failure("a snapshot must not contain sets");
  }

  throw failure("unsupported snapshot - " + sn);
}

function reconcileArraySnapshot(value, sn, modelPool) {
  if (!isArray(value)) {
    // no reconciliation possible
    return fromSnapshot(sn);
  } // remove excess items


  if (value.length > sn.length) {
    value.splice(sn.length, value.length - sn.length);
  } // reconcile present items


  for (var i = 0; i < value.length; i++) {
    var oldValue = value[i];
    var newValue = reconcileSnapshot(oldValue, sn[i], modelPool);
    detachIfNeeded(newValue, oldValue, modelPool);
    set(value, i, newValue);
  } // add excess items


  for (var _i = value.length; _i < sn.length; _i++) {
    value.push(reconcileSnapshot(undefined, sn[_i], modelPool));
  }

  return value;
}

function reconcileFrozenSnapshot(value, sn) {
  // reconciliation is only possible if the target is a Frozen instance with the same data (by ref)
  // in theory we could compare the JSON representation of both datas or do a deep comparison, but that'd be too slow
  if (value instanceof Frozen && value.data === sn.data) {
    return value;
  }

  return frozen(sn.data);
}

function reconcileModelSnapshot(value, sn, modelPool) {
  var type = sn[modelTypeKey];
  var modelInfo = getModelInfoForName(type);

  if (!modelInfo) {
    throw failure("model with name \"" + type + "\" not found in the registry");
  }

  var id = sn[modelIdKey]; // try to use model from pool if possible

  var modelInPool = modelPool.findModelForSnapshot(sn);

  if (modelInPool) {
    value = modelInPool;
  }

  if (!(value instanceof modelInfo["class"]) || value[modelTypeKey] !== type || value[modelIdKey] !== id) {
    // different kind of model / model instance, no reconciliation possible
    return fromSnapshot(sn);
  }

  var modelObj = value;
  var processedSn = sn;

  if (modelObj.fromSnapshot) {
    processedSn = modelObj.fromSnapshot(sn);
  }

  var data = modelObj.$; // remove excess props

  var dataKeys = Object.keys(data);
  var dataKeysLen = dataKeys.length;

  for (var i = 0; i < dataKeysLen; i++) {
    var k = dataKeys[i];

    if (!(k in processedSn)) {
      remove(data, k);
    }
  } // reconcile the rest


  var processedSnKeys = Object.keys(processedSn);
  var processedSnKeysLen = processedSnKeys.length;

  for (var _i2 = 0; _i2 < processedSnKeysLen; _i2++) {
    var _k = processedSnKeys[_i2];

    if (!isReservedModelKey(_k)) {
      var v = processedSn[_k];
      var oldValue = data[_k];
      var newValue = reconcileSnapshot(oldValue, v, modelPool);
      detachIfNeeded(newValue, oldValue, modelPool);
      set(data, _k, newValue);
    }
  }

  return modelObj;
}

function reconcilePlainObjectSnapshot(value, sn, modelPool) {
  // plain obj
  if (!isPlainObject(value) && !isObservableObject(value)) {
    // no reconciliation possible
    return fromSnapshot(sn);
  }

  var plainObj = value; // remove excess props

  var plainObjKeys = Object.keys(plainObj);
  var plainObjKeysLen = plainObjKeys.length;

  for (var i = 0; i < plainObjKeysLen; i++) {
    var k = plainObjKeys[i];

    if (!(k in sn)) {
      remove(plainObj, k);
    }
  } // reconcile the rest


  var snKeys = Object.keys(sn);
  var snKeysLen = snKeys.length;

  for (var _i3 = 0; _i3 < snKeysLen; _i3++) {
    var _k2 = snKeys[_i3];
    var v = sn[_k2];
    var oldValue = plainObj[_k2];
    var newValue = reconcileSnapshot(oldValue, v, modelPool);
    detachIfNeeded(newValue, oldValue, modelPool);
    set(plainObj, _k2, newValue);
  }

  return plainObj;
}

function detachIfNeeded(newValue, oldValue, modelPool) {
  // edge case for when we are swapping models around the tree
  if (newValue === oldValue) {
    // already where it should be
    return;
  }

  if (isModel(newValue) && modelPool.findModelByTypeAndId(newValue.$modelType, newValue.$modelId)) {
    var parentPath = fastGetParentPathIncludingDataObjects(newValue);

    if (parentPath) {
      set(parentPath.parent, parentPath.path, null);
    }
  }
}

var ModelPool =
/*#__PURE__*/
function () {
  function ModelPool(root) {
    // make sure we don't use the sub-data $ object
    root = dataObjectParent.get(root) || root;
    this.pool = getDeepObjectChildren(root).deepByModelTypeAndId;
  }

  var _proto = ModelPool.prototype;

  _proto.findModelByTypeAndId = function findModelByTypeAndId(modelType, modelId) {
    return this.pool.get(byModelTypeAndIdKey(modelType, modelId));
  };

  _proto.findModelForSnapshot = function findModelForSnapshot(sn) {
    if (!isModelSnapshot(sn)) {
      return undefined;
    }

    return this.findModelByTypeAndId(sn.$modelType, sn.$modelId);
  };

  return ModelPool;
}();

/**
 * Applies the given patches to the given target object.
 *
 * @param node Target object.
 * @param patches List of patches to apply.
 * @param reverse Whether patches are applied in reverse order.
 */

function applyPatches(node, patches, reverse) {
  if (reverse === void 0) {
    reverse = false;
  }

  assertTweakedObject(node, "node");

  if (patches.length <= 0) {
    return;
  }

  wrappedInternalApplyPatches.call(node, patches, reverse);
}
/**
 * @ignore
 * @internal
 */

function internalApplyPatches(patches, reverse) {
  if (reverse === void 0) {
    reverse = false;
  }

  var obj = this;
  var modelPool = new ModelPool(obj);

  if (reverse) {
    var i = patches.length;

    while (i--) {
      var p = patches[i];

      if (!isArray(p)) {
        applySinglePatch(obj, p, modelPool);
      } else {
        var j = p.length;

        while (j--) {
          applySinglePatch(obj, p[j], modelPool);
        }
      }
    }
  } else {
    var len = patches.length;

    for (var _i = 0; _i < len; _i++) {
      var _p = patches[_i];

      if (!isArray(_p)) {
        applySinglePatch(obj, _p, modelPool);
      } else {
        var len2 = _p.length;

        for (var _j = 0; _j < len2; _j++) {
          applySinglePatch(obj, _p[_j], modelPool);
        }
      }
    }
  }
}
var wrappedInternalApplyPatches =
/*#__PURE__*/
wrapInAction(BuiltInAction.ApplyPatches, internalApplyPatches, ActionContextActionType.Sync);

function applySinglePatch(obj, patch, modelPool) {
  var _pathArrayToObjectAnd = pathArrayToObjectAndProp(obj, patch.path),
      target = _pathArrayToObjectAnd.target,
      prop = _pathArrayToObjectAnd.prop;

  if (isArray(target)) {
    switch (patch.op) {
      case "add":
        {
          var index = +prop; // reconcile from the pool if possible

          var newValue = reconcileSnapshot(undefined, patch.value, modelPool);
          target.splice(index, 0, newValue);
          break;
        }

      case "remove":
        {
          var _index = +prop; // no reconciliation, removing


          target.splice(_index, 1);
          break;
        }

      case "replace":
        {
          if (prop === "length") {
            target.length = patch.value;
          } else {
            var _index2 = +prop; // try to reconcile


            var _newValue = reconcileSnapshot(target[_index2], patch.value, modelPool);

            set(target, _index2, _newValue);
          }

          break;
        }

      default:
        throw failure("unsupported patch operation: " + patch.op);
    }
  } else {
    switch (patch.op) {
      case "add":
        {
          // reconcile from the pool if possible
          var _newValue2 = reconcileSnapshot(undefined, patch.value, modelPool);

          set(target, prop, _newValue2);
          break;
        }

      case "remove":
        {
          // no reconciliation, removing
          remove(target, prop);
          break;
        }

      case "replace":
        {
          // try to reconcile
          // we don't need to tweak the pool since reconcileSnapshot will do that for us
          var _newValue3 = reconcileSnapshot(target[prop], patch.value, modelPool);

          set(target, prop, _newValue3);
          break;
        }

      default:
        throw failure("unsupported patch operation: " + patch.op);
    }
  }
}

function pathArrayToObjectAndProp(obj, path) {
  if (inDevMode()) {
    if (!isArray(path)) {
      throw failure("invalid path: " + path);
    }
  }

  var target = modelToDataNode(obj);

  if (path.length === 0) {
    return {
      target: target
    };
  }

  for (var i = 0; i <= path.length - 2; i++) {
    target = modelToDataNode(target[path[i]]);
  }

  return {
    target: target,
    prop: path[path.length - 1]
  };
}

/**
 * @ignore
 */

function runTypeCheckingAfterChange(obj, patchRecorder) {
  // invalidate type check cached result
  invalidateCachedTypeCheckerResult(obj);

  if (isModelAutoTypeCheckingEnabled()) {
    var parentModelWithTypeChecker = findNearestParentModelWithTypeChecker(obj);

    if (parentModelWithTypeChecker) {
      var err = parentModelWithTypeChecker.typeCheck();

      if (err) {
        // quietly apply inverse patches (do not generate patches, snapshots, actions, etc)
        runWithoutSnapshotOrPatches(function () {
          internalApplyPatches.call(obj, patchRecorder.invPatches, true);
        }); // at the end of apply patches it will be type checked again and its result cached once more

        err["throw"](parentModelWithTypeChecker);
      }
    }
  }
}
/**
 * @ignore
 *
 * Finds the closest parent model that has a type checker defined.
 *
 * @param child
 * @returns
 */

function findNearestParentModelWithTypeChecker(child) {
  // child might be .$, so we need to check the parent model in that case
  var actualChild = dataToModelNode(child);

  if (child !== actualChild) {
    child = actualChild;

    if (isModel(child) && !!getModelDataType(child)) {
      return child;
    }
  }

  return findParent(child, function (parent) {
    return isModel(parent) && !!getModelDataType(parent);
  });
}

/**
 * @ignore
 */

function tweakArray(value, parentPath, doNotTweakChildren) {
  var originalArr = value;
  var arrLn = originalArr.length;
  var tweakedArr = isObservableArray(originalArr) ? originalArr : observable.array([], observableOptions$1);

  if (tweakedArr !== originalArr) {
    tweakedArr.length = originalArr.length;
  }

  var interceptDisposer;
  var observeDisposer;

  var untweak = function untweak() {
    interceptDisposer();
    observeDisposer();
  };

  tweakedObjects.set(tweakedArr, untweak);
  setParent(tweakedArr, parentPath, false, false);
  var standardSn = [];
  standardSn.length = arrLn; // substitute initial values by proxied values

  for (var i = 0; i < arrLn; i++) {
    var v = originalArr[i];

    if (isPrimitive(v)) {
      if (!doNotTweakChildren) {
        set(tweakedArr, i, v);
      }

      standardSn[i] = v;
    } else {
      var path = {
        parent: tweakedArr,
        path: i
      };
      var tweakedValue = void 0;

      if (doNotTweakChildren) {
        tweakedValue = v;
        setParent(tweakedValue, path, false, false);
      } else {
        tweakedValue = tweak(v, path);
        set(tweakedArr, i, tweakedValue);
      }

      var valueSn = getInternalSnapshot(tweakedValue);
      standardSn[i] = valueSn.standard;
    }
  }

  setInternalSnapshot(tweakedArr, standardSn);
  interceptDisposer = intercept(tweakedArr, interceptArrayMutation.bind(undefined, tweakedArr));
  observeDisposer = observe(tweakedArr, arrayDidChange);
  return tweakedArr;
}

function arrayDidChange(change) {
  var arr = change.object;

  var _getInternalSnapshot = getInternalSnapshot(arr),
      oldSnapshot = _getInternalSnapshot.standard;

  var patchRecorder = new InternalPatchRecorder();
  var newSnapshot = oldSnapshot.slice();

  switch (change.type) {
    case "splice":
      {
        var index = change.index;
        var addedCount = change.addedCount;
        var removedCount = change.removedCount;
        var addedItems = [];
        addedItems.length = addedCount;

        for (var i = 0; i < addedCount; i++) {
          var v = change.added[i];

          if (isPrimitive(v)) {
            addedItems[i] = v;
          } else {
            addedItems[i] = getInternalSnapshot(v).standard;
          }
        }

        var oldLen = oldSnapshot.length;
        newSnapshot.splice.apply(newSnapshot, [index, removedCount].concat(addedItems));
        var patches = [];
        var invPatches = []; // optimization: if we add as many as we remove then replace instead

        if (addedCount === removedCount) {
          for (var _i = 0; _i < addedCount; _i++) {
            var realIndex = index + _i;
            var newVal = newSnapshot[realIndex];
            var oldVal = oldSnapshot[realIndex];

            if (newVal !== oldVal) {
              var path = [realIndex]; // replace 0, 1, 2...

              patches.push({
                op: "replace",
                path: path,
                value: newVal
              }); // replace ...2, 1, 0 since inverse patches are applied in reverse

              invPatches.push({
                op: "replace",
                path: path,
                value: oldVal
              });
            }
          }
        } else {
          var interimLen = oldLen - removedCount; // first remove items

          if (removedCount > 0) {
            // optimization, when removing from the end set the length instead
            var removeUsingSetLength = index >= interimLen;

            if (removeUsingSetLength) {
              patches.push({
                op: "replace",
                path: ["length"],
                value: interimLen
              });
            }

            for (var _i2 = removedCount - 1; _i2 >= 0; _i2--) {
              var _realIndex = index + _i2;

              var _path = [_realIndex];

              if (!removeUsingSetLength) {
                // remove ...2, 1, 0
                patches.push({
                  op: "remove",
                  path: _path
                });
              } // add 0, 1, 2... since inverse patches are applied in reverse


              invPatches.push({
                op: "add",
                path: _path,
                value: oldSnapshot[_realIndex]
              });
            }
          } // then add items


          if (addedCount > 0) {
            // optimization, for inverse patches, when adding from the end set the length to restore instead
            var restoreUsingSetLength = index >= interimLen;

            if (restoreUsingSetLength) {
              invPatches.push({
                op: "replace",
                path: ["length"],
                value: interimLen
              });
            }

            for (var _i3 = 0; _i3 < addedCount; _i3++) {
              var _realIndex2 = index + _i3;

              var _path2 = [_realIndex2]; // add 0, 1, 2...

              patches.push({
                op: "add",
                path: _path2,
                value: newSnapshot[_realIndex2]
              }); // remove ...2, 1, 0 since inverse patches are applied in reverse

              if (!restoreUsingSetLength) {
                invPatches.push({
                  op: "remove",
                  path: _path2
                });
              }
            }
          }
        }

        patchRecorder.record(patches, invPatches);
      }
      break;

    case "update":
      {
        var k = change.index;
        var val = change.newValue;
        var _oldVal = newSnapshot[k];

        if (isPrimitive(val)) {
          newSnapshot[k] = val;
        } else {
          var valueSn = getInternalSnapshot(val);
          newSnapshot[k] = valueSn.standard;
        }

        var _path3 = [k];
        patchRecorder.record([{
          op: "replace",
          path: _path3,
          value: newSnapshot[k]
        }], [{
          op: "replace",
          path: _path3,
          value: _oldVal
        }]);
      }
      break;
  }

  runTypeCheckingAfterChange(arr, patchRecorder);

  if (!runningWithoutSnapshotOrPatches) {
    setInternalSnapshot(arr, newSnapshot);
    patchRecorder.emit(arr);
  }
}

var undefinedInsideArrayErrorMsg = "undefined is not supported inside arrays since it is not serializable in JSON, consider using null instead"; // TODO: remove array parameter and just use change.object once mobx update event is fixed

function interceptArrayMutation(array, change) {
  assertCanWrite();

  switch (change.type) {
    case "splice":
      {
        if (inDevMode()) {
          var len = change.added.length;

          for (var i = 0; i < len; i++) {
            var v = change.added[i];

            if (v === undefined) {
              throw failure(undefinedInsideArrayErrorMsg);
            }
          }
        }

        for (var _i4 = 0; _i4 < change.removedCount; _i4++) {
          var removedValue = change.object[change.index + _i4];
          tweak(removedValue, undefined);
          tryUntweak(removedValue);
        }

        for (var _i5 = 0; _i5 < change.added.length; _i5++) {
          change.added[_i5] = tweak(change.added[_i5], {
            parent: change.object,
            path: change.index + _i5
          });
        } // we might also need to update the parent of the next indexes


        var oldNextIndex = change.index + change.removedCount;
        var newNextIndex = change.index + change.added.length;

        if (oldNextIndex !== newNextIndex) {
          for (var _i6 = oldNextIndex, j = newNextIndex; _i6 < change.object.length; _i6++, j++) {
            setParent(change.object[_i6], {
              parent: change.object,
              path: j
            }, true, false);
          }
        }
      }
      break;

    case "update":
      if (inDevMode() && change.newValue === undefined) {
        throw failure(undefinedInsideArrayErrorMsg);
      } // TODO: should be change.object, but mobx is bugged and doesn't send the proxy


      var oldVal = array[change.index];
      tweak(oldVal, undefined); // set old prop obj parent to undefined

      tryUntweak(oldVal);
      change.newValue = tweak(change.newValue, {
        parent: array,
        path: change.index
      });
      break;
  }

  return change;
}

var observableOptions$1 = {
  deep: false
};

/**
 * @ingore
 */

function tweakFrozen(frozenObj, parentPath) {
  var _setInternalSnapshot;

  tweakedObjects.set(frozenObj, undefined);
  setParent(frozenObj, parentPath, false, false); // we DON'T want data proxified, but the snapshot is the data itself

  setInternalSnapshot(frozenObj, (_setInternalSnapshot = {}, _setInternalSnapshot[frozenKey] = true, _setInternalSnapshot.data = frozenObj.data, _setInternalSnapshot));
  return frozenObj;
}

/**
 * Turns an object (array, plain object) into a tree node,
 * which then can accept calls to `getParent`, `getSnapshot`, etc.
 * If a tree node is passed it will return the passed argument directly.
 *
 * @param value Object to turn into a tree node.
 * @returns The object as a tree node.
 */

function toTreeNode(value) {
  if (!isObject(value)) {
    throw failure("only objects can be turned into tree nodes");
  }

  if (!isTweakedObject(value, true)) {
    return tweak(value, undefined);
  }

  return value;
}
/**
 * @ignore
 */

function internalTweak(value, parentPath) {
  if (isPrimitive(value)) {
    return value;
  }

  if (isTweakedObject(value, true)) {
    setParent(value, parentPath, false, false);
    return value;
  }

  if (isModel(value)) {
    return tweakModel(value, parentPath);
  }

  if (isArray(value)) {
    return tweakArray(value, parentPath, false);
  } // plain object


  if (isObservableObject(value) || isPlainObject(value)) {
    return tweakPlainObject(value, parentPath, undefined, false, false);
  }

  if (value instanceof Frozen) {
    return tweakFrozen(value, parentPath);
  } // unsupported


  if (isMap(value)) {
    throw failure("maps are not directly supported. consider applying 'transformObjectAsMap' over a '{[k: string]: V}' property, or 'transformArrayAsMap' over a '[string, V][]' property instead.");
  } // unsupported


  if (isSet(value)) {
    throw failure("sets are not directly supported. consider applying 'transformArrayAsSet' over a 'V[]' property instead.");
  }

  throw failure("tweak can only work over models, observable objects/arrays, or primitives, but got " + value + " instead");
}
/**
 * @ignore
 * @internal
 */


var tweak =
/*#__PURE__*/
action("tweak", internalTweak);
/**
 * @ignore
 * @internal
 */

function tryUntweak(value) {
  if (isPrimitive(value)) {
    return true;
  }

  if (inDevMode()) {
    if (fastGetParent(value)) {
      throw failure("assertion error: object cannot be untweaked while it has a parent");
    }
  }

  var untweaker = tweakedObjects.get(value);

  if (!untweaker) {
    return false;
  } // we have to make a copy since it will be changed
  // we have to iterate ourselves since it seems like babel does not do downlevel iteration


  var children = [];
  var childrenIter = getObjectChildren(value).values();
  var childrenCur = childrenIter.next();

  while (!childrenCur.done) {
    children.push(childrenCur.value);
    childrenCur = childrenIter.next();
  }

  for (var i = 0; i < children.length; i++) {
    var v = children[i];
    setParent(v, undefined, false, false);
  }

  untweaker();
  tweakedObjects["delete"](value);
  unsetInternalSnapshot(value);
  return true;
}

/**
 * @ignore
 */

function tweakPlainObject(value, parentPath, snapshotModelType, doNotTweakChildren, isDataObject) {
  var originalObj = value;
  var tweakedObj = isObservableObject(originalObj) ? originalObj : observable.object({}, undefined, observableOptions$2);
  var interceptDisposer;
  var observeDisposer;

  var untweak = function untweak() {
    interceptDisposer();
    observeDisposer();
  };

  tweakedObjects.set(tweakedObj, untweak);
  setParent(tweakedObj, parentPath, false, isDataObject);
  var standardSn = {}; // substitute initial values by tweaked values

  var originalObjKeys = Object.keys(originalObj);
  var originalObjKeysLen = originalObjKeys.length;

  for (var i = 0; i < originalObjKeysLen; i++) {
    var k = originalObjKeys[i];
    var v = originalObj[k];

    if (isPrimitive(v)) {
      if (!doNotTweakChildren) {
        set(tweakedObj, k, v);
      }

      standardSn[k] = v;
    } else {
      var path = {
        parent: tweakedObj,
        path: k
      };
      var tweakedValue = void 0;

      if (doNotTweakChildren) {
        tweakedValue = v;
        setParent(tweakedValue, path, false, false);
      } else {
        tweakedValue = tweak(v, path);
        set(tweakedObj, k, tweakedValue);
      }

      var valueSn = getInternalSnapshot(tweakedValue);
      standardSn[k] = valueSn.standard;
    }
  }

  if (snapshotModelType) {
    standardSn[modelTypeKey] = snapshotModelType;
  }

  setInternalSnapshot(isDataObject ? dataToModelNode(tweakedObj) : tweakedObj, standardSn);
  interceptDisposer = intercept(tweakedObj, interceptObjectMutation);
  observeDisposer = observe(tweakedObj, objectDidChange);
  return tweakedObj;
}
var observableOptions$2 = {
  deep: false
};

function objectDidChange(change) {
  var obj = change.object;
  var actualNode = dataToModelNode(obj);

  var _getInternalSnapshot = getInternalSnapshot(actualNode),
      standardSn = _getInternalSnapshot.standard;

  var patchRecorder = new InternalPatchRecorder();
  standardSn = Object.assign({}, standardSn);

  switch (change.type) {
    case "add":
    case "update":
      {
        var k = change.name;
        var val = change.newValue;
        var oldVal = standardSn[k];

        if (isPrimitive(val)) {
          standardSn[k] = val;
        } else {
          var valueSn = getInternalSnapshot(val);
          standardSn[k] = valueSn.standard;
        }

        var path = [k];

        if (change.type === "add") {
          patchRecorder.record([{
            op: "add",
            path: path,
            value: standardSn[k]
          }], [{
            op: "remove",
            path: path
          }]);
        } else {
          patchRecorder.record([{
            op: "replace",
            path: path,
            value: standardSn[k]
          }], [{
            op: "replace",
            path: path,
            value: oldVal
          }]);
        }
      }
      break;

    case "remove":
      {
        var _k = change.name;
        var _oldVal = standardSn[_k];
        delete standardSn[_k];
        var _path = [_k];
        patchRecorder.record([{
          op: "remove",
          path: _path
        }], [{
          op: "add",
          path: _path,
          value: _oldVal
        }]);
      }
      break;
  }

  runTypeCheckingAfterChange(obj, patchRecorder);

  if (!runningWithoutSnapshotOrPatches) {
    setInternalSnapshot(actualNode, standardSn);
    patchRecorder.emit(actualNode);
  }
}

function interceptObjectMutation(change) {
  assertCanWrite();

  if (typeof change.name === "symbol") {
    throw failure("symbol properties are not supported");
  }

  switch (change.type) {
    case "add":
      change.newValue = tweak(change.newValue, {
        parent: change.object,
        path: "" + change.name
      });
      break;

    case "remove":
      {
        var oldVal = change.object[change.name];
        tweak(oldVal, undefined);
        tryUntweak(oldVal);
        break;
      }

    case "update":
      {
        var _oldVal2 = change.object[change.name];
        tweak(_oldVal2, undefined);
        tryUntweak(_oldVal2);
        change.newValue = tweak(change.newValue, {
          parent: change.object,
          path: "" + change.name
        });
        break;
      }
  }

  return change;
}

/**
 * @ignore
 */

var internalNewModel =
/*#__PURE__*/
action("newModel", function (origModelObj, modelClass, initialData, snapshotInitialData, generateNewId) {
  if (inDevMode()) {
    assertIsModelClass(modelClass, "modelClass");
  }

  var modelObj = origModelObj;
  var modelInfo = modelInfoByClass.get(modelClass);

  if (!modelInfo) {
    throw failure("no model info for class " + modelClass.name + " could be found - did you forget to add the @model decorator?");
  }

  var id;

  if (snapshotInitialData) {
    var sn = snapshotInitialData.unprocessedSnapshot;

    if (generateNewId) {
      id = getGlobalConfig().modelIdGenerator();
    } else {
      id = sn[modelIdKey];
    }

    if (modelObj.fromSnapshot) {
      sn = modelObj.fromSnapshot(sn);
    }

    initialData = snapshotInitialData.snapshotToInitialData(sn);
  } else {
    // use symbol if provided
    if (initialData[modelIdKey]) {
      id = initialData[modelIdKey];
    } else {
      id = getGlobalConfig().modelIdGenerator();
    }
  }

  modelObj[modelTypeKey] = modelInfo.name; // fill in defaults in initial data

  var modelProps = modelClass[modelPropertiesSymbol];
  var modelPropsKeys = Object.keys(modelProps);

  for (var i = 0; i < modelPropsKeys.length; i++) {
    var k = modelPropsKeys[i];
    var v = initialData[k];

    if (v === undefined || v === null) {
      var newValue = v;
      var propData = modelProps[k];

      if (propData.defaultFn !== noDefaultValue) {
        newValue = propData.defaultFn();
      } else if (propData.defaultValue !== noDefaultValue) {
        newValue = propData.defaultValue;
      }

      set(initialData, k, newValue);
    }
  }

  set(initialData, modelIdKey, id);
  tweakModel(modelObj, undefined); // create observable data object with initial data

  var obsData = tweakPlainObject(initialData, {
    parent: modelObj,
    path: "$"
  }, modelObj[modelTypeKey], false, true); // hide $.$modelId

  Object.defineProperty(obsData, modelIdKey, _extends({}, Object.getOwnPropertyDescriptor(obsData, modelIdKey), {
    enumerable: false
  })); // link it, and make it readonly

  modelObj.$ = obsData;

  if (inDevMode()) {
    makePropReadonly(modelObj, "$", true);
  } // type check it if needed


  if (isModelAutoTypeCheckingEnabled() && getModelDataType(modelClass)) {
    var err = modelObj.typeCheck();

    if (err) {
      err["throw"](modelObj);
    }
  } // run any extra initializers for the class as needed


  var initializers = getModelClassInitializers(modelClass);

  if (initializers) {
    var len = initializers.length;

    for (var _i = 0; _i < len; _i++) {
      var init = initializers[_i];
      init(modelObj);
    }
  }

  return modelObj;
});
/**
 * @ignore
 */

function addModelClassInitializer(modelClass, init) {
  var initializers = modelClass[modelInitializersSymbol];

  if (!initializers) {
    initializers = [];
    modelClass[modelInitializersSymbol] = initializers;
  }

  initializers.push(init);
}

function getModelClassInitializers(modelClass) {
  return modelClass[modelInitializersSymbol];
}

/**
 * @ignore
 * @internal
 */

var modelInitializedSymbol =
/*#__PURE__*/
Symbol("modelInitialized");
/**
 * Base abstract class for models. Use `Model` instead when extending.
 *
 * Never override the constructor, use `onInit` or `onAttachedToRootStore` instead.
 *
 * @typeparam Data Data type.
 * @typeparam CreationData Creation data type.
 */

var BaseModel =
/*#__PURE__*/
function () {
  /**
   * Creates an instance of Model.
   */
  function BaseModel(data) {
    var initialData = data;
    var snapshotInitialData = arguments[1];
    var clazz = arguments[2];
    var propsWithTransforms = arguments[4];
    Object.setPrototypeOf(this, clazz.prototype);

    if (!snapshotInitialData) {
      // plain new
      assertIsObject(initialData, "initialData"); // apply transforms to initial data if needed

      var propsWithTransformsLen = propsWithTransforms.length;

      if (propsWithTransformsLen > 0) {
        initialData = Object.assign(initialData);

        for (var i = 0; i < propsWithTransformsLen; i++) {
          var propWithTransform = propsWithTransforms[i];
          var propName = propWithTransform[0];
          var propTransform = propWithTransform[1];
          var memoTransform = memoTransformCache.getOrCreateMemoTransform(this, propName, propTransform);
          initialData[propName] = memoTransform.dataToProp(initialData[propName]);
        }
      }

      internalNewModel(this, clazz, observable.object(initialData, undefined, {
        deep: false
      }), undefined, true);
    } else {
      // from snapshot
      var generateNewId = !!arguments[3];
      internalNewModel(this, clazz, undefined, snapshotInitialData, generateNewId);
    }
  }
  /**
   * Can be overriden to offer a reference id to be used in reference resolution.
   * By default it will use `$modelId`.
   */


  var _proto = BaseModel.prototype;

  _proto.getRefId = function getRefId() {
    return this[modelIdKey];
  }
  /**
   * Performs a type check over the model instance.
   * For this to work a data type has to be declared in the model decorator.
   *
   * @returns A `TypeCheckError` or `null` if there is no error.
   */
  ;

  _proto.typeCheck = function typeCheck$1() {
    var type = typesModel(this.constructor);
    return typeCheck(type, this);
  };

  _proto.toString = function toString(options) {
    var finalOptions = _extends({
      withData: true
    }, options);

    var firstPart = this.constructor.name + "#" + this[modelTypeKey];
    return finalOptions.withData ? "[" + firstPart + " " + JSON.stringify(getSnapshot(this)) + "]" : "[" + firstPart + "]";
  };

  return BaseModel;
}(); // these props will never be hoisted to this (except for model id)

/**
 * @internal
 */

var baseModelPropNames =
/*#__PURE__*/
new Set([modelTypeKey, modelIdKey, "onInit", "$", "getRefId", "onAttachedToRootStore", "fromSnapshot", "typeCheck"]);
/**
 * @deprecated Should not be needed anymore.
 *
 * Tricks Typescript into accepting abstract classes as a parameter for `ExtendedModel`.
 * Does nothing in runtime.
 *
 * @typeparam T Abstract model class type.
 * @param type Abstract model class.
 * @returns
 */

function abstractModelClass(type) {
  return type;
}
/**
 * Tricks Typescript into accepting a particular kind of generic class as a parameter for `ExtendedModel`.
 * Does nothing in runtime.
 *
 * @typeparam T Generic model class type.
 * @param type Generic model class.
 * @returns
 */

function modelClass(type) {
  return type;
}
/**
 * Add missing model metadata to a model creation snapshot to generate a proper model snapshot.
 * Usually used alongside `fromSnapshot`.
 *
 * @typeparam M Model type.
 * @param modelClass Model class.
 * @param snapshot Model creation snapshot without metadata.
 * @param [internalId] Model internal ID, or `undefined` to generate a new one.
 * @returns The model snapshot (including metadata).
 */

function modelSnapshotInWithMetadata(modelClass, snapshot, internalId) {
  var _extends2;

  if (internalId === void 0) {
    internalId = getGlobalConfig().modelIdGenerator();
  }

  assertIsModelClass(modelClass, "modelClass");
  assertIsObject(snapshot, "initialData");
  var modelInfo = modelInfoByClass.get(modelClass);
  return _extends({}, snapshot, (_extends2 = {}, _extends2[modelTypeKey] = modelInfo.name, _extends2[modelIdKey] = internalId, _extends2));
}
/**
 * Add missing model metadata to a model output snapshot to generate a proper model snapshot.
 * Usually used alongside `applySnapshot`.
 *
 * @typeparam M Model type.
 * @param modelClass Model class.
 * @param snapshot Model output snapshot without metadata.
 * @param [internalId] Model internal ID, or `undefined` to generate a new one.
 * @returns The model snapshot (including metadata).
 */

function modelSnapshotOutWithMetadata(modelClass, snapshot, internalId) {
  var _extends3;

  if (internalId === void 0) {
    internalId = getGlobalConfig().modelIdGenerator();
  }

  assertIsModelClass(modelClass, "modelClass");
  assertIsObject(snapshot, "initialData");
  var modelInfo = modelInfoByClass.get(modelClass);
  return _extends({}, snapshot, (_extends3 = {}, _extends3[modelTypeKey] = modelInfo.name, _extends3[modelIdKey] = internalId, _extends3));
}

/**
 * Checks if an object is a model instance.
 *
 * @param model
 * @returns
 */

function isModel(model) {
  return model instanceof BaseModel;
}
/**
 * @ignore
 * @internal
 *
 * Asserts something is actually a model.
 *
 * @param model
 * @param argName
 */

function assertIsModel(model, argName, customErrMsg) {
  if (customErrMsg === void 0) {
    customErrMsg = "must be a model instance";
  }

  if (!isModel(model)) {
    throw failure(argName + " " + customErrMsg);
  }
}
/**
 * @ignore
 * @internal
 */

function isModelClass(modelClass) {
  if (typeof modelClass !== "function") {
    return false;
  }

  if (modelClass !== BaseModel && !(modelClass.prototype instanceof BaseModel)) {
    return false;
  }

  return true;
}
/**
 * @ignore
 * @internal
 */

function assertIsModelClass(modelClass, argName) {
  if (typeof modelClass !== "function") {
    throw failure(argName + " must be a class");
  }

  if (modelClass !== BaseModel && !(modelClass.prototype instanceof BaseModel)) {
    throw failure(argName + " must extend Model");
  }
}
/**
 * @ignore
 * @internal
 */

function isModelSnapshot(sn) {
  return isPlainObject(sn) && !!sn[modelTypeKey];
}
/**
 * @ignore
 * @internal
 */

function checkModelDecoratorArgs(fnName, target, propertyKey) {
  if (typeof propertyKey !== "string") {
    throw failure(fnName + " cannot be used over symbol properties");
  }

  var errMessage = fnName + " must be used over model classes or instances";

  if (!target) {
    throw failure(errMessage);
  } // check target is a model object or extended class


  if (!(target instanceof BaseModel) && target !== BaseModel && !(target.prototype instanceof BaseModel)) {
    throw failure(errMessage);
  }
}

/**
 * Applies a full snapshot over an object, reconciling it with the current contents of the object.
 *
 * @typeparam T Object type.
 * @param node Target object (model object, object or array).
 * @param snapshot Snapshot to apply.
 */

function applySnapshot(node, snapshot) {
  assertTweakedObject(node, "node");
  assertIsObject(snapshot, "snapshot");
  wrappedInternalApplySnapshot.call(node, snapshot);
}

function internalApplySnapshot(sn) {
  var obj = this;

  var reconcile = function reconcile() {
    var modelPool = new ModelPool(obj);
    var ret = reconcileSnapshot(obj, sn, modelPool);

    if (inDevMode()) {
      if (ret !== obj) {
        throw failure("assertion error: reconciled object has to be the same");
      }
    }
  };

  if (isArray(sn)) {
    if (!isArray(obj)) {
      throw failure("if the snapshot is an array the target must be an array too");
    }

    return reconcile();
  }

  if (isFrozenSnapshot(sn)) {
    throw failure("applySnapshot cannot be used over frozen objects");
  }

  if (isModelSnapshot(sn)) {
    var type = sn[modelTypeKey];
    var modelInfo = getModelInfoForName(type);

    if (!modelInfo) {
      throw failure("model with name \"" + type + "\" not found in the registry");
    } // we don't check by actual instance since it might be a different one due to hot reloading


    if (!isModel(obj)) {
      // not a model instance, no reconciliation possible
      throw failure("the target for a model snapshot must be a model instance");
    }

    if (obj[modelTypeKey] !== type) {
      // different kind of model, no reconciliation possible
      throw failure("snapshot model type '" + type + "' does not match target model type '" + obj[modelTypeKey] + "'");
    }

    var id = sn[modelIdKey];

    if (obj[modelIdKey] !== id) {
      // different id, no reconciliation possible
      throw failure("snapshot model id '" + id + "' does not match target model id '" + obj[modelIdKey] + "'");
    }

    return reconcile();
  }

  if (isPlainObject(sn)) {
    if (!isPlainObject(obj) && !isObservableObject(obj)) {
      // no reconciliation possible
      throw failure("if the snapshot is an object the target must be an object too");
    }

    return reconcile();
  }

  throw failure("unsupported snapshot - " + sn);
}

var wrappedInternalApplySnapshot =
/*#__PURE__*/
wrapInAction(BuiltInAction.ApplySnapshot, internalApplySnapshot, ActionContextActionType.Sync);

/**
 * Applies (runs) an action over a target object.
 *
 * If you intend to apply serialized actions check one of the `applySerializedAction` methods instead.
 *
 * @param subtreeRoot Subtree root target object to run the action over.
 * @param call The action, usually as coming from `onActionMiddleware`.
 * @returns The return value of the action, if any.
 */

function applyAction(subtreeRoot, call) {
  if (call.serialized) {
    throw failure("cannot apply a serialized action call, use one of the 'applySerializedAction' methods instead");
  }

  assertTweakedObject(subtreeRoot, "subtreeRoot"); // resolve path while checking ids

  var _resolvePathCheckingI = resolvePathCheckingIds(subtreeRoot, call.targetPath, call.targetPathIds),
      current = _resolvePathCheckingI.value,
      resolved = _resolvePathCheckingI.resolved;

  if (!resolved) {
    throw failure("object at path " + JSON.stringify(call.targetPath) + " with ids " + JSON.stringify(call.targetPathIds) + " could not be resolved");
  }

  assertIsModel(current, "resolved " + current);

  if (isBuiltInAction(call.actionName)) {
    switch (call.actionName) {
      case BuiltInAction.ApplySnapshot:
        return applySnapshot.apply(current, [current].concat(call.args));

      case BuiltInAction.ApplyPatches:
        return applyPatches.apply(current, [current].concat(call.args));

      case BuiltInAction.Detach:
        return detach.apply(current, [current].concat(call.args));

      default:
        throw failure("assertion error: unknown built-in action - " + call.actionName);
    }
  } else if (isHookAction(call.actionName)) {
    throw failure("calls to hooks (" + call.actionName + ") cannot be applied");
  } else {
    return current[call.actionName].apply(current, call.args);
  }
}

var modelFlowSymbol =
/*#__PURE__*/
Symbol("modelFlow");

function flow(name, generator) {
  // Implementation based on https://github.com/tj/co/blob/master/index.js
  var flowFn = function flowFn() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var self = this;
    var previousAsyncStepContext;

    var ctxOverride = function ctxOverride(stepType) {
      return function (ctx) {
        ctx.previousAsyncStepContext = previousAsyncStepContext;
        ctx.spawnAsyncStepContext = previousAsyncStepContext ? previousAsyncStepContext.spawnAsyncStepContext : ctx;
        ctx.asyncStepType = stepType;
        ctx.args = args;
        previousAsyncStepContext = ctx;
      };
    };

    var generatorRun = false;
    var gen = wrapInAction(name, function () {
      generatorRun = true;
      return generator.apply(self, args);
    }, ActionContextActionType.Async, ctxOverride(ActionContextAsyncStepType.Spawn)).apply(self);

    if (!generatorRun) {
      // maybe it got overridden into a sync action
      return gen instanceof Promise ? gen : Promise.resolve(gen);
    } // use bound functions to fix es6 compilation


    var genNext = gen.next.bind(gen);
    var genThrow = gen["throw"].bind(gen);
    var promise = new Promise(function (resolve, reject) {
      function onFulfilled(res) {
        var ret;

        try {
          ret = wrapInAction(name, genNext, ActionContextActionType.Async, ctxOverride(ActionContextAsyncStepType.Resume)).call(self, res);
        } catch (e) {
          wrapInAction(name, function (err) {
            // we use a flow finisher to allow middlewares to tweak the return value before resolution
            return {
              value: err,
              resolution: "reject",
              accepter: resolve,
              rejecter: reject
            };
          }, ActionContextActionType.Async, ctxOverride(ActionContextAsyncStepType.Throw), true).call(self, e);
          return;
        }

        next(ret);
      }

      function onRejected(err) {
        var ret;

        try {
          ret = wrapInAction(name, genThrow, ActionContextActionType.Async, ctxOverride(ActionContextAsyncStepType.ResumeError)).call(self, err);
        } catch (e) {
          wrapInAction(name, function (err) {
            // we use a flow finisher to allow middlewares to tweak the return value before resolution
            return {
              value: err,
              resolution: "reject",
              accepter: resolve,
              rejecter: reject
            };
          }, ActionContextActionType.Async, ctxOverride(ActionContextAsyncStepType.Throw), true).call(self, e);
          return;
        }

        next(ret);
      }

      function next(ret) {
        if (ret && typeof ret.then === "function") {
          // an async iterator
          ret.then(next, reject);
        } else if (ret.done) {
          // done
          wrapInAction(name, function (val) {
            // we use a flow finisher to allow middlewares to tweak the return value before resolution
            return {
              value: val,
              resolution: "accept",
              accepter: resolve,
              rejecter: reject
            };
          }, ActionContextActionType.Async, ctxOverride(ActionContextAsyncStepType.Return), true).call(self, ret.value);
        } else {
          // continue
          Promise.resolve(ret.value).then(onFulfilled, onRejected);
        }
      }

      onFulfilled(undefined); // kick off the process
    });
    return promise;
  };

  flowFn[modelFlowSymbol] = true;
  return flowFn;
}
/**
 * Returns if the given function is a model flow or not.
 *
 * @param fn Function to check.
 * @returns
 */


function isModelFlow(fn) {
  return typeof fn === "function" && fn[modelFlowSymbol];
}
/**
 * Decorator that turns a function generator into a model flow.
 *
 * @param target
 * @param propertyKey
 * @param [baseDescriptor]
 * @returns
 */

function modelFlow(target, propertyKey, baseDescriptor) {
  return decorateWrapMethodOrField("modelFlow", {
    target: target,
    propertyKey: propertyKey,
    baseDescriptor: baseDescriptor
  }, function (data, fn) {
    if (isModelFlow(fn)) {
      return fn;
    } else {
      checkModelFlowArgs(data.target, data.propertyKey, fn);
      return flow(data.propertyKey, fn);
    }
  });
}

function checkModelFlowArgs(target, propertyKey, value) {
  if (typeof value !== "function") {
    throw failure("modelFlow has to be used over functions");
  }

  checkModelDecoratorArgs("modelFlow", target, propertyKey);
}
/**
 * Tricks the TS compiler into thinking that a model flow generator function can be awaited
 * (is a promise).
 *
 * @typeparam A Function arguments.
 * @typeparam R Return value.
 * @param fn Flow function.
 * @returns
 */


function _async(fn) {
  return fn;
}
/**
 * Makes a promise a flow, so it can be awaited with yield*.
 *
 * @typeparam T Promise return type.
 * @param promise Promise.
 * @returns
 */

function _await(promise) {
  return promiseGenerator.call(promise);
}
/*
function* promiseGenerator<T>(
  this: Promise<T>
) {
  const ret: T = yield this
  return ret
}
*/
// above code but compiled by TS for ES5
// so we don't include a dependency to regenerator runtime

var __generator = function __generator(thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

function promiseGenerator() {
  var ret;
  return __generator(this, function (_a) {
    switch (_a.label) {
      case 0:
        return [4
        /*yield*/
        , this];

      case 1:
        ret = _a.sent();
        return [2
        /*return*/
        , ret];

      default:
        return;
    }
  });
}

var cannotSerialize =
/*#__PURE__*/
Symbol("cannotSerialize");

var arraySerializer = {
  id: "mobx-keystone/array",
  serialize: function serialize(value, _serialize) {
    if (!isArray(value)) return cannotSerialize; // this will also transform observable arrays into non-observable ones

    return value.map(_serialize);
  },
  deserialize: function deserialize(arr, _deserialize) {
    return arr.map(_deserialize);
  }
};

var dateSerializer = {
  id: "mobx-keystone/dateAsTimestamp",
  serialize: function serialize(date) {
    if (!(date instanceof Date)) return cannotSerialize;
    return +date;
  },
  deserialize: function deserialize(timestamp) {
    return new Date(timestamp);
  }
};

var mapSerializer = {
  id: "mobx-keystone/mapAsArray",
  serialize: function serialize(map, _serialize) {
    if (!(map instanceof Map) && !isObservableMap(map)) return cannotSerialize;
    var arr = [];
    var iter = map.keys();
    var cur = iter.next();

    while (!cur.done) {
      var k = cur.value;
      var v = map.get(k);
      arr.push([_serialize(k), _serialize(v)]);
      cur = iter.next();
    }

    return arr;
  },
  deserialize: function deserialize(arr, _deserialize) {
    var map = new Map();
    var len = arr.length;

    for (var i = 0; i < len; i++) {
      var k = arr[i][0];
      var v = arr[i][1];
      map.set(_deserialize(k), _deserialize(v));
    }

    return map;
  }
};

/**
 * @ignore
 */

function rootPathToTargetPathIds(rootPath) {
  var targetPathIds = [];

  for (var i = 0; i < rootPath.path.length; i++) {
    var targetObj = rootPath.pathObjects[i + 1]; // first is root, we don't care about its ID

    var targetObjId = isModel(targetObj) ? targetObj.$modelId : null;
    targetPathIds.push(targetObjId);
  }

  return targetPathIds;
}
/**
 * @ignore
 */

function pathToTargetPathIds(root, path) {
  var targetPathIds = [];
  var current = root; // we don't care about the root ID

  for (var i = 0; i < path.length; i++) {
    current = current[path[i]];
    var targetObjId = isModel(current) ? current.$modelId : null;
    targetPathIds.push(targetObjId);
  }

  return targetPathIds;
}

var objectPathSerializer = {
  id: "mobx-keystone/objectPath",
  serialize: function serialize(value, _, targetRoot) {
    if (typeof value !== "object" || value === null || !isTweakedObject(value, false)) return cannotSerialize; // try to serialize a ref to its path if possible instead

    if (targetRoot) {
      var rootPath = fastGetRootPath(value);

      if (rootPath.root === targetRoot) {
        return {
          targetPath: rootPath.path,
          targetPathIds: rootPathToTargetPathIds(rootPath)
        };
      }
    }

    return cannotSerialize;
  },
  deserialize: function deserialize(ref, _, targetRoot) {
    // try to resolve the node back
    if (targetRoot) {
      var result = resolvePathCheckingIds(targetRoot, ref.targetPath, ref.targetPathIds);

      if (result.resolved) {
        return result.value;
      }
    }

    throw failure("object at path " + JSON.stringify(ref.targetPath) + " with ids " + JSON.stringify(ref.targetPathIds) + " could not be resolved");
  }
};

var objectSnapshotSerializer = {
  id: "mobx-keystone/objectSnapshot",
  serialize: function serialize(value) {
    if (typeof value !== "object" || value === null || !isTweakedObject(value, false)) return cannotSerialize;
    return getSnapshot(value);
  },
  deserialize: function deserialize(snapshot) {
    return fromSnapshot(snapshot);
  }
};

var plainObjectSerializer = {
  id: "mobx-keystone/plainObject",
  serialize: function serialize(value, _serialize) {
    if (!isPlainObject(value) && !isObservableObject(value)) return cannotSerialize; // this will make observable objects non-observable ones

    return mapObjectFields(value, _serialize);
  },
  deserialize: function deserialize(obj, serialize) {
    return mapObjectFields(obj, serialize);
  }
};

function mapObjectFields(originalObj, mapFn) {
  var obj = {};
  var keys = Object.keys(originalObj);
  var len = keys.length;

  for (var i = 0; i < len; i++) {
    var k = keys[i];
    var v = originalObj[k];
    obj[k] = mapFn(v);
  }

  return obj;
}

var setSerializer = {
  id: "mobx-keystone/setAsArray",
  serialize: function serialize(set, _serialize) {
    if (!(set instanceof Set)) return cannotSerialize;
    var arr = [];
    var iter = set.keys();
    var cur = iter.next();

    while (!cur.done) {
      var k = cur.value;
      arr.push(_serialize(k));
      cur = iter.next();
    }

    return arr;
  },
  deserialize: function deserialize(arr, _deserialize) {
    var set = new Set();
    var len = arr.length;

    for (var i = 0; i < len; i++) {
      var k = arr[i];
      set.add(_deserialize(k));
    }

    return set;
  }
};

var serializersArray = [];
var serializersMap =
/*#__PURE__*/
new Map();
/**
 * Registers a new action call argument serializers.
 * Serializers are called in the inverse order they are registered, meaning the
 * latest one registered will be called first.
 *
 * @param serializer Serializer to register.
 * @returns A disposer to unregister the serializer.
 */

function registerActionCallArgumentSerializer(serializer) {
  if (serializersArray.includes(serializer)) {
    throw failure("action call argument serializer already registered");
  }

  if (serializersMap.has(serializer.id)) {
    throw failure("action call argument serializer with id '" + serializer.id + "' already registered");
  }

  serializersArray.unshift(serializer);
  serializersMap.set(serializer.id, serializer);
  return function () {
    var index = serializersArray.indexOf(serializer);

    if (index >= 0) {
      serializersArray.splice(index, 1);
    }

    serializersMap["delete"](serializer.id);
  };
}
/**
 * Transforms an action call argument by returning a `SerializedActionCallArgument`.
 * The following are supported out of the box:
 * - Primitives.
 * - Nodes that are under the same root node as the target root (when provided) will be serialized
 *   as a path.
 * - Nodes that are not under the same root node as the target root will be serialized as their snapshot.
 * - Arrays (observable or not).
 * - Dates.
 * - Maps (observable or not).
 * - Sets (observable or not).
 * - Plain objects (observable or not).
 *
 * If the value cannot be serialized it will throw an exception.
 *
 * @param argValue Argument value to be transformed into its serializable form.
 * @param [targetRoot] Target root node of the model where this action is being performed.
 * @returns The serializable form of the passed value.
 */

function serializeActionCallArgument(argValue, targetRoot) {
  if (isPrimitive(argValue)) {
    return argValue;
  }

  var origValue = argValue;

  var serialize = function serialize(v) {
    return serializeActionCallArgument(v, targetRoot);
  }; // try serializers


  for (var i = 0; i < serializersArray.length; i++) {
    var serializer = serializersArray[i];
    var serializedValue = serializer.serialize(argValue, serialize, targetRoot);

    if (serializedValue !== cannotSerialize) {
      return {
        $mobxKeystoneSerializer: serializer.id,
        value: serializedValue
      };
    }
  }

  throw failure("serializeActionCallArgument could not serialize the given value: " + origValue);
}
/**
 * Ensures that an action call is serializable by mapping the action arguments into its
 * serializable version by using `serializeActionCallArgument`.
 *
 * @param actionCall Action call to convert.
 * @param [targetRoot] Target root node of the model where this action is being performed.
 * @returns The serializable action call.
 */

function serializeActionCall(actionCall, targetRoot) {
  if (actionCall.serialized) {
    throw failure("cannot serialize an already serialized action call");
  }

  if (targetRoot !== undefined) {
    assertTweakedObject(targetRoot, "targetRoot");
  }

  var serialize = function serialize(v) {
    return serializeActionCallArgument(v, targetRoot);
  };

  return _extends({}, actionCall, {
    serialized: true,
    args: actionCall.args.map(serialize)
  });
}
/**
 * Transforms an action call argument by returning its deserialized equivalent.
 *
 * @param argValue Argument value to be transformed into its deserialized form.
 * @param [targetRoot] Target root node of the model where this action is being performed.
 * @returns The deserialized form of the passed value.
 */

function deserializeActionCallArgument(argValue, targetRoot) {
  if (isPrimitive(argValue)) {
    return argValue;
  }

  if (!isPlainObject(argValue) || typeof argValue.$mobxKeystoneSerializer !== "string") {
    throw failure("invalid serialized action call argument");
  }

  var serializerId = argValue.$mobxKeystoneSerializer;
  var serializer = serializersMap.get(serializerId);

  if (!serializer) {
    throw failure("a serializer with id '" + serializerId + "' could not be found");
  }

  var serializedValue = argValue;

  var deserialize = function deserialize(v) {
    return deserializeActionCallArgument(v, targetRoot);
  };

  return serializer.deserialize(serializedValue.value, deserialize, targetRoot);
}
/**
 * Ensures that an action call is deserialized by mapping the action arguments into its
 * deserialized version by using `deserializeActionCallArgument`.
 *
 * @param actionCall Action call to convert.
 * @param [targetRoot] Target root node of the model where this action is being performed.
 * @returns The deserialized action call.
 */

function deserializeActionCall(actionCall, targetRoot) {
  if (!actionCall.serialized) {
    throw failure("cannot deserialize a non-serialized action call");
  }

  if (targetRoot !== undefined) {
    assertTweakedObject(targetRoot, "targetRoot");
  }

  var deserialize = function deserialize(v) {
    return deserializeActionCallArgument(v, targetRoot);
  };

  var deserializedActionCall = _extends({}, actionCall, {
    serialized: undefined,
    args: actionCall.args.map(deserialize)
  });

  delete deserializedActionCall.serialized;
  return deserializedActionCall;
} // serializer registration (from low priority to high priority)

registerActionCallArgumentSerializer(plainObjectSerializer);
registerActionCallArgumentSerializer(setSerializer);
registerActionCallArgumentSerializer(mapSerializer);
registerActionCallArgumentSerializer(dateSerializer);
registerActionCallArgumentSerializer(arraySerializer);
registerActionCallArgumentSerializer(objectSnapshotSerializer);
registerActionCallArgumentSerializer(objectPathSerializer);

function typesObjectHelper(objFn, frozen, typeInfoGen) {
  assertIsFunction(objFn, "objFn");
  return lateTypeChecker(function () {
    var objectSchema = objFn();
    assertIsObject(objectSchema, "objectSchema");
    var schemaEntries = Object.entries(objectSchema);

    var getTypeName = function getTypeName() {
      var propsMsg = [];

      for (var _len = arguments.length, recursiveTypeCheckers = new Array(_len), _key = 0; _key < _len; _key++) {
        recursiveTypeCheckers[_key] = arguments[_key];
      }

      for (var _iterator = schemaEntries, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var _ref2 = _ref,
            k = _ref2[0],
            unresolvedTc = _ref2[1];
        var tc = resolveTypeChecker(unresolvedTc);
        var propTypename = "...";

        if (!recursiveTypeCheckers.includes(tc)) {
          propTypename = tc.getTypeName.apply(tc, recursiveTypeCheckers.concat([tc]));
        }

        propsMsg.push(k + ": " + propTypename + ";");
      }

      return "{ " + propsMsg.join(" ") + " }";
    };

    var thisTc = new TypeChecker(function (obj, path) {
      if (!isObject(obj) || frozen && !(obj instanceof Frozen)) return new TypeCheckError(path, getTypeName(thisTc), obj);
      var keysToCheck = new Set(Object.keys(obj));

      for (var _iterator2 = schemaEntries, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
        var _ref3;

        if (_isArray2) {
          if (_i2 >= _iterator2.length) break;
          _ref3 = _iterator2[_i2++];
        } else {
          _i2 = _iterator2.next();
          if (_i2.done) break;
          _ref3 = _i2.value;
        }

        var _ref4 = _ref3,
            k = _ref4[0],
            unresolvedTc = _ref4[1];
        var tc = resolveTypeChecker(unresolvedTc);
        var objVal = obj[k];
        var valueError = !tc.unchecked ? tc.check(objVal, [].concat(path, [k])) : null;

        if (valueError) {
          return valueError;
        }

        keysToCheck["delete"](k);
      }

      if (keysToCheck.size > 0) {
        return new TypeCheckError(path, getTypeName(thisTc), obj);
      }

      return null;
    }, getTypeName, typeInfoGen);
    return thisTc;
  }, typeInfoGen);
}
/**
 * A type that represents a plain object.
 * Note that the parameter must be a function that returns an object. This is done so objects can support self / cross types.
 *
 * Example:
 * ```ts
 * // notice the ({ ... }), not just { ... }
 * const pointType = types.object(() => ({
 *   x: types.number,
 *   y: types.number
 * }))
 * ```
 *
 * @typeparam T Type.
 * @param objectFunction Function that generates an object with types.
 * @returns
 */


function typesObject(objectFunction) {
  // we can't type this function or else we won't be able to make it work recursively
  var typeInfoGen = function typeInfoGen(t) {
    return new ObjectTypeInfo(t, objectFunction);
  };

  return typesObjectHelper(objectFunction, false, typeInfoGen);
}
/**
 * `types.object` type info.
 */

var ObjectTypeInfo =
/*#__PURE__*/
function (_TypeInfo) {
  _inheritsLoose(ObjectTypeInfo, _TypeInfo);

  function ObjectTypeInfo(thisType, _objTypeFn) {
    var _this;

    _this = _TypeInfo.call(this, thisType) || this;
    _this._objTypeFn = _objTypeFn; // memoize to always return the same object

    _this._props = lateVal(function () {
      var objSchema = _this._objTypeFn();

      var propTypes = {};
      Object.keys(objSchema).forEach(function (propName) {
        var type = resolveStandardType(objSchema[propName]);
        propTypes[propName] = {
          type: type,
          typeInfo: getTypeInfo(type)
        };
      });
      return propTypes;
    });
    return _this;
  }

  _createClass(ObjectTypeInfo, [{
    key: "props",
    get: function get() {
      return this._props();
    }
  }]);

  return ObjectTypeInfo;
}(TypeInfo);
/**
 * A type that represents frozen data.
 *
 * Example:
 * ```ts
 * const frozenNumberType = types.frozen(types.number)
 * const frozenAnyType = types.frozen(types.unchecked<any>())
 * const frozenNumberArrayType = types.frozen(types.array(types.number))
 * const frozenUncheckedNumberArrayType = types.frozen(types.unchecked<number[]>())
 * ```
 *
 * @typeParam T Type.
 * @param dataType Type of the frozen data.
 * @returns
 */

function typesFrozen(dataType) {
  return typesObjectHelper(function () {
    return {
      data: dataType
    };
  }, true, function (t) {
    return new FrozenTypeInfo(t, resolveStandardType(dataType));
  });
}
/**
 * `types.frozen` type info.
 */

var FrozenTypeInfo =
/*#__PURE__*/
function (_TypeInfo2) {
  _inheritsLoose(FrozenTypeInfo, _TypeInfo2);

  function FrozenTypeInfo(thisType, dataType) {
    var _this2;

    _this2 = _TypeInfo2.call(this, thisType) || this;
    _this2.dataType = dataType;
    return _this2;
  }

  _createClass(FrozenTypeInfo, [{
    key: "dataTypeInfo",
    get: function get() {
      return getTypeInfo(this.dataType);
    }
  }]);

  return FrozenTypeInfo;
}(TypeInfo);

var unchecked =
/*#__PURE__*/
new TypeChecker(null, function () {
  return "any";
}, function (t) {
  return new UncheckedTypeInfo(t);
});
/**
 * A type that represents a given value that won't be type checked.
 * This is basically a way to bail out of the runtime type checking system.
 *
 * Example:
 * ```ts
 * const uncheckedSomeModel = types.unchecked<SomeModel>()
 * const anyType = types.unchecked<any>()
 * const customUncheckedType = types.unchecked<(A & B) | C>()
 * ```
 *
 * @typeparam T Type of the value, or unkown if not given.
 * @returns
 */

function typesUnchecked() {
  return unchecked;
}
/**
 * `types.unchecked` type info.
 */

var UncheckedTypeInfo =
/*#__PURE__*/
function (_TypeInfo) {
  _inheritsLoose(UncheckedTypeInfo, _TypeInfo);

  function UncheckedTypeInfo() {
    return _TypeInfo.apply(this, arguments) || this;
  }

  return UncheckedTypeInfo;
}(TypeInfo);

/**
 * Base abstract class for models that extends another model.
 *
 * @typeparam TProps New model properties type.
 * @typeparam TBaseModel Base class type.
 * @param baseModel Base model type.
 * @param modelProps Model properties.
 * @returns
 */

function ExtendedModel(baseModel, modelProps) {
  // note that & Object is there to support abstract classes
  return internalModel(modelProps, baseModel);
}
/**
 * Base abstract class for models.
 *
 * Never override the constructor, use `onInit` or `onAttachedToRootStore` instead.
 *
 * @typeparam TProps Model properties type.
 * @param modelProps Model properties.
 */

function Model(modelProps) {
  return internalModel(modelProps);
}

function internalModel(modelProps, baseModel) {
  assertIsObject(modelProps, "modelProps");

  if (baseModel) {
    assertIsModelClass(baseModel, "baseModel"); // if the baseModel is wrapped with the model decorator get the original one

    var unwrappedClass = baseModel[modelUnwrappedClassSymbol];

    if (unwrappedClass) {
      baseModel = unwrappedClass;
      assertIsModelClass(baseModel, "baseModel");
    }
  }

  var extraDescriptors = {};
  var composedModelProps = modelProps;

  if (baseModel) {
    var oldModelProps = baseModel[modelPropertiesSymbol];

    for (var _i = 0, _Object$keys = Object.keys(oldModelProps); _i < _Object$keys.length; _i++) {
      var oldModelPropKey = _Object$keys[_i];

      if (modelProps[oldModelPropKey]) {
        throw failure("extended model cannot redeclare base model property named '" + oldModelPropKey + "'");
      }

      composedModelProps[oldModelPropKey] = oldModelProps[oldModelPropKey];
    }
  } else {
    // define $modelId on the base
    extraDescriptors[modelIdKey] = createModelPropDescriptor(modelIdKey, undefined, true);
  } // create type checker if needed


  var dataTypeChecker;

  if (Object.values(composedModelProps).some(function (mp) {
    return !!mp.typeChecker;
  })) {
    var typeCheckerObj = {};

    for (var _i2 = 0, _Object$entries = Object.entries(composedModelProps); _i2 < _Object$entries.length; _i2++) {
      var _Object$entries$_i = _Object$entries[_i2],
          k = _Object$entries$_i[0],
          mp = _Object$entries$_i[1];
      typeCheckerObj[k] = !mp.typeChecker ? typesUnchecked() : mp.typeChecker;
    }

    dataTypeChecker = typesObject(function () {
      return typeCheckerObj;
    });
  } // skip props that are on base model, these have to be accessed through $
  // we only need to proxy new props, not old ones


  for (var _iterator = Object.keys(modelProps).filter(function (mp) {
    return !baseModelPropNames.has(mp);
  }), _isArray = Array.isArray(_iterator), _i3 = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i3 >= _iterator.length) break;
      _ref = _iterator[_i3++];
    } else {
      _i3 = _iterator.next();
      if (_i3.done) break;
      _ref = _i3.value;
    }

    var modelPropName = _ref;
    extraDescriptors[modelPropName] = createModelPropDescriptor(modelPropName, modelProps[modelPropName].transform, false);
  }

  var base = baseModel || BaseModel;
  var propsWithTransform = Object.entries(modelProps).filter(function (_ref2) {
    var _propName = _ref2[0],
        prop = _ref2[1];
    return !!prop.transform;
  }).map(function (_ref3) {
    var propName = _ref3[0],
        prop = _ref3[1];
    return [propName, prop.transform];
  }); // we use this weird hack rather than just class CustomBaseModel extends base {}
  // in order to work around problems with ES5 classes extending ES6 classes
  // see https://github.com/xaviergonz/mobx-keystone/issues/15

  var CustomBaseModel = function (_base) {
    _inheritsLoose$1(CustomBaseModel, _base);

    function CustomBaseModel(initialData, snapshotInitialData, modelConstructor, generateNewIds) {
      return new base(initialData, snapshotInitialData, modelConstructor || this.constructor, generateNewIds, propsWithTransform);
    }

    return CustomBaseModel;
  }(base);

  var initializers = base[modelInitializersSymbol];

  if (initializers) {
    CustomBaseModel[modelInitializersSymbol] = initializers.slice();
  }

  CustomBaseModel[modelPropertiesSymbol] = composedModelProps;
  CustomBaseModel[modelDataTypeCheckerSymbol] = dataTypeChecker;
  Object.defineProperties(CustomBaseModel.prototype, extraDescriptors);
  return CustomBaseModel;
}

function _inheritsLoose$1(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function createModelPropDescriptor(modelPropName, transform, enumerable) {
  // the code is duplicated to ensure better speed
  if (transform) {
    return {
      enumerable: enumerable,
      configurable: true,
      get: function get() {
        // no need to use get since these vars always get on the initial $
        var memoTransform = memoTransformCache.getOrCreateMemoTransform(this, modelPropName, transform);
        return memoTransform.propToData(this.$[modelPropName]);
      },
      set: function set(v) {
        // hack to only permit setting these values once fully constructed
        // this is to ignore abstract properties being set by babel
        // see https://github.com/xaviergonz/mobx-keystone/issues/18
        if (!this[modelInitializedSymbol]) {
          return;
        } // no need to use set since these vars always get on the initial $


        var memoTransform = memoTransformCache.getOrCreateMemoTransform(this, modelPropName, transform);
        this.$[modelPropName] = memoTransform.dataToProp(v);
      }
    };
  } else {
    return {
      enumerable: enumerable,
      configurable: true,
      get: function get() {
        // no need to use get since these vars always get on the initial $
        return this.$[modelPropName];
      },
      set: function set(v) {
        // hack to only permit setting these values once fully constructed
        // this is to ignore abstract properties being set by babel
        // see https://github.com/xaviergonz/mobx-keystone/issues/18
        if (!this[modelInitializedSymbol]) {
          return;
        } // no need to use set since these vars always get on the initial $


        this.$[modelPropName] = v;
      }
    };
  }
}

/**
 * Decorator that marks this class (which MUST inherit from the `Model` abstract class)
 * as a model.
 *
 * @param name Unique name for the model type. Note that this name must be unique for your whole
 * application, so it is usually a good idea to use some prefix unique to your application domain.
 */

var model = function model(name) {
  return function (clazz) {
    return internalModel$1(name, {})(clazz);
  };
};

var internalModel$1 = function internalModel(name, options) {
  return function (clazz) {
    assertIsModelClass(clazz, "a model class");

    if (modelInfoByName[name]) {
      logWarning("warn", "a model with name \"" + name + "\" already exists (if you are using hot-reloading you may safely ignore this warning)", "duplicateModelName - " + name);
    }

    if (clazz[modelUnwrappedClassSymbol]) {
      throw failure("a class already decorated with `@model` cannot be re-decorated");
    } // trick so plain new works


    var newClazz = function newClazz(initialData, snapshotInitialData, generateNewIds) {
      var instance = new clazz(initialData, snapshotInitialData, this.constructor, generateNewIds);

      if (options && options.afterNew) {
        options.afterNew(instance);
      } // the object is ready


      addHiddenProp(instance, modelInitializedSymbol, true, false);

      if (instance.onInit) {
        wrapModelMethodInActionIfNeeded(instance, "onInit", HookAction.OnInit);
        instance.onInit();
      }

      return instance;
    };

    clazz.toString = function () {
      return "class " + clazz.name + "#" + name;
    };

    clazz[modelTypeKey] = name; // this also gives access to modelInitializersSymbol, modelPropertiesSymbol, modelDataTypeCheckerSymbol

    Object.setPrototypeOf(newClazz, clazz);
    newClazz.prototype = clazz.prototype;
    Object.defineProperty(newClazz, "name", _extends({}, Object.getOwnPropertyDescriptor(newClazz, "name"), {
      value: clazz.name
    }));
    newClazz[modelUnwrappedClassSymbol] = clazz;
    var modelInfo = {
      name: name,
      "class": newClazz
    };
    modelInfoByName[name] = modelInfo;
    modelInfoByClass.set(newClazz, modelInfo);
    modelInfoByClass.set(clazz, modelInfo);
    return newClazz;
  };
}; // basically taken from TS


function tsDecorate(decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  } // eslint-disable-next-line no-sequences

  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
/**
 * Marks a class (which MUST inherit from the `Model` abstract class)
 * as a model and decorates some of its methods/properties.
 *
 * @param name Unique name for the model type. Note that this name must be unique for your whole
 * application, so it is usually a good idea to use some prefix unique to your application domain.
 * If you don't want to assign a name yet (e.g. for a base model) pass `undefined`.
 * @param clazz Model class.
 * @param decorators Decorators.
 */


function decoratedModel(name, clazz, decorators) {
  // decorate class members
  for (var _i = 0, _Object$entries = Object.entries(decorators); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _Object$entries[_i],
        k = _Object$entries$_i[0],
        decorator = _Object$entries$_i[1];
    var prototypeValueDesc = Object.getOwnPropertyDescriptor(clazz.prototype, k); // TS seems to send null for methods in the prototype
    // (which we substitute for the descriptor to avoid a double look-up) and void 0 (undefined) for props

    tsDecorate(Array.isArray(decorator) ? decorator : [decorator], clazz.prototype, k, prototypeValueDesc ? prototypeValueDesc : void 0);
  }

  return name ? model(name)(clazz) : clazz;
}

/**
 * Applies (runs) a serialized action over a target object.
 * In this mode newly generated / modified model IDs will be tracked
 * so they can be later synchronized when applying it on another machine
 * via `applySerializedActionAndSyncNewModelIds`.
 * This means this method is usually used on the server side.
 *
 * If you intend to apply non-serialized actions check `applyAction` instead.
 *
 * @param subtreeRoot Subtree root target object to run the action over.
 * @param call The serialized action, usually as coming from the server/client.
 * @returns The return value of the action, if any, plus a new serialized action
 * with model overrides.
 */

function applySerializedActionAndTrackNewModelIds(subtreeRoot, call) {
  if (!call.serialized) {
    throw failure("cannot apply a non-serialized action call, use 'applyAction' instead");
  }

  assertTweakedObject(subtreeRoot, "subtreeRoot");
  var deserializedCall = deserializeActionCall(call, subtreeRoot);
  var modelIdOverrides = []; // set a patch listener to track changes to model ids

  var patchDisposer = onPatches(subtreeRoot, function (patches) {
    scanPatchesForModelIdChanges(subtreeRoot, modelIdOverrides, patches);
  });

  try {
    var returnValue = applyAction(subtreeRoot, deserializedCall);
    return {
      returnValue: returnValue,
      serializedActionCall: _extends({}, call, {
        modelIdOverrides: modelIdOverrides
      })
    };
  } finally {
    patchDisposer();
  }
}

function scanPatchesForModelIdChanges(root, modelIdOverrides, patches) {
  var len = patches.length;

  for (var i = 0; i < len; i++) {
    var patch = patches[i];

    if (patch.op === "replace" || patch.op === "add") {
      deepScanValueForModelIdChanges(root, modelIdOverrides, patch.value, patch.path);
    }
  }
}

function deepScanValueForModelIdChanges(root, modelIdOverrides, value, path) {
  if (path.length >= 1 && path[path.length - 1] === modelIdKey && typeof value === "string") {
    // ensure the parent is an actual model
    var parent = resolvePath(root, path.slice(0, path.length - 1)).value;

    if (isModel(parent)) {
      // found one
      modelIdOverrides.push({
        op: "replace",
        path: path.slice(),
        value: value
      });
    }
  } else if (Array.isArray(value)) {
    var len = value.length;

    for (var i = 0; i < len; i++) {
      path.push(i);
      deepScanValueForModelIdChanges(root, modelIdOverrides, value[i], path);
      path.pop();
    }
  } else if (isObject(value)) {
    // skip frozen values
    if (!value[frozenKey]) {
      var keys = Object.keys(value);
      var _len = keys.length;

      for (var _i = 0; _i < _len; _i++) {
        var propName = keys[_i];
        var propValue = value[propName];
        path.push(propName);
        deepScanValueForModelIdChanges(root, modelIdOverrides, propValue, path);
        path.pop();
      }
    }
  }
}
/**
 * Applies (runs) a serialized action over a target object.
 * In this mode newly generated / modified model IDs will be tracked
 * so they can be later synchronized when applying it on another machine
 * via `applySerializedActionAndSyncNewModelIds`.
 * This means this method is usually used on the server side.
 *
 * If you intend to apply non-serialized actions check `applyAction` instead.
 *
 * @param subtreeRoot Subtree root target object to run the action over.
 * @param call The serialized action, usually as coming from the server/client.
 * @returns The return value of the action, if any, plus a new serialized action
 * with model overrides.
 */


function applySerializedActionAndSyncNewModelIds(subtreeRoot, call) {
  if (!call.serialized) {
    throw failure("cannot apply a non-serialized action call, use 'applyAction' instead");
  }

  assertTweakedObject(subtreeRoot, "subtreeRoot");
  var deserializedCall = deserializeActionCall(call, subtreeRoot);
  var returnValue;
  runInAction(function () {
    returnValue = applyAction(subtreeRoot, deserializedCall); // apply model id overrides

    applyPatches(subtreeRoot, call.modelIdOverrides);
  });
  return returnValue;
}

/**
 * Action tracking middleware finish result.
 */

var ActionTrackingResult;

(function (ActionTrackingResult) {
  /**
   * The action returned normally (without throwing).
   */
  ActionTrackingResult["Return"] = "return";
  /**
   * The action threw an error.
   */

  ActionTrackingResult["Throw"] = "throw";
})(ActionTrackingResult || (ActionTrackingResult = {}));
/**
 * Creates an action tracking middleware, which is a simplified version
 * of the standard action middleware.
 *
 * @param subtreeRoot Subtree root target object.
 * @param hooks Middleware hooks.
 * @returns The middleware disposer.
 */


function actionTrackingMiddleware(subtreeRoot, hooks) {
  assertTweakedObject(subtreeRoot, "subtreeRoot");
  var dataSymbol = Symbol("actionTrackingMiddlewareData");

  function getCtxData(ctx) {
    return ctx.data[dataSymbol];
  }

  function setCtxData(ctx, partialData) {
    var currentData = ctx.data[dataSymbol];

    if (!currentData) {
      ctx.data[dataSymbol] = partialData;
    } else {
      Object.assign(currentData, partialData);
    }
  }

  var userFilter = function userFilter(ctx) {
    if (hooks.filter) {
      return hooks.filter(simplifyActionContext(ctx));
    }

    return true;
  };

  var resumeSuspendSupport = !!hooks.onResume || !!hooks.onSuspend;

  var filter = function filter(ctx) {
    if (ctx.type === ActionContextActionType.Sync) {
      // start and finish is on the same context
      var accepted = userFilter(ctx);

      if (accepted) {
        setCtxData(ctx, {
          startAccepted: true,
          state: "idle"
        });
      }

      return accepted;
    } else {
      switch (ctx.asyncStepType) {
        case ActionContextAsyncStepType.Spawn:
          var _accepted = userFilter(ctx);

          if (_accepted) {
            setCtxData(ctx, {
              startAccepted: true,
              state: "idle"
            });
          }

          return _accepted;

        case ActionContextAsyncStepType.Return:
        case ActionContextAsyncStepType.Throw:
          // depends if the spawn one was accepted or not
          var data = getCtxData(ctx.spawnAsyncStepContext);
          return data ? data.startAccepted : false;

        case ActionContextAsyncStepType.Resume:
        case ActionContextAsyncStepType.ResumeError:
          if (!resumeSuspendSupport) {
            return false;
          } else {
            // depends if the spawn one was accepted or not
            var _data = getCtxData(ctx.spawnAsyncStepContext);

            return _data ? _data.startAccepted : false;
          }

        default:
          return false;
      }
    }
  };

  var start = function start(simpleCtx) {
    setCtxData(simpleCtx, {
      state: "started"
    });

    if (hooks.onStart) {
      return hooks.onStart(simpleCtx) || undefined;
    }

    return undefined;
  };

  var finish = function finish(simpleCtx, ret) {
    // fakely resume and suspend the parent if needed
    var parentCtx = simpleCtx.parentContext;
    var parentResumed = false;

    if (parentCtx) {
      var parentData = getCtxData(parentCtx);

      if (parentData && parentData.startAccepted && parentData.state === "suspended") {
        parentResumed = true;
        resume(parentCtx, false);
      }
    }

    setCtxData(simpleCtx, {
      state: "finished"
    });

    if (hooks.onFinish) {
      ret = hooks.onFinish(simpleCtx, ret) || ret;
    }

    if (parentResumed) {
      suspend(parentCtx);
    }

    return ret;
  };

  var resume = function resume(simpleCtx, real) {
    // ensure parents are resumed
    var parentCtx = simpleCtx.parentContext;

    if (parentCtx) {
      var parentData = getCtxData(parentCtx);

      if (parentData && parentData.startAccepted && parentData.state === "suspended") {
        resume(parentCtx, false);
      }
    }

    setCtxData(simpleCtx, {
      state: real ? "realResumed" : "fakeResumed"
    });

    if (hooks.onResume) {
      hooks.onResume(simpleCtx);
    }
  };

  var suspend = function suspend(simpleCtx) {
    setCtxData(simpleCtx, {
      state: "suspended"
    });

    if (hooks.onSuspend) {
      hooks.onSuspend(simpleCtx);
    } // ensure parents are suspended if they were fakely resumed


    var parentCtx = simpleCtx.parentContext;

    if (parentCtx) {
      var parentData = getCtxData(parentCtx);

      if (parentData && parentData.startAccepted && parentData.state === "fakeResumed") {
        suspend(parentCtx);
      }
    }
  };

  var mware = function mware(ctx, next) {
    var simpleCtx = simplifyActionContext(ctx);
    var origNext = next;

    next = function next() {
      resume(simpleCtx, true);

      try {
        return origNext();
      } finally {
        suspend(simpleCtx);
      }
    };

    if (ctx.type === ActionContextActionType.Sync) {
      var retObj = start(simpleCtx);

      if (retObj) {
        // action cancelled / overriden by onStart
        resume(simpleCtx, true);
        suspend(simpleCtx);
        retObj = finish(simpleCtx, retObj);
      } else {
        try {
          retObj = finish(simpleCtx, {
            result: ActionTrackingResult.Return,
            value: next()
          });
        } catch (err) {
          retObj = finish(simpleCtx, {
            result: ActionTrackingResult.Throw,
            value: err
          });
        }
      }

      return returnOrThrowActionTrackingReturn(retObj);
    } else {
      // async
      switch (ctx.asyncStepType) {
        case ActionContextAsyncStepType.Spawn:
          {
            var _retObj = start(simpleCtx);

            if (_retObj) {
              // action cancelled / overriden by onStart
              resume(simpleCtx, true);
              suspend(simpleCtx);
              _retObj = finish(simpleCtx, _retObj);
              return returnOrThrowActionTrackingReturn(_retObj);
            } else {
              return next();
            }
          }

        case ActionContextAsyncStepType.Return:
          {
            var flowFinisher = next();

            var _retObj2 = finish(simpleCtx, {
              result: ActionTrackingResult.Return,
              value: flowFinisher.value
            });

            flowFinisher.resolution = _retObj2.result === ActionTrackingResult.Return ? "accept" : "reject";
            flowFinisher.value = _retObj2.value;
            return flowFinisher;
          }

        case ActionContextAsyncStepType.Throw:
          {
            var _flowFinisher = next();

            var _retObj3 = finish(simpleCtx, {
              result: ActionTrackingResult.Throw,
              value: _flowFinisher.value
            });

            _flowFinisher.resolution = _retObj3.result === ActionTrackingResult.Return ? "accept" : "reject";
            _flowFinisher.value = _retObj3.value;
            return _flowFinisher;
          }

        case ActionContextAsyncStepType.Resume:
        case ActionContextAsyncStepType.ResumeError:
          if (resumeSuspendSupport) {
            return next();
          } else {
            throw failure("asssertion error: async step should have been filtered out - " + ctx.asyncStepType);
          }

        default:
          throw failure("asssertion error: async step should have been filtered out - " + ctx.asyncStepType);
      }
    }
  };

  return addActionMiddleware({
    middleware: mware,
    filter: filter,
    subtreeRoot: subtreeRoot
  });
}

function returnOrThrowActionTrackingReturn(retObj) {
  if (retObj.result === ActionTrackingResult.Return) {
    return retObj.value;
  } else {
    throw retObj.value;
  }
}

var simpleDataContextSymbol =
/*#__PURE__*/
Symbol("simpleDataContext");
/**
 * Simplifies an action context by converting an async call hierarchy into a simpler one.
 *
 * @param ctx Action context to convert.
 * @returns Simplified action context.
 */

function simplifyActionContext(ctx) {
  while (ctx.previousAsyncStepContext) {
    ctx = ctx.previousAsyncStepContext;
  }

  var simpleCtx = ctx.data[simpleDataContextSymbol];

  if (!simpleCtx) {
    var parentContext = ctx.parentContext ? simplifyActionContext(ctx.parentContext) : undefined;
    simpleCtx = {
      actionName: ctx.actionName,
      type: ctx.type,
      target: ctx.target,
      args: ctx.args,
      data: ctx.data,
      parentContext: parentContext
    };
    simpleCtx.rootContext = parentContext ? parentContext.rootContext : simpleCtx;
    ctx.data[simpleDataContextSymbol] = simpleCtx;
  }

  return simpleCtx;
}

/**
 * Attaches an action middleware that invokes a listener for all actions of a given tree.
 * Note that the listener will only be invoked for the topmost level actions, so it won't run for child actions or intermediary flow steps.
 * Also it won't trigger the listener for calls to hooks such as `onAttachedToRootStore` or its returned disposer.
 *
 * Its main use is to keep track of top level actions that can be later replicated via `applyAction` somewhere else (another machine, etc.).
 *
 * There are two kind of possible listeners, `onStart` and `onFinish` listeners.
 * `onStart` listeners are called before the action executes and allow cancellation by returning a new return value (which might be a return or a throw).
 * `onFinish` listeners are called after the action executes, have access to the action actual return value and allow overriding by returning a
 * new return value (which might be a return or a throw).
 *
 * If you want to ensure that the actual action calls are serializable you should use either `serializeActionCallArgument` over the arguments
 * or `serializeActionCall` over the whole action before sending the action call over the wire / storing them .
 *
 * @param subtreeRoot Subtree root target object.
 * @param listeners Listener functions that will be invoked everytime a topmost action is invoked on the model or any children.
 * @returns The middleware disposer.
 */

function onActionMiddleware(subtreeRoot, listeners) {
  assertTweakedObject(subtreeRoot, "subtreeRoot");
  assertIsObject(listeners, "listeners");
  return actionTrackingMiddleware(subtreeRoot, {
    filter: function filter(ctx) {
      if (ctx.parentContext) {
        // sub-action, do nothing
        return false;
      } // skip hooks


      if (isHookAction(ctx.actionName)) {
        return false;
      }

      return true;
    },
    onStart: function onStart(ctx) {
      if (listeners.onStart) {
        var actionCall = actionContextToActionCall(ctx);
        return listeners.onStart(actionCall, ctx);
      }
    },
    onFinish: function onFinish(ctx, ret) {
      if (listeners.onFinish) {
        var actionCall = actionContextToActionCall(ctx);
        return listeners.onFinish(actionCall, ctx, ret);
      }
    }
  });
}

function actionContextToActionCall(ctx) {
  var rootPath = fastGetRootPath(ctx.target);
  return {
    actionName: ctx.actionName,
    args: ctx.args,
    targetPath: rootPath.path,
    targetPathIds: rootPathToTargetPathIds(rootPath)
  };
}

/**
 * Attaches an action middleware that will throw when any action is started
 * over the node or any of the child nodes, thus effectively making the subtree
 * readonly.
 *
 * It will return an object with a `dispose` function to remove the middleware and a `allowWrite` function
 * that will allow actions to be started inside the provided code block.
 *
 * Example:
 * ```ts
 * // given a model instance named todo
 * const { dispose, allowWrite } = readonlyMiddleware(todo)
 *
 * // this will throw
 * todo.setDone(false)
 * await todo.setDoneAsync(false)
 *
 * // this will work
 * allowWrite(() => todo.setDone(false))
 * // note: for async always use one action invocation per allowWrite!
 * await allowWrite(() => todo.setDoneAsync(false))
 * ```
 *
 * @param subtreeRoot Subtree root target object.
 * @returns An object with the middleware disposer (`dispose`) and a `allowWrite` function.
 */

function readonlyMiddleware(subtreeRoot) {
  assertTweakedObject(subtreeRoot, "subtreeRoot");
  var writable = false;
  var writableSymbol = Symbol("writable");
  var disposer = actionTrackingMiddleware(subtreeRoot, {
    filter: function filter(ctx) {
      // skip hooks
      if (isHookAction(ctx.actionName)) {
        return false;
      } // if we are inside allowWrite it is writable


      var currentlyWritable = writable;

      if (!currentlyWritable) {
        // if a parent context was writable then the child should be as well
        var currentCtx = ctx;

        while (currentCtx && !currentlyWritable) {
          currentlyWritable = !!currentCtx.data[writableSymbol];
          currentCtx = currentCtx.parentContext;
        }
      }

      if (currentlyWritable) {
        ctx.data[writableSymbol] = true;
        return false;
      }

      return true;
    },
    onStart: function onStart(ctx) {
      // if we get here (wasn't filtered out) it is not writable
      return {
        result: ActionTrackingResult.Throw,
        value: failure("tried to invoke action '" + ctx.actionName + "' over a readonly node")
      };
    }
  });
  return {
    dispose: disposer,
    allowWrite: function allowWrite(fn) {
      var oldWritable = writable;
      writable = true;

      try {
        return fn();
      } finally {
        writable = oldWritable;
      }
    }
  };
}

/**
 * Escapes a json pointer path.
 *
 * @param path The raw pointer
 * @return the Escaped path
 */

function escapePathComponent(path) {
  if (typeof path === "number") {
    return "" + path;
  }

  if (path.indexOf("/") === -1 && path.indexOf("~") === -1) {
    return path;
  }

  return path.replace(/~/g, "~0").replace(/\//g, "~1");
}
/**
 * Unescapes a json pointer path.
 *
 * @param path The escaped pointer
 * @return The unescaped path
 */


function unescapePathComponent(path) {
  return path.replace(/~1/g, "/").replace(/~0/g, "~");
}
/**
 * Converts a path into a JSON pointer.
 *
 * @param path Path to convert.
 * @returns Converted JSON pointer.
 */


function pathToJsonPointer(path) {
  if (path.length <= 0) {
    return "";
  }

  return "/" + path.map(escapePathComponent).join("/");
}
/**
 * Converts a JSON pointer into a path.
 *
 * @param jsonPointer JSON pointer to convert.
 * @returns Converted path.
 */

function jsonPointerToPath(jsonPointer) {
  if (jsonPointer === "") {
    return [];
  }

  if (!jsonPointer.startsWith("/")) {
    throw failure("a JSON pointer must start with '/' or be empty");
  }

  jsonPointer = jsonPointer.slice(1);
  return jsonPointer.split("/").map(unescapePathComponent);
}
/**
 * Convert a patch into a JSON patch.
 *
 * @param patch A patch.
 * @returns A JSON patch.
 */

function patchToJsonPatch(patch) {
  return _extends({}, patch, {
    path: pathToJsonPointer(patch.path)
  });
}
/**
 * Converts a JSON patch into a patch.
 *
 * @param jsonPatch A JSON patch.
 * @returns A patch.
 */

function jsonPatchToPatch(jsonPatch) {
  return _extends({}, jsonPatch, {
    path: jsonPointerToPath(jsonPatch.path)
  });
}

/**
 * Creates a patch recorder.
 *
 * @param subtreeRoot
 * @param [opts]
 * @returns The patch recorder.
 */

function patchRecorder(subtreeRoot, opts) {
  assertTweakedObject(subtreeRoot, "subtreeRoot");
  return internalPatchRecorder(subtreeRoot, opts);
}
/**
 * @ignore
 * @internal
 *
 * Creates a global or local patch recorder.
 *
 * @param subtreeRoot
 * @param [opts]
 * @returns The patch recorder.
 */

function internalPatchRecorder(subtreeRoot, opts) {
  var _recording$filter$opt = _extends({
    recording: true,
    filter: alwaysAcceptFilter
  }, opts),
      recording = _recording$filter$opt.recording,
      filter = _recording$filter$opt.filter;

  var events = [];
  var onPatchesDisposer;

  if (subtreeRoot) {
    onPatchesDisposer = onPatches(subtreeRoot, function (p, invP) {
      if (recording && filter(p, invP)) {
        events.push({
          target: subtreeRoot,
          patches: p,
          inversePatches: invP
        });
      }
    });
  } else {
    onPatchesDisposer = onGlobalPatches(function (target, p, invP) {
      if (recording && filter(p, invP)) {
        events.push({
          target: target,
          patches: p,
          inversePatches: invP
        });
      }
    });
  }

  return {
    get recording() {
      return recording;
    },

    set recording(enabled) {
      recording = enabled;
    },

    get events() {
      return events;
    },

    dispose: function dispose() {
      onPatchesDisposer();
    }
  };
}

var alwaysAcceptFilter = function alwaysAcceptFilter() {
  return true;
};

/**
 * Creates a transaction middleware, which reverts changes made by an action / child
 * actions when the root action throws an exception by applying inverse patches.
 *
 * @typeparam M Model
 * @param target Object with the root target model object (`model`) and root action name (`actionName`).
 * @returns The middleware disposer.
 */

function transactionMiddleware(target) {
  assertIsObject(target, "target");
  var model = target.model,
      actionName = target.actionName;
  assertIsModel(model, "target.model");

  if (typeof actionName !== "string") {
    throw failure("target.actionName must be a string");
  }

  var patchRecorderSymbol = Symbol("patchRecorder");

  function initPatchRecorder(ctx) {
    ctx.rootContext.data[patchRecorderSymbol] = internalPatchRecorder(undefined, {
      recording: false
    });
  }

  function getPatchRecorder(ctx) {
    return ctx.rootContext.data[patchRecorderSymbol];
  }

  return actionTrackingMiddleware(model, {
    filter: function filter(ctx) {
      // the primary action must be on the root object
      var rootContext = ctx.rootContext;
      return rootContext.target === model && rootContext.actionName === actionName;
    },
    onStart: function onStart(ctx) {
      if (ctx === ctx.rootContext) {
        initPatchRecorder(ctx);
      }
    },
    onResume: function onResume(ctx) {
      getPatchRecorder(ctx).recording = true;
    },
    onSuspend: function onSuspend(ctx) {
      getPatchRecorder(ctx).recording = false;
    },
    onFinish: function onFinish(ctx, ret) {
      if (ctx === ctx.rootContext) {
        var patchRecorder = getPatchRecorder(ctx);

        try {
          if (ret.result === ActionTrackingResult.Throw) {
            // undo changes (backwards for inverse patches)
            var events = patchRecorder.events;

            for (var i = events.length - 1; i >= 0; i--) {
              var event = events[i];
              applyPatches(event.target, event.inversePatches, true);
            }
          }
        } finally {
          patchRecorder.dispose();
        }
      }
    }
  });
}
/**
 * Transaction middleware as a decorator.
 *
 * @param target
 * @param propertyKey
 */

function transaction(target, propertyKey) {
  checkModelDecoratorArgs("transaction", target, propertyKey);
  addModelClassInitializer(target.constructor, function (modelInstance) {
    transactionMiddleware({
      model: modelInstance,
      actionName: propertyKey
    });
  });
}

/**
 * A type that represents an array of values of a given type.
 *
 * Example:
 * ```ts
 * const numberArrayType = types.array(types.number)
 * ```
 *
 * @typeparam T Item type.
 * @param itemType Type of inner items.
 * @returns
 */

function typesArray(itemType) {
  var typeInfoGen = function typeInfoGen(t) {
    return new ArrayTypeInfo(t, resolveStandardType(itemType));
  };

  return lateTypeChecker(function () {
    var itemChecker = resolveTypeChecker(itemType);

    var getTypeName = function getTypeName() {
      for (var _len = arguments.length, recursiveTypeCheckers = new Array(_len), _key = 0; _key < _len; _key++) {
        recursiveTypeCheckers[_key] = arguments[_key];
      }

      return "Array<" + itemChecker.getTypeName.apply(itemChecker, recursiveTypeCheckers.concat([itemChecker])) + ">";
    };

    var thisTc = new TypeChecker(function (array, path) {
      if (!isArray(array)) {
        return new TypeCheckError(path, getTypeName(thisTc), array);
      }

      if (!itemChecker.unchecked) {
        for (var i = 0; i < array.length; i++) {
          var itemError = itemChecker.check(array[i], [].concat(path, [i]));

          if (itemError) {
            return itemError;
          }
        }
      }

      return null;
    }, getTypeName, typeInfoGen);
    return thisTc;
  }, typeInfoGen);
}
/**
 * `types.array` type info.
 */

var ArrayTypeInfo =
/*#__PURE__*/
function (_TypeInfo) {
  _inheritsLoose(ArrayTypeInfo, _TypeInfo);

  function ArrayTypeInfo(thisType, itemType) {
    var _this;

    _this = _TypeInfo.call(this, thisType) || this;
    _this.itemType = itemType;
    return _this;
  }

  _createClass(ArrayTypeInfo, [{
    key: "itemTypeInfo",
    get: function get() {
      return getTypeInfo(this.itemType);
    }
  }]);

  return ArrayTypeInfo;
}(TypeInfo);

function tProp(typeOrDefaultValue, def) {
  switch (typeof typeOrDefaultValue) {
    case "string":
      return tProp(typesString, typeOrDefaultValue);

    case "number":
      return tProp(typesNumber, typeOrDefaultValue);

    case "boolean":
      return tProp(typesBoolean, typeOrDefaultValue);
  }

  var hasDefaultValue = arguments.length > 1;
  var isDefFn = typeof def === "function";
  return {
    $propValueType: null,
    $propCreationValueType: null,
    $isOptional: null,
    $instanceValueType: null,
    $instanceCreationValueType: null,
    defaultFn: hasDefaultValue && isDefFn ? def : noDefaultValue,
    defaultValue: hasDefaultValue && !isDefFn ? def : noDefaultValue,
    typeChecker: resolveStandardType(typeOrDefaultValue),
    transform: undefined
  };
}

/**
 * Store model instance for undo/redo actions.
 * Do not manipulate directly, other that creating it.
 */

var UndoStore =
/*#__PURE__*/
function (_Model) {
  _inheritsLoose(UndoStore, _Model);

  function UndoStore() {
    return _Model.apply(this, arguments) || this;
  }

  var _proto = UndoStore.prototype;

  /**
   * @ignore
   */
  _proto._clearUndo = function _clearUndo() {
    var _this = this;

    withoutUndo(function () {
      _this.undoEvents.length = 0;
    });
  }
  /**
   * @ignore
   */
  ;

  _proto._clearRedo = function _clearRedo() {
    var _this2 = this;

    withoutUndo(function () {
      _this2.redoEvents.length = 0;
    });
  }
  /**
   * @ignore
   */
  ;

  _proto._undo = function _undo() {
    var _this3 = this;

    withoutUndo(function () {
      var event = _this3.undoEvents.pop();

      _this3.redoEvents.push(event);
    });
  }
  /**
   * @ignore
   */
  ;

  _proto._redo = function _redo() {
    var _this4 = this;

    withoutUndo(function () {
      var event = _this4.redoEvents.pop();

      _this4.undoEvents.push(event);
    });
  }
  /**
   * @ignore
   */
  ;

  _proto._addUndo = function _addUndo(event) {
    var _this5 = this;

    withoutUndo(function () {
      _this5.undoEvents.push(event); // once an undo event is added redo queue is no longer valid


      _this5.redoEvents.length = 0;
    });
  };

  return UndoStore;
}(
/*#__PURE__*/
Model({
  // TODO: add proper type checking to undo store
  undoEvents:
  /*#__PURE__*/
  tProp(
  /*#__PURE__*/
  typesArray(
  /*#__PURE__*/
  typesUnchecked()), function () {
    return [];
  }),
  redoEvents:
  /*#__PURE__*/
  tProp(
  /*#__PURE__*/
  typesArray(
  /*#__PURE__*/
  typesUnchecked()), function () {
    return [];
  })
}));

__decorate([modelAction], UndoStore.prototype, "_clearUndo", null);

__decorate([modelAction], UndoStore.prototype, "_clearRedo", null);

__decorate([modelAction], UndoStore.prototype, "_undo", null);

__decorate([modelAction], UndoStore.prototype, "_redo", null);

__decorate([modelAction], UndoStore.prototype, "_addUndo", null);

UndoStore =
/*#__PURE__*/
__decorate([
/*#__PURE__*/
model("mobx-keystone/UndoStore")], UndoStore);
/**
 * Manager class returned by `undoMiddleware` that allows you to perform undo/redo actions.
 */

var UndoManager =
/*#__PURE__*/
function () {
  /**
   * Creates an instance of `UndoManager`.
   * Do not use directly, use `undoMiddleware` instead.
   *
   * @param disposer
   * @param subtreeRoot
   * @param [store]
   */
  function UndoManager(disposer, subtreeRoot, store) {
    this.disposer = disposer;
    this.subtreeRoot = subtreeRoot;
    this.store = store || new UndoStore({});
  }
  /**
   * The undo stack, where the first operation to undo will be the last of the array.
   * Do not manipulate this array directly.
   */


  var _proto2 = UndoManager.prototype;

  /**
   * Clears the undo queue.
   */
  _proto2.clearUndo = function clearUndo() {
    this.store._clearUndo();
  }
  /**
   * The number of redo actions available.
   */
  ;

  /**
   * Clears the redo queue.
   */
  _proto2.clearRedo = function clearRedo() {
    this.store._clearRedo();
  }
  /**
   * Undoes the last action.
   * Will throw if there is no action to undo.
   */
  ;

  _proto2.undo = function undo() {
    var _this6 = this;

    if (!this.canUndo) {
      throw failure("nothing to undo");
    }

    var event = this.undoQueue[this.undoQueue.length - 1];
    withoutUndo(function () {
      applyPatches(_this6.subtreeRoot, event.inversePatches, true);
    });

    this.store._undo();
  }
  /**
   * Redoes the previous action.
   * Will throw if there is no action to redo.
   */
  ;

  _proto2.redo = function redo() {
    var _this7 = this;

    if (!this.canRedo) {
      throw failure("nothing to redo");
    }

    var event = this.redoQueue[this.redoQueue.length - 1];
    withoutUndo(function () {
      applyPatches(_this7.subtreeRoot, event.patches);
    });

    this.store._redo();
  }
  /**
   * Disposes the undo middleware.
   */
  ;

  _proto2.dispose = function dispose() {
    this.disposer();
  };

  _createClass(UndoManager, [{
    key: "undoQueue",
    get: function get() {
      return this.store.undoEvents;
    }
    /**
     * The redo stack, where the first operation to redo will be the last of the array.
     * Do not manipulate this array directly.
     */

  }, {
    key: "redoQueue",
    get: function get() {
      return this.store.redoEvents;
    }
    /**
     * The number of undo actions available.
     */

  }, {
    key: "undoLevels",
    get: function get() {
      return this.undoQueue.length;
    }
    /**
     * If undo can be performed (if there is at least one undo action available).
     */

  }, {
    key: "canUndo",
    get: function get() {
      return this.undoLevels > 0;
    }
  }, {
    key: "redoLevels",
    get: function get() {
      return this.redoQueue.length;
    }
    /**
     * If redo can be performed (if there is at least one redo action available)
     */

  }, {
    key: "canRedo",
    get: function get() {
      return this.redoLevels > 0;
    }
  }]);

  return UndoManager;
}();

__decorate([computed], UndoManager.prototype, "undoQueue", null);

__decorate([computed], UndoManager.prototype, "redoQueue", null);

__decorate([computed], UndoManager.prototype, "undoLevels", null);

__decorate([computed], UndoManager.prototype, "canUndo", null);

__decorate([action], UndoManager.prototype, "clearUndo", null);

__decorate([computed], UndoManager.prototype, "redoLevels", null);

__decorate([computed], UndoManager.prototype, "canRedo", null);

__decorate([action], UndoManager.prototype, "clearRedo", null);

__decorate([action], UndoManager.prototype, "undo", null);

__decorate([action], UndoManager.prototype, "redo", null);
/**
 * Creates an undo middleware.
 *
 * @param subtreeRoot Subtree root target object.
 * @param [store] Optional `UndoStore` where to store the undo/redo queues. Use this if you want to
 * store such queues somewhere in your models. If none is provided it will reside in memory.
 * @returns An `UndoManager` which allows you to do the manage the undo/redo operations and dispose of the middleware.
 */


function undoMiddleware(subtreeRoot, store) {
  assertTweakedObject(subtreeRoot, "subtreeRoot");
  var patchRecorderSymbol = Symbol("patchRecorder");

  function initPatchRecorder(ctx) {
    ctx.rootContext.data[patchRecorderSymbol] = {
      recorder: patchRecorder(subtreeRoot, {
        recording: false,
        filter: undoDisabledFilter
      }),
      recorderStack: 0
    };
  }

  function getPatchRecorderData(ctx) {
    return ctx.rootContext.data[patchRecorderSymbol];
  }

  var manager;
  var middlewareDisposer = actionTrackingMiddleware(subtreeRoot, {
    onStart: function onStart(ctx) {
      if (ctx === ctx.rootContext) {
        initPatchRecorder(ctx);
      }
    },
    onResume: function onResume(ctx) {
      var patchRecorderData = getPatchRecorderData(ctx);
      patchRecorderData.recorderStack++;
      patchRecorderData.recorder.recording = patchRecorderData.recorderStack > 0;
    },
    onSuspend: function onSuspend(ctx) {
      var patchRecorderData = getPatchRecorderData(ctx);
      patchRecorderData.recorderStack--;
      patchRecorderData.recorder.recording = patchRecorderData.recorderStack > 0;
    },
    onFinish: function onFinish(ctx) {
      if (ctx === ctx.rootContext) {
        var _patchRecorder = getPatchRecorderData(ctx).recorder;

        if (_patchRecorder.events.length > 0) {
          var patches = [];
          var inversePatches = [];

          for (var _iterator = _patchRecorder.events, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref;

            if (_isArray) {
              if (_i >= _iterator.length) break;
              _ref = _iterator[_i++];
            } else {
              _i = _iterator.next();
              if (_i.done) break;
              _ref = _i.value;
            }

            var event = _ref;
            patches.push.apply(patches, event.patches);
            inversePatches.push.apply(inversePatches, event.inversePatches);
          }

          manager.store._addUndo({
            targetPath: fastGetRootPath(ctx.target).path,
            actionName: ctx.actionName,
            patches: patches,
            inversePatches: inversePatches
          });
        }

        _patchRecorder.dispose();
      }
    }
  });
  manager = new UndoManager(middlewareDisposer, subtreeRoot, store);
  return manager;
}
var undoDisabled = false;

var undoDisabledFilter = function undoDisabledFilter() {
  return !undoDisabled;
};
/**
 * Skips the undo recording mechanism for the code block that gets run synchronously inside.
 *
 * @typeparam T
 * @param fn
 * @returns
 */


function withoutUndo(fn) {
  var savedUndoDisabled = undoDisabled;
  undoDisabled = true;

  try {
    return fn();
  } finally {
    undoDisabled = savedUndoDisabled;
  }
}

function getContextValue(contextValue) {
  if (contextValue.type === "value") {
    return contextValue.value;
  } else {
    return contextValue.value.get();
  }
}

var ContextClass =
/*#__PURE__*/
function () {
  function ContextClass(defaultValue) {
    this.nodeContextValue = new WeakMap();
    this.nodeAtom = new WeakMap();
    this.setDefault(defaultValue);
  }

  var _proto = ContextClass.prototype;

  _proto.getNodeAtom = function getNodeAtom(node) {
    var atomPerNode = this.nodeAtom.get(node);

    if (!atomPerNode) {
      atomPerNode = createAtom("contextValue");
      this.nodeAtom.set(node, atomPerNode);
    }

    return atomPerNode;
  };

  _proto.fastGet = function fastGet(node) {
    this.getNodeAtom(node).reportObserved();
    var obsForNode = this.nodeContextValue.get(node);

    if (obsForNode) {
      return getContextValue(obsForNode);
    }

    var parent = fastGetParent(node);

    if (!parent) {
      return this.getDefault();
    }

    return this.fastGet(parent);
  };

  _proto.get = function get(node) {
    assertTweakedObject(node, "node");
    return this.fastGet(node);
  };

  _proto.fastGetProviderNode = function fastGetProviderNode(node) {
    this.getNodeAtom(node).reportObserved();
    var obsForNode = this.nodeContextValue.get(node);

    if (obsForNode) {
      return node;
    }

    var parent = fastGetParent(node);

    if (!parent) {
      return undefined;
    }

    return this.fastGetProviderNode(parent);
  };

  _proto.getProviderNode = function getProviderNode(node) {
    assertTweakedObject(node, "node");
    return this.fastGetProviderNode(node);
  };

  _proto.getDefault = function getDefault() {
    return getContextValue(this.defaultContextValue);
  };

  _proto.setDefault = function setDefault(value) {
    this.defaultContextValue = {
      type: "value",
      value: value
    };
  };

  _proto.setDefaultComputed = function setDefaultComputed(valueFn) {
    this.defaultContextValue = {
      type: "computed",
      value: computed(valueFn)
    };
  };

  _proto.set = function set(node, value) {
    assertTweakedObject(node, "node");
    this.nodeContextValue.set(node, {
      type: "value",
      value: value
    });
    this.getNodeAtom(node).reportChanged();
  };

  _proto.setComputed = function setComputed(node, valueFn) {
    assertTweakedObject(node, "node");
    this.nodeContextValue.set(node, {
      type: "computed",
      value: computed(valueFn)
    });
    this.getNodeAtom(node).reportChanged();
  };

  _proto.unset = function unset(node) {
    assertTweakedObject(node, "node");
    this.nodeContextValue["delete"](node);
    this.getNodeAtom(node).reportChanged();
  };

  return ContextClass;
}();

__decorate([observable.ref], ContextClass.prototype, "defaultContextValue", void 0);

__decorate([action], ContextClass.prototype, "setDefault", null);

__decorate([action], ContextClass.prototype, "setDefaultComputed", null);

__decorate([action], ContextClass.prototype, "set", null);

__decorate([action], ContextClass.prototype, "setComputed", null);

__decorate([action], ContextClass.prototype, "unset", null); // base


function createContext(defaultValue) {
  return new ContextClass(defaultValue);
}

var Lock =
/*#__PURE__*/
function () {
  function Lock() {
    this._locked = true;
  }

  var _proto = Lock.prototype;

  _proto.unlockedFn = function unlockedFn(fn) {
    var _this = this;

    var innerFn = function innerFn() {
      var oldLocked = _this._locked;
      _this._locked = false;

      try {
        return fn.apply(void 0, arguments);
      } finally {
        _this._locked = oldLocked;
      }
    };

    return innerFn;
  };

  _proto.withUnlock = function withUnlock(fn) {
    var oldLocked = this._locked;
    this._locked = false;

    try {
      return fn();
    } finally {
      this._locked = oldLocked;
    }
  };

  _createClass(Lock, [{
    key: "isLocked",
    get: function get() {
      return this._locked;
    }
  }]);

  return Lock;
}();

var observableMapBackedByObservableArray =
/*#__PURE__*/
action(function (array) {
  if (inDevMode()) {
    if (!isObservableArray(array)) {
      throw failure("assertion failed: expected an observable array");
    }
  }

  var map = observable.map(array);

  if (map.size !== array.length) {
    throw failure("arrays backing a map cannot contain duplicate keys");
  }

  var mutationLock = new Lock(); // for speed reasons we will just assume distinct values are only once in the array
  // also we assume tuples themselves are immutable
  // when the array changes the map changes

  observe(array, action(mutationLock.unlockedFn(function (change) {
    switch (change.type) {
      case "splice":
        {
          {
            var removed = change.removed;

            for (var i = 0; i < removed.length; i++) {
              map["delete"](removed[i][0]);
            }
          }
          {
            var added = change.added;

            for (var _i = 0; _i < added.length; _i++) {
              map.set(added[_i][0], added[_i][1]);
            }
          }
          break;
        }

      case "update":
        {
          map["delete"](change.oldValue[0]);
          map.set(change.newValue[0], change.newValue[1]);
          break;
        }
    }
  }))); // when the map changes also change the array

  intercept(map, action(function (change) {
    if (!mutationLock.isLocked) {
      return null; // already changed
    }

    switch (change.type) {
      case "update":
        {
          // replace the whole tuple to keep tuple immutability
          var i = array.findIndex(function (i) {
            return i[0] === change.name;
          });
          array[i] = [change.name, change.newValue];
          break;
        }

      case "add":
        {
          array.push([change.name, change.newValue]);
          break;
        }

      case "delete":
        {
          var _i2 = array.findIndex(function (i) {
            return i[0] === change.name;
          });

          if (_i2 >= 0) {
            array.splice(_i2, 1);
          }

          break;
        }
    }

    return change;
  }));
  return map;
});
var arrayAsMapInnerTransform = {
  propToData: function propToData(arr) {
    return isArray(arr) ? observableMapBackedByObservableArray(arr) : arr;
  },
  dataToProp: function dataToProp(newMap) {
    if (!isMap(newMap)) {
      return newMap;
    }

    var arr = [];

    for (var _iterator = newMap.keys(), _isArray = Array.isArray(_iterator), _i3 = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i3 >= _iterator.length) break;
        _ref = _iterator[_i3++];
      } else {
        _i3 = _iterator.next();
        if (_i3.done) break;
        _ref = _i3.value;
      }

      var k = _ref;
      arr.push([k, newMap.get(k)]);
    }

    return arr;
  }
};
function prop_mapArray(def) {
  return transformedProp(prop(def), arrayAsMapInnerTransform, true);
}
function tProp_mapArray(typeOrDefaultValue, def) {
  return transformedProp(tProp(typeOrDefaultValue, def), arrayAsMapInnerTransform, true);
}

var observableSetBackedByObservableArray =
/*#__PURE__*/
action(function (array) {
  if (inDevMode()) {
    if (!isObservableArray(array)) {
      throw failure("assertion failed: expected an observable array");
    }
  }

  var set = observable.set(array);

  if (set.size !== array.length) {
    throw failure("arrays backing a set cannot contain duplicate values");
  }

  var mutationLock = new Lock(); // for speed reasons we will just assume distinct values are only once in the array
  // when the array changes the set changes

  observe(array, action(mutationLock.unlockedFn(function (change) {
    switch (change.type) {
      case "splice":
        {
          {
            var removed = change.removed;

            for (var i = 0; i < removed.length; i++) {
              set["delete"](removed[i]);
            }
          }
          {
            var added = change.added;

            for (var _i = 0; _i < added.length; _i++) {
              set.add(added[_i]);
            }
          }
          break;
        }

      case "update":
        {
          set["delete"](change.oldValue);
          set.add(change.newValue);
          break;
        }
    }
  }))); // when the set changes also change the array

  intercept(set, action(function (change) {
    if (!mutationLock.isLocked) {
      return null; // already changed
    }

    switch (change.type) {
      case "add":
        {
          array.push(change.newValue);
          break;
        }

      case "delete":
        {
          var i = array.indexOf(change.oldValue);

          if (i >= 0) {
            array.splice(i, 1);
          }

          break;
        }
    }

    return change;
  }));
  return set;
});
var arrayAsSetInnerTransform = {
  propToData: function propToData(arr) {
    return isArray(arr) ? observableSetBackedByObservableArray(arr) : arr;
  },
  dataToProp: function dataToProp(newSet) {
    return isSet(newSet) ? [].concat(newSet.values()) : newSet;
  }
};
function prop_setArray(def) {
  return transformedProp(prop(def), arrayAsSetInnerTransform, true);
}
function tProp_setArray(typeOrDefaultValue, def) {
  return transformedProp(tProp(typeOrDefaultValue, def), arrayAsSetInnerTransform, true);
}

var observableMapBackedByObservableObject =
/*#__PURE__*/
action(function (obj) {
  if (inDevMode()) {
    if (!isObservableObject(obj)) {
      throw failure("assertion failed: expected an observable object");
    }
  }

  var map = observable.map();
  var keys = Object.keys(obj);

  for (var i = 0; i < keys.length; i++) {
    var k = keys[i];
    map.set(k, obj[k]);
  }

  var mutationLock = new Lock(); // when the object changes the map changes

  observe(obj, action(mutationLock.unlockedFn(function (change) {
    switch (change.type) {
      case "add":
      case "update":
        {
          map.set(change.name, change.newValue);
          break;
        }

      case "remove":
        {
          map["delete"](change.name);
          break;
        }
    }
  }))); // when the map changes also change the object

  intercept(map, action(function (change) {
    if (!mutationLock.isLocked) {
      return null; // already changed
    }

    switch (change.type) {
      case "add":
      case "update":
        {
          set(obj, change.name, change.newValue);
          break;
        }

      case "delete":
        {
          remove(obj, change.name);
          break;
        }
    }

    return change;
  }));
  return map;
});
var objectAsMapInnerTransform = {
  propToData: function propToData(obj) {
    return isObject(obj) ? observableMapBackedByObservableObject(obj) : obj;
  },
  dataToProp: function dataToProp(newMap) {
    if (!isMap(newMap)) {
      return newMap;
    }

    var obj = {};

    for (var _iterator = newMap.keys(), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var k = _ref;
      obj[k] = newMap.get(k);
    }

    return obj;
  }
};
function prop_mapObject(def) {
  return transformedProp(prop(def), objectAsMapInnerTransform, true);
}
function tProp_mapObject(typeOrDefaultValue, def) {
  return transformedProp(tProp(typeOrDefaultValue, def), objectAsMapInnerTransform, true);
}

var DateBackedByProp =
/*#__PURE__*/
function (_Date) {
  _inheritsLoose(DateBackedByProp, _Date);

  function DateBackedByProp(value, _updateBackedProp) {
    var _this;

    _this = _Date.call(this, value) || this;
    _this._updateBackedProp = _updateBackedProp;
    return _this;
  }

  var _proto = DateBackedByProp.prototype;

  _proto._updateDate = function _updateDate(method, superMethod, args) {
    // work over a copy
    var date = new Date(this.getTime());
    date[method].apply(date, args); // update backed prop

    this._updateBackedProp(date); // if that succeeds apply over current date object


    return superMethod.apply(this, args);
  } // make mutable methods update the backed prop
  ;

  _proto.setTime = function setTime() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return this._updateDate("setTime", _Date.prototype.setTime, args);
  };

  _proto.setMilliseconds = function setMilliseconds() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return this._updateDate("setMilliseconds", _Date.prototype.setMilliseconds, args);
  };

  _proto.setUTCMilliseconds = function setUTCMilliseconds() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return this._updateDate("setUTCMilliseconds", _Date.prototype.setUTCMilliseconds, args);
  };

  _proto.setSeconds = function setSeconds() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return this._updateDate("setSeconds", _Date.prototype.setSeconds, args);
  };

  _proto.setUTCSeconds = function setUTCSeconds() {
    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    return this._updateDate("setUTCSeconds", _Date.prototype.setUTCSeconds, args);
  };

  _proto.setMinutes = function setMinutes() {
    for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    return this._updateDate("setMinutes", _Date.prototype.setMinutes, args);
  };

  _proto.setUTCMinutes = function setUTCMinutes() {
    for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }

    return this._updateDate("setUTCMinutes", _Date.prototype.setUTCMinutes, args);
  };

  _proto.setHours = function setHours() {
    for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
      args[_key8] = arguments[_key8];
    }

    return this._updateDate("setHours", _Date.prototype.setHours, args);
  };

  _proto.setUTCHours = function setUTCHours() {
    for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
      args[_key9] = arguments[_key9];
    }

    return this._updateDate("setUTCHours", _Date.prototype.setUTCHours, args);
  };

  _proto.setDate = function setDate() {
    for (var _len10 = arguments.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
      args[_key10] = arguments[_key10];
    }

    return this._updateDate("setDate", _Date.prototype.setDate, args);
  };

  _proto.setUTCDate = function setUTCDate() {
    for (var _len11 = arguments.length, args = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
      args[_key11] = arguments[_key11];
    }

    return this._updateDate("setUTCDate", _Date.prototype.setUTCDate, args);
  };

  _proto.setMonth = function setMonth() {
    for (var _len12 = arguments.length, args = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
      args[_key12] = arguments[_key12];
    }

    return this._updateDate("setMonth", _Date.prototype.setMonth, args);
  };

  _proto.setUTCMonth = function setUTCMonth() {
    for (var _len13 = arguments.length, args = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
      args[_key13] = arguments[_key13];
    }

    return this._updateDate("setUTCMonth", _Date.prototype.setUTCMonth, args);
  };

  _proto.setFullYear = function setFullYear() {
    for (var _len14 = arguments.length, args = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
      args[_key14] = arguments[_key14];
    }

    return this._updateDate("setFullYear", _Date.prototype.setFullYear, args);
  };

  _proto.setUTCFullYear = function setUTCFullYear() {
    for (var _len15 = arguments.length, args = new Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
      args[_key15] = arguments[_key15];
    }

    return this._updateDate("setUTCFullYear", _Date.prototype.setUTCFullYear, args);
  };

  return DateBackedByProp;
}(
/*#__PURE__*/
_wrapNativeSuper(Date));

/**
 * @deprecated Consider using `prop_dateString` or `tProp_dateString` instead.
 *
 * Decorator property transform for ISO date strings to Date objects and vice-versa.
 */

var stringAsDate =
/*#__PURE__*/
propTransform({
  propToData: function propToData(prop, setProp) {
    if (typeof prop !== "string") {
      return prop;
    }

    if (setProp) {
      return new DateBackedByProp(prop, function (date) {
        setProp(date.toJSON());
      });
    } else {
      return new Date(prop);
    }
  },
  dataToProp: function dataToProp(date) {
    return date instanceof Date ? date.toJSON() : date;
  }
});
function prop_dateString(def) {
  return transformedProp(prop(def), stringAsDate, true);
}
function tProp_dateString(typeOrDefaultValue, def) {
  return transformedProp(tProp(typeOrDefaultValue, def), stringAsDate, true);
}

/**
 * @deprecated Consider using `prop_dateTimestamp` or `tProp_dateTimestamp` instead.
 *
 * Decorator property transform for number timestamps to Date objects and vice-versa.
 */

var timestampAsDate =
/*#__PURE__*/
propTransform({
  propToData: function propToData(prop, setProp) {
    if (typeof prop !== "number") {
      return prop;
    }

    if (setProp) {
      return new DateBackedByProp(prop, function (date) {
        setProp(date.getTime());
      });
    } else {
      return new Date(prop);
    }
  },
  dataToProp: function dataToProp(date) {
    return date instanceof Date ? date.getTime() : date;
  }
});
function prop_dateTimestamp(def) {
  return transformedProp(prop(def), timestampAsDate, true);
}
function tProp_dateTimestamp(typeOrDefaultValue, def) {
  return transformedProp(tProp(typeOrDefaultValue, def), timestampAsDate, true);
}

/**
 * Connects a tree node to a redux dev tools instance.
 *
 * @param remotedevPackage The remotedev package (usually the result of `require("remoteDev")`) (https://www.npmjs.com/package/remotedev).
 * @param remotedevConnection The result of a connect method from the remotedev package (usually the result of `remoteDev.connectViaExtension(...)`).
 * @param target Object to use as root.
 * @param storeName Name to be shown in the redux dev tools.
 * @param [options] Optional options object. `logArgsNearName` if it should show the arguments near the action name (default is `true`).
 */

function connectReduxDevTools(remotedevPackage, remotedevConnection, target, options) {
  assertTweakedObject(target, "target");

  var opts = _extends({
    logArgsNearName: true
  }, options);

  var handlingMonitorAction = 0; // subscribe to change state (if need more than just logging)

  remotedevConnection.subscribe(function (message) {
    if (message.type === "DISPATCH") {
      handleMonitorActions(remotedevConnection, target, message);
    }
  });
  var initialState = getSnapshot(target);
  remotedevConnection.init(initialState);
  var currentActionId = 0;
  var actionIdSymbol = Symbol("actionId");
  actionTrackingMiddleware(target, {
    onStart: function onStart(ctx) {
      ctx.data[actionIdSymbol] = currentActionId++;
    },
    onResume: function onResume(ctx) {
      // give a chance to the parent to log its own changes before the child starts
      if (ctx.parentContext) {
        log(ctx.parentContext, undefined);
      }

      log(ctx, undefined);
    },
    onSuspend: function onSuspend(ctx) {
      log(ctx, undefined);
    },
    onFinish: function onFinish(ctx, ret) {
      log(ctx, ret.result);
    }
  });

  function handleMonitorActions(remotedev2, target2, message) {
    try {
      handlingMonitorAction++;

      switch (message.payload.type) {
        case "RESET":
          applySnapshot(target2, initialState);
          return remotedev2.init(initialState);

        case "COMMIT":
          return remotedev2.init(getSnapshot(target2));

        case "ROLLBACK":
          return remotedev2.init(remotedevPackage.extractState(message));

        case "JUMP_TO_STATE":
        case "JUMP_TO_ACTION":
          applySnapshot(target2, remotedevPackage.extractState(message));
          return;

        case "IMPORT_STATE":
          var nextLiftedState = message.payload.nextLiftedState;
          var computedStates = nextLiftedState.computedStates;
          applySnapshot(target2, computedStates[computedStates.length - 1].state);
          remotedev2.send(null, nextLiftedState);
          return;

        default:
      }
    } finally {
      handlingMonitorAction--;
    }
  }

  var lastLoggedSnapshot = initialState;

  function log(ctx, result) {
    if (handlingMonitorAction) {
      return;
    }

    var sn = getSnapshot(target); // ignore actions that don't change anything (unless it is a throw)

    if (sn === lastLoggedSnapshot && result !== ActionTrackingResult.Throw) {
      return;
    }

    lastLoggedSnapshot = sn;
    var rootPath = fastGetRootPath(ctx.target);
    var name = getActionContextNameAndTypePath(ctx, rootPath, result);
    var copy = {
      type: name,
      path: rootPath.path,
      args: ctx.args
    };
    remotedevConnection.send(copy, sn);
  }

  function getActionContextNameAndTypePath(ctx, rootPath, result) {
    var pathStr = "[/" + rootPath.path.join("/") + "] ";
    var name = pathStr + ctx.actionName;

    if (opts.logArgsNearName) {
      var args = ctx.args.map(function (a) {
        try {
          return JSON.stringify(a);
        } catch (_unused) {
          return "**unserializable**";
        }
      }).join(", ");

      if (args.length > 64) {
        args = args.slice(0, 64) + "...";
      }

      name += "(" + args + ")";
    }

    var actionId = ctx.data[actionIdSymbol];
    name += " (id " + (actionId !== undefined ? actionId : "?");

    if (ctx.type === ActionContextActionType.Async) {
      name += ", async";
    }

    name += ")";

    if (result === ActionTrackingResult.Throw) {
      name += " -error thrown-";
    }

    if (ctx.parentContext) {
      var parentName = getActionContextNameAndTypePath(ctx.parentContext, fastGetRootPath(ctx.parentContext.target), undefined);

      if (parentName) {
        name = parentName + " >>> " + name;
      }
    }

    return name;
  }
}

/**
 * Adds a reaction that will trigger every time an snapshot changes.
 *
 * @typeparam T Object type.
 * @param node Object to get the snapshot from.
 * @param listener Function that will be triggered when the snapshot changes.
 * @returns A disposer.
 */

function onSnapshot(node, listener) {
  assertTweakedObject(node, "node");
  var currentSnapshot = getSnapshot(node);
  return reaction(function () {
    return getSnapshot(node);
  }, function (newSnapshot) {
    var prevSn = currentSnapshot;
    currentSnapshot = newSnapshot;
    listener(newSnapshot, prevSn);
  });
}

var reduxActionType = "applyAction";
/**
 * Transforms an action call into a redux action.
 *
 * @param actionCall Action call.
 * @returns A redux action.
 */

function actionCallToReduxAction(actionCall) {
  return {
    type: reduxActionType,
    payload: actionCall
  };
}
/**
 * Generates a redux compatible store out of a mobx-keystone object.
 *
 * @template T Object type.
 * @param target Root object.
 * @param middlewares Optional list of redux middlewares.
 * @returns A redux compatible store.
 */

function asReduxStore(target) {
  assertTweakedObject(target, "target");

  var defaultDispatch = function defaultDispatch(action) {
    if (action.type !== reduxActionType) {
      throw failure("action type was expected to be '" + reduxActionType + "', but it was '" + action.type + "'");
    }

    applyAction(target, action.payload);
    return action;
  };

  var store = {
    getState: function getState() {
      return getSnapshot(target);
    },
    dispatch: function dispatch(action) {
      return runMiddlewares(action, runners, defaultDispatch);
    },
    subscribe: function subscribe(listener) {
      return onSnapshot(target, listener);
    }
  };

  for (var _len = arguments.length, middlewares = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    middlewares[_key - 1] = arguments[_key];
  }

  var runners = middlewares.map(function (mw) {
    return mw(store);
  });
  return store;
}

function runMiddlewares(initialAction, runners, next) {
  var i = 0;

  function runNextMiddleware(action) {
    var runner = runners[i];
    i++;

    if (runner) {
      return runner(runNextMiddleware)(action);
    } else {
      return next(action);
    }
  }

  return runNextMiddleware(initialAction);
}

/**
 * A reference model base type.
 * Use `customRef` to create a custom ref constructor.
 */

var Ref =
/*#__PURE__*/
function (_Model) {
  _inheritsLoose(Ref, _Model);

  function Ref() {
    return _Model.apply(this, arguments) || this;
  }

  _createClass(Ref, [{
    key: "maybeCurrent",

    /**
     * The object this reference points to, or `undefined` if the reference is currently invalid.
     */
    get: function get() {
      return this.resolve();
    }
    /**
     * If the reference is currently valid.
     */

  }, {
    key: "isValid",
    get: function get() {
      return !!this.maybeCurrent;
    }
    /**
     * The object this reference points to, or throws if invalid.
     */

  }, {
    key: "current",
    get: function get() {
      var current = this.maybeCurrent;

      if (!current) {
        throw failure("a reference of type '" + this[modelTypeKey] + "' could not resolve an object with id '" + this.id + "'");
      }

      return current;
    }
  }]);

  return Ref;
}(
/*#__PURE__*/
Model({
  /**
   * Reference id.
   */
  id:
  /*#__PURE__*/
  tProp(typesString)
}));

__decorate([computed], Ref.prototype, "maybeCurrent", null);

__decorate([computed], Ref.prototype, "isValid", null);

__decorate([computed], Ref.prototype, "current", null);
/**
 * Checks if a ref object is of a given ref type.
 *
 * @typeparam T Referenced object type.
 * @param ref Reference object.
 * @param refType Reference type.
 * @returns `true` if it is of the given type, false otherwise.
 */


function isRefOfType(ref, refType) {
  return ref instanceof refType.refClass;
}

/**
 * Back-references from object to the references that point to it.
 */

var objectBackRefs =
/*#__PURE__*/
new WeakMap();
/**
 * @ignore
 * @internal
 */

function internalCustomRef(modelTypeId, resolverGen, getId, onResolvedValueChange) {
  var CustomRef =
  /*#__PURE__*/
  function (_Ref) {
    _inheritsLoose(CustomRef, _Ref);

    function CustomRef() {
      return _Ref.apply(this, arguments) || this;
    }

    var _proto = CustomRef.prototype;

    _proto.resolve = function resolve() {
      if (!this.resolver) {
        this.resolver = resolverGen(this);
      }

      return this.resolver(this);
    };

    _proto.onInit = function onInit() {
      var _this = this;

      // listen to changes
      var savedOldTarget;
      var savedFirstTime = true; // according to mwestrate this won't leak as long as we don't keep the disposer around

      reaction(function () {
        return _this.maybeCurrent;
      }, function (newTarget) {
        var oldTarget = savedOldTarget;
        var firstTime = savedFirstTime; // update early in case of thrown exceptions

        savedOldTarget = newTarget;
        savedFirstTime = false;
        updateBackRefs(_this, fn, newTarget, oldTarget);

        if (!firstTime && onResolvedValueChange && newTarget !== oldTarget) {
          onResolvedValueChange(_this, newTarget, oldTarget);
        }
      }, {
        fireImmediately: true
      });
    };

    return CustomRef;
  }(Ref);

  CustomRef = __decorate([model(modelTypeId)], CustomRef);

  var fn = function fn(target) {
    var id;

    if (typeof target === "string") {
      id = target;
    } else {
      assertIsObject(target, "target");
      id = getId(target);
    }

    if (typeof id !== "string") {
      throw failure("ref target object must have an id of string type");
    }

    var ref = new CustomRef({
      id: id
    });
    return ref;
  };

  fn.refClass = CustomRef;
  return fn;
}
/**
 * Uses a model `getRefId()` method whenever possible to get a reference ID.
 * If the model does not have an implementation of that method it returns `undefined`.
 * If the model has an implementation, but that implementation returns anything other than
 * a `string` it will throw.
 *
 * @param target Target object to get the ID from.
 * @returns The string ID or `undefined`.
 */

function getModelRefId(target) {
  if (isModel(target) && target.getRefId) {
    var id = target.getRefId();

    if (typeof id !== "string") {
      throw failure("'getRefId()' must return a string when present");
    }

    return id;
  }

  return undefined;
}

function getBackRefs(target, refType) {
  var backRefs = objectBackRefs.get(target);

  if (!backRefs) {
    backRefs = {
      all: observable.set(undefined, {
        deep: false
      }),
      byType: new WeakMap()
    };
    objectBackRefs.set(target, backRefs);
  }

  if (!refType) {
    return backRefs.all;
  } else {
    var byType = backRefs.byType.get(refType);

    if (!byType) {
      byType = observable.set(undefined, {
        deep: false
      });
      backRefs.byType.set(refType, byType);
    }

    return byType;
  }
}
/**
 * Gets all references that resolve to a given object.
 *
 * @typeparam T Referenced object type.
 * @param target Node the references point to.
 * @param [refType] Pass it to filter by only references of a given type, or do not to get references of any type.
 * @returns An observable set with all reference objects that point to the given object.
 */


function getRefsResolvingTo(target, refType) {
  assertTweakedObject(target, "target");
  var refTypeObject = refType;
  return getBackRefs(target, refTypeObject);
}

function updateBackRefs(ref, refClass, newTarget, oldTarget) {
  if (newTarget === oldTarget) {
    return;
  }

  if (oldTarget) {
    getBackRefs(oldTarget)["delete"](ref);
    getBackRefs(oldTarget, refClass)["delete"](ref);
  }

  if (newTarget) {
    getBackRefs(newTarget).add(ref);
    getBackRefs(newTarget, refClass).add(ref);
  }
}

/**
 * Creates a custom ref to an object, which in its snapshot form has an id.
 *
 * @typeparam T Target object type.
 * @param modelTypeId Unique model type id.
 * @param options Custom reference options.
 * @returns A function that allows you to construct that type of custom reference.
 */

var customRef =
/*#__PURE__*/
action("customRef", function (modelTypeId, options) {
  var getId = options.getId || getModelRefId;
  return internalCustomRef(modelTypeId, function () {
    return options.resolve;
  }, getId, options.onResolvedValueChange);
});

var computedIdTrees =
/*#__PURE__*/
new WeakMap();
/**
 * Creates a root ref to an object, which in its snapshot form has an id.
 * A root ref will only be able to resolve references as long as both the Ref
 * and the referenced object share a common root.
 *
 * @typeparam T Target object type.
 * @param modelTypeId Unique model type id.
 * @param [options] Root reference options.
 * @returns A function that allows you to construct that type of root reference.
 */

var rootRef =
/*#__PURE__*/
action("rootRef", function (modelTypeId, options) {
  var getId = options && options.getId || getModelRefId;
  var onResolvedValueChange = options && options.onResolvedValueChange; // cache/reuse computedIdTrees for same getId function

  var computedIdTree = computedIdTrees.get(getId);

  if (!computedIdTree) {
    computedIdTree = computedWalkTreeAggregate(getId);
    computedIdTrees.set(getId, computedIdTree);
  }

  var resolverGen = function resolverGen(ref) {
    var cachedTarget;
    return function () {
      var refRoot = fastGetRoot(ref);

      if (isRefRootCachedTargetOk(ref, refRoot, cachedTarget, getId)) {
        return cachedTarget;
      } // when not found, everytime a child is added/removed or its id changes we will perform another search
      // this search is only done once for every distinct getId function


      var idMap = computedIdTree.walk(refRoot);
      var newTarget = idMap ? idMap.get(ref.id) : undefined;

      if (newTarget) {
        cachedTarget = newTarget;
      }

      return newTarget;
    };
  };

  return internalCustomRef(modelTypeId, resolverGen, getId, onResolvedValueChange);
});

function isRefRootCachedTargetOk(ref, refRoot, cachedTarget, getId) {
  if (!cachedTarget) return false;
  if (ref.id !== getId(cachedTarget)) return false;
  if (refRoot !== fastGetRoot(cachedTarget)) return false;
  return true;
}

/**
 * Clones an object by doing a `fromSnapshot(getSnapshot(value), { generateNewIds: true })`.
 *
 * @typeparam T Object type.
 * @param node Object to clone.
 * @param [options] Options.
 * @returns The cloned object.
 */

function clone(node, options) {
  assertTweakedObject(node, "node");

  var opts = _extends({
    generateNewIds: true
  }, options);

  var sn = getSnapshot(node);
  return fromSnapshot(sn, opts);
}

/**
 * Deeply compares two values.
 *
 * Supported values are:
 * - Primitives
 * - Boxed observables
 * - Objects, observable objects
 * - Arrays, observable arrays
 * - Typed arrays
 * - Maps, observable maps
 * - Sets, observable sets
 * - Tree nodes (optimized by using snapshot comparison internally)
 *
 * Note that in the case of models the result will be false if their model IDs are different.
 *
 * @param a First value to compare.
 * @param b Second value to compare.
 * @returns `true` if they are the equivalent, `false` otherwise.
 */

function deepEquals(a, b) {
  // quick check for reference
  if (a === b) {
    return true;
  } // use snapshots to compare if possible
  // since snapshots use structural sharing it is more likely
  // to speed up comparisons


  if (isTreeNode(a)) {
    a = getSnapshot(a);
  } else if (isObservable(a)) {
    a = toJS(a, toJSOptions);
  }

  if (isTreeNode(b)) {
    b = getSnapshot(b);
  } else if (isObservable(b)) {
    b = toJS(b, toJSOptions);
  }

  return fastDeepEqual(a, b);
}
var toJSOptions = {
  exportMapsAsObjects: false,
  recurseEverything: false
};

/**
 * A class with the implementationm of draft.
 * Use `draft` to create an instance of this class.
 *
 * @typeparam T Data type.
 */

var Draft =
/*#__PURE__*/
function () {
  /**
   * Creates an instance of Draft.
   * Do not use directly, use `draft` instead.
   *
   * @param original
   */
  function Draft(original) {
    assertTweakedObject(original, "original");
    this.originalData = original;
    this.data = fromSnapshot(this.originalSnapshot, {
      generateNewIds: false
    });
  }
  /**
   * Commits current draft changes to the original object.
   */


  var _proto = Draft.prototype;

  _proto.commit = function commit() {
    applySnapshot(this.originalData, getSnapshot(this.data));
  }
  /**
   * Partially commits current draft changes to the original object.
   * If the path cannot be resolved in either the draft or the original object it will throw.
   * Note that model IDs are checked to be the same when resolving the paths.
   *
   * @param path Path to commit.
   */
  ;

  _proto.commitByPath = function commitByPath(path) {
    var draftTarget = resolvePath(this.data, path);

    if (!draftTarget.resolved) {
      throw failure("path " + JSON.stringify(path) + " could not be resolved in draft object");
    }

    var draftPathIds = pathToTargetPathIdsIgnoringLast(this.data, path);
    var originalTarget = resolvePathCheckingIds(this.originalData, path, draftPathIds);

    if (!originalTarget.resolved) {
      throw failure("path " + JSON.stringify(path) + " could not be resolved in original object");
    }

    applyPatches(this.originalData, [{
      path: path,
      op: "replace",
      value: getSnapshot(draftTarget.value)
    }]);
  }
  /**
   * Resets the draft to be an exact copy of the current state of the original object.
   */
  ;

  _proto.reset = function reset() {
    applySnapshot(this.data, this.originalSnapshot);
  }
  /**
   * Partially resets current draft changes to be the same as the original object.
   * If the path cannot be resolved in either the draft or the original object it will throw.
   * Note that model IDs are checked to be the same when resolving the paths.
   *
   * @param path Path to reset.
   */
  ;

  _proto.resetByPath = function resetByPath(path) {
    var originalTarget = resolvePath(this.originalData, path);

    if (!originalTarget.resolved) {
      throw failure("path " + JSON.stringify(path) + " could not be resolved in original object");
    }

    var originalPathIds = pathToTargetPathIdsIgnoringLast(this.originalData, path);
    var draftTarget = resolvePathCheckingIds(this.data, path, originalPathIds);

    if (!draftTarget.resolved) {
      throw failure("path " + JSON.stringify(path) + " could not be resolved in draft object");
    }

    applyPatches(this.data, [{
      path: path,
      op: "replace",
      value: getSnapshot(originalTarget.value)
    }]);
  }
  /**
   * Returns `true` if the draft has changed compared to the original object, `false` otherwise.
   */
  ;

  /**
   * Returns `true` if the value at the given path of the draft has changed compared to the original object.
   * If the path cannot be resolved in the draft it will throw.
   * If the path cannot be resolved in the original object it will return `true`.
   * Note that model IDs are checked to be the same when resolving the paths.
   *
   * @param path Path to check.
   */
  _proto.isDirtyByPath = function isDirtyByPath(path) {
    var draftTarget = resolvePath(this.data, path);

    if (!draftTarget.resolved) {
      throw failure("path " + JSON.stringify(path) + " could not be resolved in draft object");
    }

    var draftPathIds = pathToTargetPathIdsIgnoringLast(this.data, path);
    var originalTarget = resolvePathCheckingIds(this.originalData, path, draftPathIds);

    if (!originalTarget.resolved) {
      return true;
    }

    return !deepEquals(draftTarget.value, originalTarget.value);
  };

  _createClass(Draft, [{
    key: "isDirty",
    get: function get() {
      return !deepEquals(getSnapshot(this.data), this.originalSnapshot);
    }
  }, {
    key: "originalSnapshot",
    get: function get() {
      return getSnapshot(this.originalData);
    }
  }]);

  return Draft;
}();

__decorate([action], Draft.prototype, "commit", null);

__decorate([action], Draft.prototype, "commitByPath", null);

__decorate([action], Draft.prototype, "reset", null);

__decorate([action], Draft.prototype, "resetByPath", null);

__decorate([computed], Draft.prototype, "isDirty", null);

__decorate([computed], Draft.prototype, "originalSnapshot", null);
/**
 * Creates a draft copy of a tree node and all its children.
 *
 * @typeparam T Data type.
 * @param original Original node.
 * @returns The draft object.
 */


function draft(original) {
  return new Draft(original);
}

function pathToTargetPathIdsIgnoringLast(root, path) {
  var pathIds = pathToTargetPathIds(root, path);

  if (pathIds.length >= 1) {
    // never check the last object id
    pathIds[pathIds.length - 1] = skipIdChecking;
  }

  return pathIds;
}

/**
 * Context that allows access to the sandbox manager this node runs under (if any).
 */

var sandboxManagerContext =
/*#__PURE__*/
createContext();
/**
 * Returns the sandbox manager of a node, or `undefined` if none.
 *
 * @param node Node to check.
 * @returns The sandbox manager of a node, or `undefined` if none.
 */

function getNodeSandboxManager(node) {
  return sandboxManagerContext.get(node);
}
/**
 * Returns if a given node is a sandboxed node.
 *
 * @param node Node to check.
 * @returns `true` if it is sandboxed, `false`
 */

function isSandboxedNode(node) {
  return !!getNodeSandboxManager(node);
}
/**
 * Manager class returned by `sandbox` that allows you to make changes to a sandbox copy of the
 * original subtree and apply them to the original subtree or reject them.
 */

var SandboxManager =
/*#__PURE__*/
function () {
  /**
   * Creates an instance of `SandboxManager`.
   * Do not use directly, use `sandbox` instead.
   *
   * @param subtreeRoot Subtree root target object.
   */
  function SandboxManager(subtreeRoot) {
    var _this = this;

    this.subtreeRoot = subtreeRoot;
    assertTweakedObject(subtreeRoot, "subtreeRoot"); // we temporarily set the default value of the context manager so that
    // cloned nodes can access it while in their onInit phase

    var previousContextDefault = sandboxManagerContext.getDefault();
    sandboxManagerContext.setDefault(this);

    try {
      this.subtreeRootClone = clone(subtreeRoot, {
        generateNewIds: false
      });
      sandboxManagerContext.set(this.subtreeRootClone, this);
    } catch (err) {
      throw err;
    } finally {
      sandboxManagerContext.setDefault(previousContextDefault);
    }

    var wasRS = false;
    var disposeReactionRS = reaction(function () {
      return isRootStore(subtreeRoot);
    }, function (isRS) {
      if (isRS !== wasRS) {
        wasRS = isRS;

        if (isRS) {
          registerRootStore(_this.subtreeRootClone);
        } else {
          unregisterRootStore(_this.subtreeRootClone);
        }
      }
    }, {
      fireImmediately: true
    });
    var disposeOnPatches = onPatches(subtreeRoot, function (patches) {
      if (_this.withSandboxPatchRecorder) {
        throw failure("original subtree must not change while 'withSandbox' executes");
      }

      _this.allowWrite(function () {
        applyPatches(_this.subtreeRootClone, patches);
      });
    });

    var _readonlyMiddleware = readonlyMiddleware(this.subtreeRootClone),
        allowWrite = _readonlyMiddleware.allowWrite,
        disposeReadonlyMW = _readonlyMiddleware.dispose;

    this.allowWrite = allowWrite;

    this.disposer = function () {
      disposeReactionRS();
      disposeOnPatches();
      disposeReadonlyMW();

      if (isRootStore(_this.subtreeRootClone)) {
        unregisterRootStore(_this.subtreeRootClone);
      }

      _this.disposer = function () {};
    };
  }
  /**
   * Executes `fn` with a sandbox copy of `node`. The changes made to the sandbox in `fn` can be
   * accepted, i.e. applied to the original subtree, or rejected.
   *
   * @typeparam T Object type.
   * @typeparam R Return type.
   * @param node Object or tuple of objects for which to obtain a sandbox copy.
   * @param fn Function that is called with a sandbox copy of `node`. Any changes made to the
   * sandbox are applied to the original subtree when `fn` returns `true` or
   * `{ commit: true, ... }`. When `fn` returns `false` or `{ commit: false, ... }` the changes made
   * to the sandbox are rejected.
   * @returns Value of type `R` when `fn` returns an object of type `{ commit: boolean; return: R }`
   * or `void` when `fn` returns a boolean.
   */


  var _proto = SandboxManager.prototype;

  _proto.withSandbox = function withSandbox(node, fn) {
    assertIsFunction(fn, "fn");
    var isNodesArray = Array.isArray(node) && !isTweakedObject(node, false);
    var nodes = isNodesArray ? node : [node];

    var _this$prepareSandboxC = this.prepareSandboxChanges(nodes),
        sandboxNodes = _this$prepareSandboxC.sandboxNodes,
        applyRecorderChanges = _this$prepareSandboxC.applyRecorderChanges;

    var commit = false;

    try {
      var returnValue = this.allowWrite(function () {
        return fn(isNodesArray ? sandboxNodes : sandboxNodes[0]);
      });

      if (typeof returnValue === "boolean") {
        commit = returnValue;
        return undefined;
      } else {
        commit = returnValue.commit;
        return returnValue["return"];
      }
    } finally {
      applyRecorderChanges(commit);
    }
  }
  /**
   * Disposes of the sandbox.
   */
  ;

  _proto.dispose = function dispose() {
    this.disposer();
  };

  _proto.prepareSandboxChanges = function prepareSandboxChanges(nodes) {
    var _this2 = this;

    var isNestedWithSandboxCall = !!this.withSandboxPatchRecorder;
    var sandboxNodes = nodes.map(function (node) {
      assertTweakedObject(node, "node");
      var path = getParentToChildPath(isNestedWithSandboxCall ? _this2.subtreeRootClone : _this2.subtreeRoot, node);

      if (!path) {
        throw failure("node is not a child of subtreeRoot" + (isNestedWithSandboxCall ? "Clone" : ""));
      }

      var sandboxNode = resolvePath(_this2.subtreeRootClone, path).value;

      if (!sandboxNode) {
        throw failure("path could not be resolved - sandbox may be out of sync with original tree");
      }

      return sandboxNode;
    });

    if (!this.withSandboxPatchRecorder) {
      this.withSandboxPatchRecorder = patchRecorder(this.subtreeRootClone);
    }

    var recorder = this.withSandboxPatchRecorder;
    var numRecorderEvents = recorder.events.length;

    var applyRecorderChanges = function applyRecorderChanges(commit) {
      if (!isNestedWithSandboxCall) {
        recorder.dispose();
        _this2.withSandboxPatchRecorder = undefined;
      }

      runInAction(function () {
        if (commit) {
          if (!isNestedWithSandboxCall) {
            var len = recorder.events.length;

            for (var i = 0; i < len; i++) {
              applyPatches(_this2.subtreeRoot, recorder.events[i].patches);
            }
          }
        } else {
          _this2.allowWrite(function () {
            var i = recorder.events.length;

            while (i-- > numRecorderEvents) {
              applyPatches(_this2.subtreeRootClone, recorder.events[i].inversePatches, true);
            }
          });
        }
      });
    };

    return {
      sandboxNodes: sandboxNodes,
      applyRecorderChanges: applyRecorderChanges
    };
  };

  return SandboxManager;
}();
/**
 * Creates a sandbox.
 *
 * @param subtreeRoot Subtree root target object.
 * @returns A `SandboxManager` which allows you to manage the sandbox operations and dispose of the
 * sandbox.
 */

function sandbox(subtreeRoot) {
  return new SandboxManager(subtreeRoot);
}

/**
 * A set that is backed by an array.
 * Use `arraySet` to create it.
 */

var ArraySet =
/*#__PURE__*/
function (_Model) {
  _inheritsLoose(ArraySet, _Model);

  function ArraySet() {
    return _Model.apply(this, arguments) || this;
  }

  var _proto = ArraySet.prototype;

  _proto.add = function add(value) {
    var items = this.items;

    if (!items.includes(value)) {
      items.push(value);
    }

    return this;
  };

  _proto.clear = function clear() {
    this.items.length = 0;
  };

  _proto["delete"] = function _delete(value) {
    var items = this.items;
    var index = items.findIndex(function (t) {
      return t === value;
    });

    if (index >= 0) {
      items.splice(index, 1);
      return true;
    } else {
      return false;
    }
  };

  _proto.forEach = function forEach(callbackfn, thisArg) {
    // we cannot use the set implementation since we need to pass this as set
    var items = this.items;
    var len = items.length;

    for (var i = 0; i < len; i++) {
      var k = items[i];
      callbackfn.call(thisArg, k, k, this);
    }
  };

  _proto.has = function has(value) {
    return this.items.includes(value);
  };

  _proto.keys = function keys() {
    return this.values(); // yes, values
  };

  _proto.values = function values$1() {
    var items = this.items;
    return values(items)[Symbol.iterator]();
  };

  _proto.entries = function entries() {
    var items = this.items; // TODO: should use an actual iterator

    return items.map(function (v) {
      return [v, v];
    }).values();
  };

  _proto[Symbol.iterator] = function () {
    return this.values();
  };

  _createClass(ArraySet, [{
    key: "size",
    get: function get() {
      return this.items.length;
    }
  }, {
    key: Symbol.toStringTag,
    get: function get() {
      return "ArraySet";
    }
  }]);

  return ArraySet;
}(
/*#__PURE__*/
Model({
  items:
  /*#__PURE__*/
  tProp(
  /*#__PURE__*/
  typesArray(
  /*#__PURE__*/
  typesUnchecked()), function () {
    return [];
  })
}));

__decorate([modelAction], ArraySet.prototype, "add", null);

__decorate([modelAction], ArraySet.prototype, "clear", null);

__decorate([modelAction], ArraySet.prototype, "delete", null);

ArraySet =
/*#__PURE__*/
__decorate([
/*#__PURE__*/
model("mobx-keystone/ArraySet")], ArraySet);
/**
 * Creates a new ArraySet model instance.
 *
 * @typeparam V Value type.
 * @param [entries] Optional initial values.
 */

function arraySet(values) {
  var initialArr = values ? values.slice() : [];
  return new ArraySet({
    items: initialArr
  });
}

/**
 * A type that represents an array backed set ArraySet.
 *
 * Example:
 * ```ts
 * const numberSetType = types.arraySet(types.number)
 * ```
 *
 * @typeparam T Value type.
 * @param valueType Value type.
 * @returns
 */

function typesArraySet(valueType) {
  var typeInfoGen = function typeInfoGen(t) {
    return new ArraySetTypeInfo(t, resolveStandardType(valueType));
  };

  return lateTypeChecker(function () {
    var valueChecker = resolveTypeChecker(valueType);

    var getTypeName = function getTypeName() {
      for (var _len = arguments.length, recursiveTypeCheckers = new Array(_len), _key = 0; _key < _len; _key++) {
        recursiveTypeCheckers[_key] = arguments[_key];
      }

      return "ArraySet<" + valueChecker.getTypeName.apply(valueChecker, recursiveTypeCheckers.concat([valueChecker])) + ">";
    };

    var thisTc = new TypeChecker(function (obj, path) {
      if (!(obj instanceof ArraySet)) {
        return new TypeCheckError(path, getTypeName(thisTc), obj);
      }

      var dataTypeChecker = typesObject(function () {
        return {
          items: typesArray(valueChecker)
        };
      });
      var resolvedTc = resolveTypeChecker(dataTypeChecker);
      return resolvedTc.check(obj.$, path);
    }, getTypeName, typeInfoGen);
    return thisTc;
  }, typeInfoGen);
}
/**
 * `types.arraySet` type info.
 */

var ArraySetTypeInfo =
/*#__PURE__*/
function (_TypeInfo) {
  _inheritsLoose(ArraySetTypeInfo, _TypeInfo);

  function ArraySetTypeInfo(originalType, valueType) {
    var _this;

    _this = _TypeInfo.call(this, originalType) || this;
    _this.valueType = valueType;
    return _this;
  }

  _createClass(ArraySetTypeInfo, [{
    key: "valueTypeInfo",
    get: function get() {
      return getTypeInfo(this.valueType);
    }
  }]);

  return ArraySetTypeInfo;
}(TypeInfo);

/**
 * A type that represents the union of several other types (a | b | c | ...).
 *
 * Example:
 * ```ts
 * const booleanOrNumberType = types.or(types.boolean, types.number)
 * ```
 *
 * @typeparam T Type.
 * @param orTypes Possible types.
 * @returns
 */

function typesOr() {
  for (var _len = arguments.length, orTypes = new Array(_len), _key = 0; _key < _len; _key++) {
    orTypes[_key] = arguments[_key];
  }

  var typeInfoGen = function typeInfoGen(t) {
    return new OrTypeInfo(t, orTypes.map(resolveStandardType));
  };

  return lateTypeChecker(function () {
    var checkers = orTypes.map(resolveTypeChecker); // if the or includes unchecked then it is unchecked

    if (checkers.some(function (tc) {
      return tc.unchecked;
    })) {
      return typesUnchecked();
    }

    var getTypeName = function getTypeName() {
      for (var _len2 = arguments.length, recursiveTypeCheckers = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        recursiveTypeCheckers[_key2] = arguments[_key2];
      }

      var typeNames = checkers.map(function (tc) {
        if (recursiveTypeCheckers.includes(tc)) {
          return "...";
        }

        return tc.getTypeName.apply(tc, recursiveTypeCheckers.concat([tc]));
      });
      return typeNames.join(" | ");
    };

    var thisTc = new TypeChecker(function (value, path) {
      var noMatchingType = checkers.every(function (tc) {
        return !!tc.check(value, path);
      });

      if (noMatchingType) {
        return new TypeCheckError(path, getTypeName(thisTc), value);
      } else {
        return null;
      }
    }, getTypeName, typeInfoGen);
    return thisTc;
  }, typeInfoGen);
}
/**
 * `types.or` type info.
 */

var OrTypeInfo =
/*#__PURE__*/
function (_TypeInfo) {
  _inheritsLoose(OrTypeInfo, _TypeInfo);

  function OrTypeInfo(thisType, orTypes) {
    var _this;

    _this = _TypeInfo.call(this, thisType) || this;
    _this.orTypes = orTypes; // memoize to always return the same array on the getter

    _this._orTypeInfos = lateVal(function () {
      return _this.orTypes.map(getTypeInfo);
    });
    return _this;
  }

  _createClass(OrTypeInfo, [{
    key: "orTypeInfos",
    get: function get() {
      return this._orTypeInfos();
    }
  }]);

  return OrTypeInfo;
}(TypeInfo);

function enumValues(e) {
  var vals = [];

  for (var _i = 0, _Object$keys = Object.keys(e); _i < _Object$keys.length; _i++) {
    var k = _Object$keys[_i];
    var v = e[k]; // we have to do this since TS does something weird
    // to number values
    // Hi = 0 -> { Hi: 0, 0: "Hi" }

    if (typeof v !== "string" || e[v] !== +k) {
      vals.push(v);
    }
  }

  return vals;
}
/**
 * An enum type, based on a Typescript alike enum object.
 * Syntactic sugar for `types.or(...enum_values.map(types.literal))`
 *
 * Example:
 * ```ts
 * enum Color {
 *   Red = "red",
 *   Green = "green"
 * }
 *
 * const colorType = types.enum<Color>(Color)
 * ```
 *
 * @template E Enum type.
 * @param enumObject
 * @returns
 */


function typesEnum(enumObject) {
  assertIsObject(enumObject, "enumObject");
  var literals = enumValues(enumObject).map(function (e) {
    return typesLiteral(e);
  });
  return typesOr.apply(void 0, literals);
}

/**
 * A type that represents either a type or undefined.
 * Syntactic sugar for `types.or(baseType, types.undefined)`
 *
 * Example:
 * ```ts
 * const numberOrUndefinedType = types.maybe(types.number)
 * ```
 *
 * @typeparam S Type.
 * @param baseType Type.
 * @returns
 */

function typesMaybe(baseType) {
  return typesOr(baseType, typesUndefined);
}
/**
 * A type that represents either a type or null.
 * Syntactic sugar for `types.or(baseType, types.null)`
 *
 *  * Example:
 * ```ts
 * const numberOrNullType = types.maybeNull(types.number)
 * ```
 *
 * @typeparam S Type.
 * @param type Type.
 * @returns
 */

function typesMaybeNull(type) {
  return typesOr(type, typesNull);
}

/**
 * A type that represents an object-like map, an object with string keys and values all of a same given type.
 *
 * Example:
 * ```ts
 * // { [k: string]: number }
 * const numberMapType = types.record(types.number)
 * ```
 *
 * @typeparam T Type.
 * @param valueType Type of the values of the object-like map.
 * @returns
 */

function typesRecord(valueType) {
  var typeInfoGen = function typeInfoGen(tc) {
    return new RecordTypeInfo(tc, resolveStandardType(valueType));
  };

  return lateTypeChecker(function () {
    var valueChecker = resolveTypeChecker(valueType);

    var getTypeName = function getTypeName() {
      for (var _len = arguments.length, recursiveTypeCheckers = new Array(_len), _key = 0; _key < _len; _key++) {
        recursiveTypeCheckers[_key] = arguments[_key];
      }

      return "Record<" + valueChecker.getTypeName.apply(valueChecker, recursiveTypeCheckers.concat([valueChecker])) + ">";
    };

    var thisTc = new TypeChecker(function (obj, path) {
      if (!isObject(obj)) return new TypeCheckError(path, getTypeName(thisTc), obj);

      if (!valueChecker.unchecked) {
        var keys = Object.keys(obj);

        for (var i = 0; i < keys.length; i++) {
          var k = keys[i];
          var v = obj[k];
          var valueError = valueChecker.check(v, [].concat(path, [k]));

          if (valueError) {
            return valueError;
          }
        }
      }

      return null;
    }, getTypeName, typeInfoGen);
    return thisTc;
  }, typeInfoGen);
}
/**
 * `types.record` type info.
 */

var RecordTypeInfo =
/*#__PURE__*/
function (_TypeInfo) {
  _inheritsLoose(RecordTypeInfo, _TypeInfo);

  function RecordTypeInfo(thisType, valueType) {
    var _this;

    _this = _TypeInfo.call(this, thisType) || this;
    _this.valueType = valueType;
    return _this;
  }

  _createClass(RecordTypeInfo, [{
    key: "valueTypeInfo",
    get: function get() {
      return getTypeInfo(this.valueType);
    }
  }]);

  return RecordTypeInfo;
}(TypeInfo);

/**
 * A map that is backed by an object-like map.
 * Use `objectMap` to create it.
 */

var ObjectMap =
/*#__PURE__*/
function (_Model) {
  _inheritsLoose(ObjectMap, _Model);

  function ObjectMap() {
    return _Model.apply(this, arguments) || this;
  }

  var _proto = ObjectMap.prototype;

  _proto.clear = function clear() {
    var items = this.items;
    var keys = Object.keys(items);
    var len = keys.length;

    for (var i = 0; i < len; i++) {
      var k = keys[i];
      remove(items, k);
    }
  };

  _proto["delete"] = function _delete(key) {
    var hasKey = this.has(key);

    if (hasKey) {
      remove(this.items, key);
      return true;
    } else {
      return false;
    }
  };

  _proto.forEach = function forEach(callbackfn, thisArg) {
    // we cannot use the map implementation since we need to pass this as map
    var items = this.items;
    var keys = Object.keys(items);
    var len = keys.length;

    for (var i = 0; i < len; i++) {
      var k = keys[i];
      callbackfn.call(thisArg, items[k], k, this);
    }
  };

  _proto.get = function get$1(key) {
    return get(this.items, key);
  };

  _proto.has = function has$1(key) {
    return has(this.items, key);
  };

  _proto.set = function set$1(key, value) {
    set(this.items, key, value);

    return this;
  };

  _proto.keys = function keys$1() {
    // TODO: should use an actual iterator
    return keys(this.items)[Symbol.iterator]();
  };

  _proto.values = function values$1() {
    // TODO: should use an actual iterator
    return values(this.items)[Symbol.iterator]();
  };

  _proto.entries = function entries$1() {
    // TODO: should use an actual iterator
    return entries(this.items)[Symbol.iterator]();
  };

  _proto[Symbol.iterator] = function () {
    return this.entries();
  };

  _createClass(ObjectMap, [{
    key: "size",
    get: function get() {
      return keys(this.items).length;
    }
  }, {
    key: Symbol.toStringTag,
    get: function get() {
      return "ObjectMap";
    }
  }]);

  return ObjectMap;
}(
/*#__PURE__*/
Model({
  items:
  /*#__PURE__*/
  tProp(
  /*#__PURE__*/
  typesRecord(
  /*#__PURE__*/
  typesUnchecked()), function () {
    return {};
  })
}));

__decorate([modelAction], ObjectMap.prototype, "clear", null);

__decorate([modelAction], ObjectMap.prototype, "delete", null);

__decorate([modelAction], ObjectMap.prototype, "set", null);

ObjectMap =
/*#__PURE__*/
__decorate([
/*#__PURE__*/
model("mobx-keystone/ObjectMap")], ObjectMap);
/**
 * Creates a new ObjectMap model instance.
 *
 * @typeparam V Value type.
 * @param [entries] Optional initial values.
 */

function objectMap(entries) {
  var initialObj = {};

  if (entries) {
    var len = entries.length;

    for (var i = 0; i < len; i++) {
      var entry = entries[i];
      initialObj[entry[0]] = entry[1];
    }
  }

  return new ObjectMap({
    items: initialObj
  });
}

/**
 * A type that represents an object-like map ObjectMap.
 *
 * Example:
 * ```ts
 * const numberMapType = types.objectMap(types.number)
 * ```
 *
 * @typeparam T Value type.
 * @param valueType Value type.
 * @returns
 */

function typesObjectMap(valueType) {
  var typeInfoGen = function typeInfoGen(t) {
    return new ObjectMapTypeInfo(t, resolveStandardType(valueType));
  };

  return lateTypeChecker(function () {
    var valueChecker = resolveTypeChecker(valueType);

    var getTypeName = function getTypeName() {
      for (var _len = arguments.length, recursiveTypeCheckers = new Array(_len), _key = 0; _key < _len; _key++) {
        recursiveTypeCheckers[_key] = arguments[_key];
      }

      return "ObjectMap<" + valueChecker.getTypeName.apply(valueChecker, recursiveTypeCheckers.concat([valueChecker])) + ">";
    };

    var thisTc = new TypeChecker(function (obj, path) {
      if (!(obj instanceof ObjectMap)) {
        return new TypeCheckError(path, getTypeName(thisTc), obj);
      }

      var dataTypeChecker = typesObject(function () {
        return {
          items: typesRecord(valueChecker)
        };
      });
      var resolvedTc = resolveTypeChecker(dataTypeChecker);
      return resolvedTc.check(obj.$, path);
    }, getTypeName, typeInfoGen);
    return thisTc;
  }, typeInfoGen);
}
/**
 * `types.objectMap` type info.
 */

var ObjectMapTypeInfo =
/*#__PURE__*/
function (_TypeInfo) {
  _inheritsLoose(ObjectMapTypeInfo, _TypeInfo);

  function ObjectMapTypeInfo(thisType, valueType) {
    var _this;

    _this = _TypeInfo.call(this, thisType) || this;
    _this.valueType = valueType;
    return _this;
  }

  _createClass(ObjectMapTypeInfo, [{
    key: "valueTypeInfo",
    get: function get() {
      return getTypeInfo(this.valueType);
    }
  }]);

  return ObjectMapTypeInfo;
}(TypeInfo);

/**
 * A type that represents a reference to an object or model.
 *
 * Example:
 * ```ts
 * const refToSomeObject = types.ref<SomeObject>()
 * ```
 *
 * @typeparam M Model type.
 * @returns
 */

function typesRef() {
  return refTypeChecker;
}
var typeName = "Ref";
var refDataTypeChecker =
/*#__PURE__*/
typesObject(function () {
  return {
    id: typesString
  };
});
var refTypeChecker =
/*#__PURE__*/
new TypeChecker(function (value, path) {
  if (!(value instanceof Ref)) {
    return new TypeCheckError(path, typeName, value);
  }

  var resolvedTc = resolveTypeChecker(refDataTypeChecker);
  return resolvedTc.check(value.$, path);
}, function () {
  return typeName;
}, function (t) {
  return new RefTypeInfo(t);
});
/**
 * `types.ref` type info.
 */

var RefTypeInfo =
/*#__PURE__*/
function (_TypeInfo) {
  _inheritsLoose(RefTypeInfo, _TypeInfo);

  function RefTypeInfo() {
    return _TypeInfo.apply(this, arguments) || this;
  }

  return RefTypeInfo;
}(TypeInfo);

/**
 * A type that represents an tuple of values of a given type.
 *
 * Example:
 * ```ts
 * const stringNumberTupleType = types.tuple(types.string, types.number)
 * ```
 *
 * @typeparam T Item types.
 * @param itemType Type of inner items.
 * @returns
 */

function typesTuple() {
  for (var _len = arguments.length, itemTypes = new Array(_len), _key = 0; _key < _len; _key++) {
    itemTypes[_key] = arguments[_key];
  }

  var typeInfoGen = function typeInfoGen(t) {
    return new TupleTypeInfo(t, itemTypes.map(resolveStandardType));
  };

  return lateTypeChecker(function () {
    var checkers = itemTypes.map(resolveTypeChecker);

    var getTypeName = function getTypeName() {
      for (var _len2 = arguments.length, recursiveTypeCheckers = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        recursiveTypeCheckers[_key2] = arguments[_key2];
      }

      var typeNames = checkers.map(function (tc) {
        if (recursiveTypeCheckers.includes(tc)) {
          return "...";
        }

        return tc.getTypeName.apply(tc, recursiveTypeCheckers.concat([tc]));
      });
      return "[" + typeNames.join(", ") + "]";
    };

    var thisTc = new TypeChecker(function (array, path) {
      if (!isArray(array) || array.length !== itemTypes.length) {
        return new TypeCheckError(path, getTypeName(thisTc), array);
      }

      for (var i = 0; i < array.length; i++) {
        var itemChecker = checkers[i];

        if (!itemChecker.unchecked) {
          var itemError = itemChecker.check(array[i], [].concat(path, [i]));

          if (itemError) {
            return itemError;
          }
        }
      }

      return null;
    }, getTypeName, typeInfoGen);
    return thisTc;
  }, typeInfoGen);
}
/**
 * `types.tuple` type info.
 */

var TupleTypeInfo =
/*#__PURE__*/
function (_TypeInfo) {
  _inheritsLoose(TupleTypeInfo, _TypeInfo);

  function TupleTypeInfo(thisType, itemTypes) {
    var _this;

    _this = _TypeInfo.call(this, thisType) || this;
    _this.itemTypes = itemTypes; // memoize to always return the same array on the getter

    _this._itemTypeInfos = lateVal(function () {
      return _this.itemTypes.map(getTypeInfo);
    });
    return _this;
  }

  _createClass(TupleTypeInfo, [{
    key: "itemTypeInfos",
    get: function get() {
      return this._itemTypeInfos();
    }
  }]);

  return TupleTypeInfo;
}(TypeInfo);

var types = {
  literal: typesLiteral,
  undefined: typesUndefined,
  "null": typesNull,
  "boolean": typesBoolean,
  number: typesNumber,
  string: typesString,
  or: typesOr,
  maybe: typesMaybe,
  maybeNull: typesMaybeNull,
  array: typesArray,
  record: typesRecord,
  unchecked: typesUnchecked,
  model: typesModel,
  object: typesObject,
  ref: typesRef,
  frozen: typesFrozen,
  "enum": typesEnum,
  refinement: typesRefinement,
  integer: typesInteger,
  nonEmptyString: typesNonEmptyString,
  objectMap: typesObjectMap,
  arraySet: typesArraySet,
  tuple: typesTuple,
  mapArray: function mapArray(valueType) {
    return typesArray(typesTuple(typesString, valueType));
  },
  setArray: function setArray(valueType) {
    return typesArray(valueType);
  },
  mapObject: function mapObject(valueType) {
    return typesRecord(valueType);
  },
  dateString: typesNonEmptyString,
  dateTimestamp: typesInteger
};

var ArrayAsMap =
/*#__PURE__*/
function () {
  function ArrayAsMap(getTarget) {
    this.getTarget = getTarget;
  }

  var _proto = ArrayAsMap.prototype;

  _proto.clear = function clear() {
    var items = this.getTarget();
    items.length = 0;
  };

  _proto["delete"] = function _delete(key) {
    var items = this.getTarget();
    var index = items.findIndex(function (t) {
      return t[0] === key;
    });

    if (index >= 0) {
      items.splice(index, 1);
      return true;
    } else {
      return false;
    }
  };

  _proto.forEach = function forEach(callbackfn, thisArg) {
    var items = this.getTarget();
    var len = items.length;

    for (var i = 0; i < len; i++) {
      var t = items[i];
      callbackfn.call(thisArg, t[1], t[0], this);
    }
  };

  _proto.get = function get(key) {
    var items = this.getTarget();
    var found = items.find(function (t) {
      return t[0] === key;
    });
    return found ? found[1] : undefined;
  };

  _proto.has = function has(key) {
    var items = this.getTarget();
    return items.some(function (t) {
      return t[0] === key;
    });
  };

  _proto.set = function set(key, value) {
    var items = this.getTarget();
    var found = items.find(function (t) {
      return t[0] === key;
    });

    if (found) {
      found[1] = value;
    } else {
      items.push([key, value]);
    }

    return this;
  };

  _proto.keys = function keys() {
    var items = this.getTarget(); // TODO: should use an actual iterator

    return items.map(function (t) {
      return t[0];
    })[Symbol.iterator]();
  };

  _proto.values = function values() {
    var items = this.getTarget(); // TODO: should use an actual iterator

    return items.map(function (t) {
      return t[1];
    })[Symbol.iterator]();
  };

  _proto.entries = function entries() {
    var items = this.getTarget(); // we do the copy just to keep reactivity

    return items.map(function (t) {
      return [t[0], t[1]];
    })[Symbol.iterator]();
  };

  _proto[Symbol.iterator] = function () {
    return this.entries();
  };

  _createClass(ArrayAsMap, [{
    key: "size",
    get: function get() {
      var items = this.getTarget();
      return items.length;
    }
  }, {
    key: Symbol.toStringTag,
    get: function get() {
      return "Map";
    }
  }]);

  return ArrayAsMap;
}();

__decorate([action], ArrayAsMap.prototype, "clear", null);

__decorate([action], ArrayAsMap.prototype, "delete", null);

__decorate([action], ArrayAsMap.prototype, "set", null);
/**
 * @deprecated Consider using `prop_mapArray` or `tProp_mapArray` instead.
 *
 * Returns a wrapper that wraps an observable tuple array `[K, V][]`
 * into a map alike interface.
 *
 * @typeparam K Key type
 * @typeparam V Value type
 * @param getTarget Target store array getter.
 * @returns
 */


function arrayAsMap(getTarget) {
  return new ArrayAsMap(getTarget);
}

var ArrayAsSet =
/*#__PURE__*/
function () {
  function ArrayAsSet(getTarget) {
    this.getTarget = getTarget;
  }

  var _proto = ArrayAsSet.prototype;

  _proto.add = function add(value) {
    var items = this.getTarget();

    if (!items.includes(value)) {
      items.push(value);
    }

    return this;
  };

  _proto.clear = function clear() {
    var items = this.getTarget();
    items.length = 0;
  };

  _proto["delete"] = function _delete(value) {
    var items = this.getTarget();
    var index = items.findIndex(function (t) {
      return t === value;
    });

    if (index >= 0) {
      items.splice(index, 1);
      return true;
    } else {
      return false;
    }
  };

  _proto.forEach = function forEach(callbackfn, thisArg) {
    var items = this.getTarget();
    var len = items.length;

    for (var i = 0; i < len; i++) {
      var t = items[i];
      callbackfn.call(thisArg, t, t, this);
    }
  };

  _proto.has = function has(value) {
    var items = this.getTarget();
    return items.includes(value);
  };

  _proto.keys = function keys() {
    return this.values(); // yes, values
  };

  _proto.values = function values$1() {
    var items = this.getTarget();
    return values(items)[Symbol.iterator]();
  };

  _proto.entries = function entries() {
    var items = this.getTarget(); // TODO: should use an actual iterator

    return items.map(function (v) {
      return [v, v];
    }).values();
  };

  _proto[Symbol.iterator] = function () {
    return this.values();
  };

  _createClass(ArrayAsSet, [{
    key: "size",
    get: function get() {
      var items = this.getTarget();
      return items.length;
    }
  }, {
    key: Symbol.toStringTag,
    get: function get() {
      return "Set";
    }
  }]);

  return ArrayAsSet;
}();

__decorate([action], ArrayAsSet.prototype, "add", null);

__decorate([action], ArrayAsSet.prototype, "clear", null);

__decorate([action], ArrayAsSet.prototype, "delete", null);
/**
 * @deprecated Consider using `prop_setArray` or `tProp_setArray` instead.
 *
 * Returns a wrapper that wraps an observable array `V[]`
 * into a set alike interface.
 *
 * @typeparam V Value type
 * @param getTarget Target store array getter.
 * @returns
 */


function arrayAsSet(getTarget) {
  return new ArrayAsSet(getTarget);
}

var ObjectAsMap =
/*#__PURE__*/
function () {
  function ObjectAsMap(getTarget) {
    this.getTarget = getTarget;
  }

  var _proto = ObjectAsMap.prototype;

  _proto.clear = function clear() {
    var items = this.getTarget();
    var keys = Object.keys(items);
    var len = keys.length;

    for (var i = 0; i < len; i++) {
      var k = keys[i];
      remove(items, k);
    }
  };

  _proto["delete"] = function _delete(key) {
    var items = this.getTarget();
    var hasKey = this.has(key);

    if (hasKey) {
      remove(items, key);
      return true;
    } else {
      return false;
    }
  };

  _proto.forEach = function forEach(callbackfn, thisArg) {
    var items = this.getTarget();
    var keys = Object.keys(items);
    var len = keys.length;

    for (var i = 0; i < len; i++) {
      var k = keys[i];
      callbackfn.call(thisArg, items[k], k, this);
    }
  };

  _proto.get = function get$1(key) {
    var items = this.getTarget();
    return get(items, key);
  };

  _proto.has = function has$1(key) {
    var items = this.getTarget();
    return has(items, key);
  };

  _proto.set = function set$1(key, value) {
    var items = this.getTarget();

    set(items, key, value);

    return this;
  };

  _proto.keys = function keys$1() {
    var items = this.getTarget(); // TODO: should use an actual iterator

    return keys(items)[Symbol.iterator]();
  };

  _proto.values = function values$1() {
    var items = this.getTarget(); // TODO: should use an actual iterator

    return values(items)[Symbol.iterator]();
  };

  _proto.entries = function entries$1() {
    var items = this.getTarget(); // TODO: should use an actual iterator

    return entries(items)[Symbol.iterator]();
  };

  _proto[Symbol.iterator] = function () {
    return this.entries();
  };

  _createClass(ObjectAsMap, [{
    key: "size",
    get: function get() {
      var items = this.getTarget();
      return keys(items).length;
    }
  }, {
    key: Symbol.toStringTag,
    get: function get() {
      return "Map";
    }
  }]);

  return ObjectAsMap;
}();

__decorate([action], ObjectAsMap.prototype, "clear", null);

__decorate([action], ObjectAsMap.prototype, "delete", null);

__decorate([action], ObjectAsMap.prototype, "set", null);
/**
 * @deprecated Consider using `prop_mapObject` or `tProp_mapObject` instead.
 *
 * Returns a wrapper that wraps an observable object
 * `Record<string, V>` into a map alike interface.
 *
 * @typeparam V Value type
 * @param getTarget Target store object getter.
 * @returns
 */


function objectAsMap(getTarget) {
  return new ObjectAsMap(getTarget);
}

export { ActionContextActionType, ActionContextAsyncStepType, ActionTrackingResult, ArrayAsMap, ArrayAsSet, ArraySet, ArraySetTypeInfo, ArrayTypeInfo, BaseModel, BooleanTypeInfo, BuiltInAction, Draft, ExtendedModel, Frozen, FrozenCheckMode, FrozenTypeInfo, HookAction, InternalPatchRecorder, LiteralTypeInfo, MobxKeystoneError, Model, ModelAutoTypeCheckingMode, ModelTypeInfo, NumberTypeInfo, ObjectAsMap, ObjectMap, ObjectMapTypeInfo, ObjectTypeInfo, OrTypeInfo, RecordTypeInfo, Ref, RefTypeInfo, RefinementTypeInfo, SandboxManager, StringTypeInfo, TupleTypeInfo, TypeCheckError, TypeInfo, UncheckedTypeInfo, UndoManager, UndoStore, WalkTreeMode, _async, _await, abstractModelClass, actionCallToReduxAction, actionTrackingMiddleware, addActionMiddleware, addHiddenProp, applyAction, applyPatches, applySerializedActionAndSyncNewModelIds, applySerializedActionAndTrackNewModelIds, applySnapshot, arrayAsMap, arrayAsSet, arraySet, asReduxStore, assertCanWrite, assertIsFunction, assertIsModel, assertIsModelClass, assertIsObject, assertIsPrimitive, assertTweakedObject, baseModelPropNames, canWrite, cannotSerialize, checkModelDecoratorArgs, clone, computedWalkTreeAggregate, connectReduxDevTools, createContext, customRef, debugFreeze, decorateWrapMethodOrField, decoratedModel, deepEquals, deleteFromArray, deserializeActionCall, deserializeActionCallArgument, detach, draft, failure, fastGetParent, fastGetParentIncludingDataObjects, fastGetParentPath, fastGetParentPathIncludingDataObjects, fastGetRoot, fastGetRootPath, fastGetRootStore, fastIsModelDataObject, fastIsRootStore, findParent, findParentPath, fromSnapshot, frozen, frozenKey, getActionMiddlewares, getActionProtection, getChildrenObjects, getCurrentActionContext, getGlobalConfig, getModelDataType, getModelRefId, getNodeSandboxManager, getParent, getParentPath, getParentToChildPath, getRefsResolvingTo, getRoot, getRootPath, getRootStore, getSnapshot, getTypeInfo, inDevMode, internalApplyPatches, internalCustomRef, internalPatchRecorder, isArray, isBuiltInAction, isChildOfParent, isFrozenSnapshot, isHookAction, isMap, isModel, isModelAction, isModelAutoTypeCheckingEnabled, isModelClass, isModelDataObject, isModelFlow, isModelSnapshot, isObject, isParentOfChild, isPlainObject, isPrimitive, isRefOfType, isReservedModelKey, isRoot, isRootStore, isSandboxedNode, isSet, isTreeNode, isTweakedObject, jsonPatchToPatch, jsonPointerToPath, lateVal, logWarning, makePropReadonly, model, modelAction, modelClass, modelFlow, modelIdKey, modelInitializedSymbol, modelSnapshotInWithMetadata, modelSnapshotOutWithMetadata, modelTypeKey, noDefaultValue, objectAsMap, objectMap, onActionMiddleware, onChildAttachedTo, onGlobalPatches, onPatches, onSnapshot, patchRecorder, patchToJsonPatch, pathToJsonPointer, prop, propTransform, prop_dateString, prop_dateTimestamp, prop_mapArray, prop_mapObject, prop_setArray, readonlyMiddleware, reduxActionType, registerActionCallArgumentSerializer, registerRootStore, resolvePath, resolvePathCheckingIds, rootRef, runUnprotected, runWithoutSnapshotOrPatches, runningWithoutSnapshotOrPatches, sandbox, serializeActionCall, serializeActionCallArgument, setCurrentActionContext, setGlobalConfig, simplifyActionContext, skipIdChecking, stringAsDate, tProp, tProp_dateString, tProp_dateTimestamp, tProp_mapArray, tProp_mapObject, tProp_setArray, timestampAsDate, toTreeNode, transaction, transactionMiddleware, tryUntweak, tweak, tweakedObjects, typeCheck, types, undoMiddleware, unregisterRootStore, walkTree, withoutUndo };
//# sourceMappingURL=mobxkeystone.esm.js.map
